<template>
    <!-- top -->
    <div id="pt120" class="pt120">
        <div class="sectionInner" v-if="pt125Init.catalogFlg == 1 && !(getLengthObj(pt125Init.productInfo) > 0)">
            <span class="text-danger">
                <!--該当の商品は存在しません。-->
                {{ $t('pt125.labels.catalogItemError') }}
            </span>
        </div>
        <div v-else-if="getLengthObj(pt125Init.productInfo) > 0 && customFlg == 0">
            <breadcrumb :navList="pt125Init.navList[0]"
                        :routerNmItem="site + SiteConstants.PG010MAIN"
                        :decriptPage="$t('pt125.labels.infoProduct')"
                        :itemNm="pt125Init.productInfo.WEB_ITEM_NM">
            </breadcrumb>
            <h2 class="itemTitle">{{ $t('pt125.labels.infoProduct') }}</h2>
            <div class="errorMessage">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="PT125_PART" />
            </div>
            <div class="itemInfo">
                <div class="productTop" style="width:100%">
                    <component v-for="(item, index) in pt125Init.detailList.filter(item => item.WAKU_ID == 1)" :key="index"
                        :is="item.INCLUDE_NM" :ptInitData="pt125Init" :pt125ReqModel="pt125ReqModel" :teikiKounyuu="teikiKounyuu"
                        v-model="pt125ReqModel.buyCount" @stepDown="stepDown" @stepUp="stepUp"
                        :doChkCartAddTxt="doChkCartAddTxt()" @getAnimalQty="getAnimalQty" @getItemQty="getItemQty"
                        @getColSizeChange="getColSize" :isLp="isLp" @pt125doOrder="pt125doOrder"
                        @pt125doKanrenOrder="pt125doKanrenOrder" @pt125favorites="pt125favorites"
                        @pt125removeFavorites="pt125removeFavorites" :htmlText="item.HTML_TXT"
                        @showModal="showModal" @showMatomeDetail="showMatomeDetail" 
                        :allergenStr="allergenStr" :specDispFlg="specDispFlg" @itemStdListDl="itemStdListDl">
                    </component>
                </div>
                <div class="productLeft">
                    <div class="itemDetailInfo " >
                        <div class="itemBuyDetail">
                            <div class="itemGallery">
                                <component v-for="(item, index) in pt125Init.detailList.filter(item => item.WAKU_ID == 2)" :key="index"
                                    :is="item.INCLUDE_NM" :ptInitData="pt125Init" :pt125ReqModel="pt125ReqModel" :teikiKounyuu="teikiKounyuu"
                                    v-model="pt125ReqModel.buyCount" @stepDown="stepDown" @stepUp="stepUp"
                                    :doChkCartAddTxt="doChkCartAddTxt()" @getAnimalQty="getAnimalQty" @getItemQty="getItemQty"
                                    @getColSizeChange="getColSize" :isLp="isLp" @pt125doOrder="pt125doOrder"
                                    @pt125doKanrenOrder="pt125doKanrenOrder" @pt125favorites="pt125favorites"
                                    @pt125removeFavorites="pt125removeFavorites" :htmlText="item.HTML_TXT"
                                    @showModal="showModal" @showMatomeDetail="showMatomeDetail"
                                    :allergenStr="allergenStr" :specDispFlg="specDispFlg" @itemStdListDl="itemStdListDl"
                                    >
                                </component>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="productRight" >
                    <!--レビュー表示 -->
                    <div class="itemDetailInfo " >
                        <div class="itemBuyDetail">
                            <component v-for="(item, index) in pt125Init.detailList.filter(item => item.WAKU_ID == 3)" :key="index"
                                :is="item.INCLUDE_NM" :ptInitData="pt125Init" :pt125ReqModel="pt125ReqModel" :teikiKounyuu="teikiKounyuu"
                                v-model="pt125ReqModel.buyCount" @stepDown="stepDown" @stepUp="stepUp"
                                :doChkCartAddTxt="doChkCartAddTxt()" @getAnimalQty="getAnimalQty" @getItemQty="getItemQty"
                                @getColSizeChange="getColSize" :isLp="isLp" @pt125doOrder="pt125doOrder"
                                @pt125doKanrenOrder="pt125doKanrenOrder" @pt125favorites="pt125favorites"
                                @pt125removeFavorites="pt125removeFavorites" :htmlText="item.HTML_TXT"
                                @showModal="showModal" @showMatomeDetail="showMatomeDetail"
                                :allergenStr="allergenStr" :specDispFlg="specDispFlg" @itemStdListDl="itemStdListDl"
                                >
                            </component>
                        </div>
                    </div>
                </div>
                <div class="productBottom" >
                    <component v-for="(item, index) in pt125Init.detailList.filter(item => item.WAKU_ID == 4)" :key="index"
                        :is="item.INCLUDE_NM" :ptInitData="pt125Init" :pt125ReqModel="pt125ReqModel" :teikiKounyuu="teikiKounyuu"
                        v-model="pt125ReqModel.buyCount" @stepDown="stepDown" @stepUp="stepUp"
                        :doChkCartAddTxt="doChkCartAddTxt()" @getAnimalQty="getAnimalQty" @getItemQty="getItemQty"
                        @getColSizeChange="getColSize" :isLp="isLp" @pt125doOrder="pt125doOrder"
                        @pt125doKanrenOrder="pt125doKanrenOrder" @pt125favorites="pt125favorites"
                        @pt125removeFavorites="pt125removeFavorites" :htmlText="item.HTML_TXT"
                        @showModal="showModal" @showMatomeDetail="showMatomeDetail"
                        :allergenStr="allergenStr" :specDispFlg="specDispFlg" @itemStdListDl="itemStdListDl"
                        >
                    </component>
                    <!-- フォーム一体型対象 -->
                    <br>
                    <div class="formLpContainer" id="pt400" v-if="pt125Init.productInfo.FORM_LP_FLG == 1 && isLp">
                        <!--注文者情報- -->
                        <div class="subTitle" v-if="!pt125Init.loginKbn">
                            <h4>{{ $t("pt125.labels.orderInfo") }}</h4>
                        </div>
                        <div class="customer" v-if="!pt125Init.loginKbn">
                            <!--会員ID pt125Init.loginKbn=true ログイン済み-->
                            <div class="kaiinIdLine" v-if="pt125Init.kokyakuCdHatuFlg == 1">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT ? 'required' : 'verticalAlignTop'"
                                        id="kokyakuCd_lbl">
                                        <span>{{ $t('pt400.labels.kaiinId') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <template>
                                        <input-check type="text" id="kokyakuCd" class="kaiinIdInput code"
                                            name="kokyakuCd" maxlength="15" size="35" v-model="pt125ReqModel.kokyakuCd"
                                            :disabled="pageType != PAGE_INSERT" />
                                        <!--重複チェックボタン-->
                                        <input v-if="pageType == PAGE_INSERT" id="nav-search-button" type="button"
                                            @click="check()" :value="$t('pt400.labels.duplicationcheck')">
                                        <span class="okMessage" v-if="pt125ReqModel.kaiinCheck == 0">{{
                                            $t('pt400.labels.checkConfirm') }}</span>
                                        <span class="err" v-if="pt125ReqModel.kaiinCheck == 1">{{
                                            $t('pt400.labels.checkConfirmErr') }}</span>
                                        <span class="checkNull" v-if="pt125ReqModel.kaiinCheck == 2">{{
                                            $t('pt400.labels.checkCnfirmNull') }}</span>
                                    </template>
                                    <!--項目説明マスタ[24]-->
                                    <div v-if="pageType == PAGE_INSERT" v-html="pt400DescriptionInfo['24']"></div>
                                </div>
                            </div>
                            <div class="mailLine">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT ? 'required' : 'verticalAlignTop'">
                                        <span id="mail_lbl">{{ $t('common.labels.mailAddress') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" class="mailInput mode" id="mail" name="mail" maxlength="80"
                                        size="35" v-model="pt125ReqModel.mail"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <input-check v-if="pageType == PAGE_UPDATE" type="hidden" id="mailOld"
                                        name="mailOld" v-model="pt125ReqModel.mailOld" />
                                    <!--項目説明マスタ[4]-->
                                    <div v-html="pt400DescriptionInfo['4']"></div>
                                </div>
                                <div class="input">
                                    <!--項目説明マスタ[5]-->
                                    <div v-html="pt400DescriptionInfo['5']"></div>
                                    <!--確認メールアドレス入力-->
                                    <input-check type="text" class="mailConfirmInput mode" id="mail_confirm"
                                        name="mail_confirm" maxlength="80" size="35"
                                        v-model="pt125ReqModel.mail_confirm"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                </div>
                            </div>
                            <!-- 新規パスワード-->
                            <div class="NewPassLine" v-if="pt125Init.syouninOption == 0">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT ? 'required' : 'verticalAlignTop'">
                                        <span id="password_lbl">{{ $t('pt400.labels.newPass') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="password" name="password" size="20" class="passwordInput"
                                        maxlength="16" id="password" v-model="pt125ReqModel.password" />
                                    <!--項目説明マスタ[7]-->
                                    <div v-html="pt400DescriptionInfo['7']"></div>
                                </div>
                            </div>
                            <div class="confirmPassLine" v-if="pt125Init.syouninOption == 0">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT ? 'required' : 'verticalAlignTop'">
                                        <span id="passwordSub_lbl">{{ $t('pt400.labels.passConfirm') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <!--項目説明マスタ[8]-->
                                    <div v-html="pt400DescriptionInfo['8']"></div>
                                    <!--確認パスワード入力-->
                                    <input-check type="password" name="passwordSub" size="20" maxlength="16"
                                        class="passwordSubInput" id="passwordSub" v-model="pt125ReqModel.passwordSub" />
                                </div>
                            </div>
                            <!--お名前-->
                            <div class="nameLine">
                                <div class="label">
                                    <label :class="pt125Init.nameEditFlg == 0 ? 'required' : ''">
                                        <span>{{ $t('pt125.labels.names' + common.stringNvl(pt125Init.siteKbn))
                                            }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <label v-if="pt125Init.name2Flg == 1" for="nm1" id="nm1_lbl">{{
                                        $t('pt125.labels.surname' +
                                        common.stringNvl(pt125Init.siteKbn)) }}</label>
                                    <label v-else for="nm" id="nm_lbl">{{ $t('pt400.labels.name1') }}</label>
                                    <!--編集オプション：可の場合-->
                                    <template v-if="pt125Init.nameEditFlg == 0">
                                        <input-check :class="pt125Init.name2Flg == 0 ? 'width150' : ''" class="nm1Input"
                                            type="text" name="nm1" id="nm1" size="25" maxlength="25"
                                            v-model="pt125ReqModel.nm1"
                                            :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    </template>
                                    <!--編集オプション：不可の場合-->
                                    <template v-else>
                                        <input-check :class="pt125Init.name2Flg == 0 ? 'width150' : ''" disabled
                                            class="backgroundColorBrightSilver" type="text" name="nm1" id="nm1"
                                            size="25" maxlength="25" v-model="pt125ReqModel.nm1" />
                                    </template>
                                    <template v-if="pt125Init.name2Flg == 1">
                                        <!--名 名前２利用フラグが利用の場合-->
                                        <label for="nm2" id="nm2_lbl">{{ $t('pt125.labels.name2' +
                                            common.stringNvl(pt125Init.siteKbn)) }}</label>
                                        <!--編集オプション：可の場合-->
                                        <template v-if="pt125Init.nameEditFlg == 0">
                                            <input-check type="text" name="nm2" id="nm2" class="nm2Input" size="25"
                                                maxlength="25" v-model="pt125ReqModel.nm2"
                                                :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                        </template>
                                        <!--編集オプション：不可の場合-->
                                        <template v-else>
                                            <input-check disabled class="backgroundColorBrightSilver" type="text"
                                                name="nm2" id="nm2" size="25" maxlength="25"
                                                v-model="pt125ReqModel.nm2" />
                                        </template>
                                    </template>

                                    <!--名 名前3-->
                                    <label v-if="pt125Init.siteKbn == '4'" for="nm2" id="nm3_lbl">{{
                                        $t('pt125.labels.name3' +
                                        common.stringNvl(pt125Init.siteKbn)) }}</label>
                                    <template v-if="pt125Init.siteKbn == '4'">
                                        <!--編集オプション：可の場合-->
                                        <template v-if="pt125Init.nameEditFlg == 0">
                                            <input-check type="text" name="nm3" id="nm3" class="nm3Input" size="25"
                                                maxlength="25" v-model="pt125ReqModel.nm3"
                                                :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                        </template>
                                        <!--編集オプション：不可の場合-->
                                        <template v-else>
                                            <input-check disabled class="backgroundColorBrightSilver" type="text"
                                                name="nm3" id="nm3" size="25" maxlength="25"
                                                v-model="pt125ReqModel.nm3" />
                                        </template>
                                    </template>

                                    <!--項目説明マスタ[9]-->
                                    <div v-if="pt125Init.nameEditFlg == 0" v-html="pt400DescriptionInfo['9']"></div>
                                </div>
                            </div>
                            <!--カナ-->
                            <div class="kanaLine">
                                <div class="label">
                                    <label
                                        :class="pt125Init.kanaHissuFlg == 0 && pt125Init.nameEditFlg == 0 ? 'optional' : pt125Init.nameEditFlg == 0 ? 'required' : ''">
                                        <span>{{ $t('pt125.labels.name' + common.stringNvl(pt125Init.siteKbn)) }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <label v-if="pt125Init.name2Flg == 1" for="kana1">{{ $t('pt125.labels.surname' +
                                        common.stringNvl(pt125Init.siteKbn)) }}</label>
                                    <label v-else for="kana">{{ $t('pt400.labels.name1') }}</label>
                                    <span id="kana1_lbl" hidden>{{ $t('pt400.labels.nameSurnameKana') }}</span>
                                    <span id="kana_lbl" hidden>{{ $t('pt400.labels.name') }}</span>
                                    <!--編集可-->
                                    <template v-if="pt125Init.nameEditFlg == 0">
                                        <input-check :class="pt125Init.name2Flg == 0 ? 'width150' : ''"
                                            class="kana1Input" type="text" name="kana1" size="25" id="kana1"
                                            maxlength="25" v-model="pt125ReqModel.kana1"
                                            :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    </template>
                                    <!--編集不可-->
                                    <template v-else>
                                        <input-check :class="pt125Init.name2Flg == 0 ? 'width150' : ''" disabled
                                            class="backgroundColorBrightSilver" type="text" name="kana1" size="25"
                                            id="kana1" maxlength="25" v-model="pt125ReqModel.kana1" />
                                    </template>
                                    <template v-if="pt125Init.name2Flg == 1">
                                        <!--名 名前２利用フラグが利用の場合-->
                                        <label for="kana2">{{ $t('pt125.labels.name2' +
                                            common.stringNvl(pt125Init.siteKbn)) }}</label>
                                        <span id="kana2_lbl" hidden>{{ $t('pt400.labels.nameSurFirstNameKana') }}</span>
                                        <!--編集可-->
                                        <template v-if="pt125Init.nameEditFlg == 0">
                                            <input-check type="text" name="kana2" size="25" class="kana2Input"
                                                id="kana2" maxlength="25" v-model="pt125ReqModel.kana2"
                                                :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                        </template>
                                        <!--編集不可-->
                                        <template v-else>
                                            <input-check disabled class="backgroundColorBrightSilver" type="text"
                                                name="kana2" size="25" id="kana2" maxlength="25"
                                                v-model="pt125ReqModel.kana2" />
                                        </template>
                                    </template>

                                    <template v-if="pt125Init.siteKbn == '4'">
                                        <!--名 名前3-->
                                        <label for="kana3">{{ $t('pt125.labels.name3' +
                                            common.stringNvl(pt125Init.siteKbn)) }}</label>
                                        <span id="kana3_lbl" hidden>{{ $t('pt400.labels.name3KanaB') }}</span>
                                        <!--編集可-->
                                        <template v-if="pt125Init.nameEditFlg == 0">
                                            <input-check type="text" name="kana3" size="25" class="kana3Input"
                                                id="kana3" maxlength="25" v-model="pt125ReqModel.kana3"
                                                :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                        </template>
                                        <!--編集不可-->
                                        <template v-else>
                                            <input-check disabled class="backgroundColorBrightSilver" type="text"
                                                name="kana3" size="25" id="kana3" maxlength="25"
                                                v-model="pt125ReqModel.kana3" />
                                        </template>
                                    </template>
                                    <!--項目説明マスタ[10]-->
                                    <div v-if="pt125Init.nameEditFlg == 0" v-html="pt400DescriptionInfo['10']"></div>

                                </div>
                            </div>
                            <!--郵便番号-->
                            <div class="zipLine">
                                <div class="label">
                                    <label class="required" id="zip_lbl">
                                        <span>{{ $t('common.labels.postalCode') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" class="zipInput"
                                        @on-input-change="addrAutoInput('kokyaku')" name="zip" size="8" id="zip"
                                        maxlength="8" v-model="pt125ReqModel.zip"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <span class="btnAddSearch">
                                        <!--住所検索-->
                                        <a @click="addrAutoInput('kokyaku')">{{ $t('common.labels.addressSearch') }}</a>
                                    </span>
                                    <!--項目説明マスタ[11]-->
                                    <div v-html="pt400DescriptionInfo['11']"></div>
                                </div>
                            </div>
                            <!--都道府県 プルダウン設定オプション-->
                            <div class="kenLine" v-if="pt125Init.kenPulldownDispFlg == 1">
                                <div class="label">
                                    <label class="required" id="kenCd_lbl">
                                        <span>{{ $t('common.labels.prefectures') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <select v-model="pt125ReqModel.kenCd" class="kenCdSelect" id="kenCd" name="kenCd"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <option v-for="kenCd in pt125Init.kenCdList" :key="kenCd.KEY"
                                            :value="kenCd.KEY">
                                            {{ kenCd.VALUE }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <input type="hidden" v-model="pt125ReqModel.kenCd" />
                            <!--住所1 -->
                            <div class="addr1Line">
                                <div class="label">
                                    <label class="required" id="addr1_lbl">
                                        <span>{{ $t('pt400.labels.city') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" class="addr1Input" name="addr1" size="72" id="addr1"
                                        maxlength="50" v-model="pt125ReqModel.addr1"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <!--項目説明マスタ[18]-->
                                    <div v-html="pt400DescriptionInfo['12']"></div>
                                </div>
                            </div>
                            <!--住所2 利用オプション-->
                            <div class="addr2Line" v-if="pt125Init.addr2Flg == 1">
                                <div class="label">
                                    <label :class="pt125Init.addr2HissuFlg == 1 ? 'required' : 'optional'"
                                        id="addr2_lbl">
                                        <span>{{ $t('pt400.labels.lessAddress') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" id="addr2" name="addr2" size="72" class="addr2Input"
                                        maxlength="50" v-model="pt125ReqModel.addr2"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <!--項目説明マスタ[20]-->
                                    <div v-html="pt400DescriptionInfo['13']"></div>
                                </div>
                            </div>
                            <!--住所3 利用オプション-->
                            <div class="addr3Line" v-if="pt125Init.addr3Flg == 1">
                                <div class="label">
                                    <label :class="pt125Init.addr3HissuFlg == 1 ? 'required' : 'optional'"
                                        id="addr3_lbl">
                                        <span>{{ $t('common.labels.optionLabel') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" id="addr3" name="addr3" size="72" class="addr3Input"
                                        maxlength="50" v-model="pt125ReqModel.addr3"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <!--項目説明マスタ[22]-->
                                    <div v-html="pt400DescriptionInfo['14']"></div>
                                </div>
                            </div>
                            <!--電話番号 -->
                            <div class="telLine">
                                <div class="label">
                                    <label class="required" id="tel1_lbl">
                                        <span>{{ $t('pt400.labels.phoneNumber') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" id="tel1" name="tel1" class="tel1Input code" size="18"
                                        maxlength="15" v-model="pt125ReqModel.tel1"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <!--項目説明マスタ[15]-->
                                    <div v-html="pt400DescriptionInfo['15']"></div>
                                </div>
                            </div>
                            <!--FAX -->
                            <div class="faxLine">
                                <div class="label">
                                    <label class="optional" id="fax_lbl">
                                        <span>{{ $t('common.labels.fax') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" id="fax" class="faxInput code" name="fax" maxlength="15"
                                        size="18" v-model="pt125ReqModel.fax"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <!--項目説明マスタ[16]-->
                                    <div v-html="pt400DescriptionInfo['16']"></div>
                                </div>
                            </div>

                            <!-- 生年月日-->
                            <div class="birthLine" v-if="pt125Init.siteKbn != '4' && pt125Init.btobFlg == 0">
                                <div class="label">
                                    <label :class="pt125Init.birthdayUpdateFlg == 0 ? 'optional' : ''"
                                        id="birthDay_lbl">
                                        <span>{{ $t('common.labels.birthday') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <template v-if="pt125Init.birthdayUpdateFlg == 0">
                                        <input-check type="text" id="birthDayYYYY" class="birthYearInput numcode"
                                            name="birthDay_YYYY" maxlength="4" size="7"
                                            v-model="pt125ReqModel.birthDayYYYY"
                                            :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                        <span class="birthYear">{{ $t('common.labels.year') }}</span>
                                        <select v-model="pt125ReqModel.birthDayMM" name="birthDay_MM"
                                            class="birthMonthSelect"
                                            :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                            <option></option>
                                            <template v-for="mm in 12">
                                                <option v-if="mm < 10" :key="mm" :value="'0' + mm">{{ '0' + mm }}
                                                </option>
                                                <option v-else :key="mm" :value="mm">{{ mm }}</option>
                                            </template>
                                        </select>
                                        <span class="birthMonth">{{ $t('common.labels.month') }}</span>
                                        <select v-model="pt125ReqModel.birthDayDD" name="birthDay_DD"
                                            class="birthDaySelect"
                                            :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                            <option></option>
                                            <template v-for="dd in 31">
                                                <option v-if="dd < 10" :key="dd" :value="'0' + dd">{{ '0' + dd }}
                                                </option>
                                                <option v-else :key="dd" :value="dd">{{ dd }}</option>
                                            </template>
                                        </select>
                                        <span class="birthDay">{{ $t('common.labels.day') }}</span>
                                        <!--項目説明マスタ[28]-->
                                        <div v-html="pt400DescriptionInfo['17']"></div>
                                    </template>
                                    <template v-else>
                                        {{ pt125ReqModel.birthDayYYYY }}年
                                        {{ pt125ReqModel.birthDayMM }}月
                                        {{ pt125ReqModel.birthDayDD }}日
                                    </template>
                                </div>
                            </div>
                            <!--性別-->
                            <div class="sexLine" v-if="pt125Init.siteKbn != '4' && pt125Init.btobFlg == 0">
                                <div class="label">
                                    <label :class="pt125Init.sexUpdateFlg == 0 ? 'optional' : ''" id="sex_lbl">
                                        <span>{{ $t('common.labels.sex') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <template v-if="pt125Init.sexUpdateFlg == 0">
                                        <div class="sexKbn">
                                            <input type="radio" class="sexKbn1Input" name="sexKbn" value="1"
                                                v-model="pt125ReqModel.sexKbn" id="sexKbn_0"
                                                :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                            <label for="sexKbn_0">{{ $t('common.labels.male') }}</label>
                                            <input type="radio" class="sexKbn2Input" name="sexKbn" value="2"
                                                v-model="pt125ReqModel.sexKbn" id="sexKbn_1"
                                                :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                            <label for="sexKbn_1">{{ $t('common.labels.female') }}</label>
                                            <input type="radio" class="sexKbn3Input" name="sexKbn" value="9"
                                                v-model="pt125ReqModel.sexKbn" id="sexKbn_2"
                                                :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                            <label for="sexKbn_2">{{ $t('common.labels.unspecified') }}</label>
                                            <!--項目説明マスタ[18]-->
                                            <div v-html="pt400DescriptionInfo['18']"></div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-if="pt125ReqModel.sexKbn == '1'">{{ $t('common.labels.male') }}</div>
                                        <div v-else-if="pt125ReqModel.sexKbn == '2'">{{ $t('common.labels.female') }}
                                        </div>
                                        <div v-else>{{ $t('common.labels.unspecified') }}</div>
                                    </template>
                                </div>
                            </div>
                            <!--メルマガ-->
                            <div class="mailMgLine"
                                v-if="pt125Init.siteKbn != '4' && pt125Init.btobFlg == 0 && pt125Init.mailMgDispFlg == 1">
                                <div class="label">
                                    <label class="required" id="mailMg_lbl">
                                        <span>{{ $t('pt400.labels.emailMagazine') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input type="radio" name="newsMailRcvFlg" value="0" class="newsMailRcvFlg0Input"
                                        v-model="pt125ReqModel.newsMailRcvFlg" id="newsMailRcvFlg_1"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="newsMailRcvFlg_1">{{ $t('pt400.labels.doNotWant') }}</label>
                                    <input type="radio" name="newsMailRcvFlg" value="1" class="newsMailRcvFlg1Input"
                                        v-model="pt125ReqModel.newsMailRcvFlg" id="newsMailRcvFlg_0"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="newsMailRcvFlg_0">{{ $t('pt400.labels.toWish') }}</label>
                                    <!--項目説明マスタ[19]-->
                                    <div v-html="pt400DescriptionInfo['19']"></div>
                                </div>
                            </div>
                            <!--DM-->
                            <div class="dmNgFlgLine"
                                v-if="pt125Init.siteKbn != '4' && pt125Init.btobFlg == 0 && pt125Init.mailMgDispFlg == 1">
                                <div class="label">
                                    <label class="required" id="dmNgFlg_lbl">
                                        <span>{{ $t('pt400.labels.dmNgFlg') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input type="radio" name="dmNoFlg" value="0" class="dmNoFlg0Input"
                                        v-model="pt125ReqModel.dmFlg" id="dmNoFlg_1"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="dmNoFlg_1">{{ $t('pt400.labels.doNotWant') }}</label>
                                    <input type="radio" name="dmNoFlg" value="1" class="dmNoFlg1Input"
                                        v-model="pt125ReqModel.dmFlg" id="dmNoFlg_0"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="dmNoFlg_0">{{ $t('pt400.labels.toWish') }}</label>
                                </div>
                            </div>
                            <!-- チラシ -->
                            <div class="flierNgFlgLine" v-if="pt125Init.flierNgFlg == 1">
                                <div class="label">
                                    <label class="required" id="flierNgFlg_lbl">
                                        <span>{{ $t('pt400.labels.flierNgFlg') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input type="radio" name="flierNgFlg" value="0" class="flierNgFlg0Input"
                                        v-model="pt125ReqModel.flierNgFlg" id="flierNgFlg_1"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="flierNgFlg_1">{{ $t('pt400.labels.doNotWant') }}</label>
                                    <input type="radio" name="flierNgFlg" value="1" class="flierNgFlg1Input"
                                        v-model="pt125ReqModel.flierNgFlg" id="flierNgFlg_0"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="flierNgFlg_0">{{ $t('pt400.labels.toWish') }}</label>
                                </div>
                            </div>
                            <!--ニックネーム -->
                            <div class="nicknameLine" v-if="pt125Init.siteKbn != '4'">
                                <div class="label">
                                    <label class="optional" id="nickname_lbl">
                                        <span>{{ $t('pt400.labels.nickname') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" class="nicknameInput" id="nickname" name="nickname"
                                        maxlength="10" size="18" v-model="pt125ReqModel.nickname"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    <!--項目説明マスタ[23]-->
                                    <div v-html="pt400DescriptionInfo['23']"></div>
                                </div>
                            </div>
                            <!--年齢 -->
                            <div class="ageLine" v-if="pt125Init.siteKbn != '4'">
                                <div class="label">
                                    <label class="optional" id="age_lbl">
                                        <span>{{ $t('pt400.labels.age') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input type="radio" class="ageOpenFlg1Input" name="ageOpenFlg" value="1"
                                        v-model="pt125ReqModel.ageOpenFlg" id="age_Koukai_1"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="age_Koukai_1">{{ $t('pt400.labels.koukai1') }}</label>
                                    <input type="radio" class="ageOpenFlg0Input" name="ageOpenFlg" value="0"
                                        v-model="pt125ReqModel.ageOpenFlg" id="age_Koukai_0"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="age_Koukai_0">{{ $t('pt400.labels.koukai2') }}</label>
                                </div>
                            </div>
                            <!--性別 -->
                            <div class="sexDispLine" v-if="pt125Init.siteKbn != '4'">
                                <div class="label">
                                    <label class="optional" id="sexDisp_lbl">
                                        <span>{{ $t('common.labels.sex') }}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input type="radio" class="sexOpenFlg1Input" name="sexOpenFlg" value="1"
                                        v-model="pt125ReqModel.sexOpenFlg" id="sex_Koukai_1"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="sex_Koukai_1">{{ $t('pt400.labels.koukai1') }}</label>
                                    <input type="radio" class="sexOpenFlg0Input" name="sexOpenFlg" value="0"
                                        v-model="pt125ReqModel.sexOpenFlg" id="sex_Koukai_0"
                                        :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                    <label for="sex_Koukai_0">{{ $t('pt400.labels.koukai2') }}</label>
                                </div>
                            </div>
                            <!--顧客グループ
                        <div class="kenLine" v-if="pt125Init.customerGroupFlg == 1 && pt125Init.siteKbn == '4'">
                            <div class="label">
                                <label class="required" id="customerGroup_lbl">
                                    <span>{{pt125Init.analysisTitle}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <select v-model="pt125ReqModel.customerGroup"   class="customerGroup"  id="customerGroup" name="customerGroup" :disabled="pt125Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"> 
                                    <option v-for="cusGroup in pt125Init.customerGroupList" :key="cusGroup.KEY" :value="cusGroup.KEY">{{cusGroup.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        -->
                        </div>

                        <!--配送先情報-->
                        <template>
                            <!--配送先情報- -->
                            <div class="subTitle">
                                <h4>{{ $t("pt125.labels.tdkInfo") }}</h4>
                                <label for="radiogroup_1" class="select_add">
                                    <input type="radio" id="radiogroup_1" name="radioGroup" value="1"
                                        v-model="pt125ReqModel.radioGroup" @click="radioClick" class="margin-left-10px">
                                    <!-- 注文者住所に送る -->
                                    <b> {{ $t("sh030.labels.sendOrdererAddress") }}</b>
                                </label>

                                <label for="radiogroup_3" class="select_add">
                                    <input type="radio" id="radiogroup_3" name="radioGroup" value="2"
                                        v-model="pt125ReqModel.radioGroup" @click="radioClick" class="margin-left-10px">
                                    <!-- 別のお届け先に送る -->
                                    <b> {{ $t("sh030.labels.sendToAnotherAddressee") }}</b>
                                </label>

                            </div>
                            <div class="customer delivery sh030-body-guest-area"
                                v-show="pt125ReqModel.radioGroup == '2'">
                                <!-- お名前※ -->
                                <div class="nameLine">
                                    <div class="label">
                                        <label class="required">
                                            <span>{{ $t('sh030.labels.name') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <!-- 姓 -->
                                        <template v-if="pt125Init.name2Flg == 1">
                                            <label class="sh030-form-column-num02">{{ $t("pt330.labels.surname")
                                                }}</label>
                                        </template>
                                        <template v-else>
                                            <label class="sh030-form-column-num02">{{ $t("pt330.labels.name1")
                                                }}</label>
                                        </template>
                                        <input-check type="text" id="tdkNm1" name="tdkNm1"
                                            v-model="pt125ReqModel.tdkNm1" size="20" maxlength="30" class="multi" />
                                        <!-- 名 -->
                                        <template v-if="pt125Init.name2Flg == 1">
                                            <label class="sh030-form-column-num02">{{ $t("pt330.labels.name2")
                                                }}</label>
                                            <input-check type="text" id="tdkNm2" name="tdkNm2"
                                                v-model="pt125ReqModel.tdkNm2" size="20" maxlength="30" class="multi" />
                                        </template>
                                        <!--項目説明-->
                                        <div v-html="pt400DescriptionInfo['9']"></div>
                                    </div>
                                </div>
                                <!-- フリガナ -->
                                <div class="kanaLine">
                                    <div class="label">
                                        <label class="optional">
                                            <span>{{ $t("sh030.labels.name") }}（{{ $t("sh030.labels.nameKana")
                                                }}）</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <!-- 姓 -->
                                        <template v-if="pt125Init.name2Flg == 1">
                                            <label class="sh030-form-column-num02">{{ $t("pt330.labels.surname")
                                                }}</label>
                                        </template>
                                        <template v-else>
                                            <label class="sh030-form-column-num02">{{ $t("pt330.labels.name1")
                                                }}</label>
                                        </template>
                                        <input-check type="text" id="tdkKana1" name="tdkKana1"
                                            v-model="pt125ReqModel.tdkKana1" size="20" maxlength="30" class="multi" />
                                        <!-- 名 -->
                                        <template v-if="pt125Init.name2Flg == 1">
                                            <label class="sh030-form-column-num02">{{ $t("pt330.labels.name2")
                                                }}</label>
                                            <input-check type="text" id="tdkKana2" name="tdkKana2"
                                                v-model="pt125ReqModel.tdkKana2" size="20" maxlength="30"
                                                class="multi" />
                                        </template>
                                        <!--項目説明-->
                                        <div v-html="pt400DescriptionInfo['10']"></div>
                                    </div>
                                </div>

                                <!-- 郵便番号 -->
                                <div class="zipLine">
                                    <div class="label">
                                        <label class="required" id="tdkZip_lbl">
                                            <span>{{ $t('common.labels.postalCode') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <input-check type="text" id="tdkZip" name="tdkZip"
                                            @on-input-change="addrAutoInput('tdk')" v-model="pt125ReqModel.tdkZip"
                                            size="13" maxlength="30" class="zip form-control-sm" />
                                        <!--住所検索-->
                                        <span class="btnAddSearch">
                                            <!--住所検索-->
                                            <a @click="addrAutoInput('tdk')">{{ $t('common.labels.addressSearch') }}</a>
                                        </span>
                                        <!--項目説明マスタ[11]-->
                                        <div v-html="pt400DescriptionInfo['11']"></div>
                                    </div>
                                </div>

                                <!-- 都道府県CD -->
                                <div class="kenLine" v-if="pt125Init.kenPulldownDispFlg == 1">
                                    <div class="label">
                                        <label class="required" id="kenCd_lbl">
                                            <span>{{ $t('common.labels.prefectures') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <select v-model="pt125ReqModel.tdkKenCd" id="tdkKenCd">
                                            <option v-for="ken in pt125Init.kenCdList" :key="ken.KEY" :value="ken.KEY"
                                                :selected="ken.KEY == pt125ReqModel.tdkKenCd">{{ ken.VALUE }}</option>
                                        </select>
                                    </div>
                                    <div v-html="descriptionInfo[6]"></div>
                                </div>

                                <!-- 住所（市区郡町村） -->
                                <div class="addr1Line">
                                    <div class="label">
                                        <label class="required" id="addr1_lbl">
                                            <span>{{ $t('sh030.labels.cityAndCounty') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <input-check id="tdkAddr1" type="text" name="tdkAddr1" size="50"
                                            v-model="pt125ReqModel.tdkAddr1" maxlength="50" />
                                        <br />
                                        <template v-if="pt125Init.kenPulldownDispFlg == 1">
                                            <div v-html="descriptionInfo[7]"></div>
                                        </template>
                                        <template v-else>
                                            <div v-html="descriptionInfo[8]"></div>
                                        </template>
                                        <!--項目説明-->
                                        <div v-html="pt400DescriptionInfo['12']"></div>
                                    </div>
                                </div>

                                <!-- 住所（番地以下） -->
                                <div class="addr2Line" v-if="pt125Init.addr2Flg == 1">
                                    <div class="label">
                                        <label :class="pt125Init.addr2HissuFlg == 1 ? 'required' : 'optional'"
                                            id="addr2_lbl">
                                            <span>{{ $t('sh030.labels.streetAddress') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <input id="tdkAddr2" type="text" name="tdkAddr2" size="50"
                                            v-model="pt125ReqModel.tdkAddr2" maxlength="50" />
                                        <!--項目説明-->
                                        <div v-html="pt400DescriptionInfo['13']"></div>
                                    </div>
                                </div>

                                <!-- 住所（マンション名・会社名等） -->
                                <div class="addr3Line" v-if="pt125Init.addr3Flg == 1">
                                    <div class="label">
                                        <label :class="pt125Init.addr3HissuFlg == 1 ? 'required' : 'optional'"
                                            id="addr3_lbl">
                                            <span>{{ $t('sh030.labels.apartmentName') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <input id="tdkAddr3" type="text" name="tdkAddr3" size="50"
                                            v-model="pt125ReqModel.tdkAddr3" MaxLength="50" />
                                        <br />
                                        <!--項目説明-->
                                        <div v-html="pt400DescriptionInfo['14']"></div>
                                    </div>
                                </div>

                                <!-- メールアドレス -->
                                <div class="mailLine">
                                    <div class="label">
                                        <label class="required" id="tdkMail1_lbl">
                                            <span>{{ $t('sh060.labels.mailAddress') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <input-check type="text" id="tdkMail1" name="tdkMail1"
                                            v-model="pt125ReqModel.tdkMail1" size="60" maxlength="80" class="mail" />
                                        <br>
                                        <!--項目説明-->
                                        <div v-html="pt400DescriptionInfo['4']"></div>
                                    </div>
                                </div>

                                <!-- 電話番号※ -->
                                <div class="telLine">
                                    <div class="label">
                                        <label class="required" id="tdkTel_lbl">
                                            <span>{{ $t('pt125.labels.phoneNumber') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <input-check type="text" id="tdkTel" name="tdkTel"
                                            v-model="pt125ReqModel.tdkTel" size="20" maxlength="14" class="tel" />
                                        <!--項目説明-->
                                        <div v-html="pt400DescriptionInfo['15']"></div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <br>
                        <!--決済情報-->
                        <template>
                            <!--決済情報- -->
                            <div class="subTitle">
                                <h4>{{ $t("pt125.labels.kessaiInfo") }}</h4>
                            </div>
                            <div class="sh050PayDetail">

                                <!--<h4>{{$t("sh050.labels.choosePaymentMethod")}}</h4> お支払い方法の選択 -->
                                <p class="mb32">{{ $t("sh050.labels.preferredPaymentMethod") }}</p>
                                <div class="customer sh050PaytblPerson sh050Paytblmb32">
                                    <!-- 支払い方法loop -->
                                    <template v-for="(obj, index) in sh050SiharaiHohoKbnList">
                                        <template>
                                            <!-- 代引き、が使えないパターン： 別届け先直送の場合  
                                            <template v-if="sh050RespModel_daiNgFlg == 1">
                                                -- 代引きの決済CDの表示をしない --
                                                <template v-if="obj.KEY == '2'"></template>
<template v-else>
                                                    <div :key="index">
                                                        <div  class="label">
                                                            <div  class="optional">
                                                                <input type="radio" :value="obj.KEY" name="siharai_hoho_kbn"
                                                                    :id="'_siharai_hoho_kbn_' + obj.KEY" :checked="obj.KEY == siharaiHohoKbn ? 'checked':''" @click="selectSiharaiHoho(obj.KEY)"/>
                                                                <label :for="'_siharai_hoho_kbn_' + obj.KEY" onClick="">
                                                                    <strong>{{obj.VALUE}}</strong>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="input">
                                                            --決済方法のメッセージ --
                                                            <span v-html="sh050DescriptionInfo[obj.KEY]"></span>
                                                        </div>
                                                    </div>
                                                </template>
</template>
-->
                                            <!-- 無条件で表示 v-else-->
                                            <template>
                                                <div class="nameLine" :key="index">
                                                    <div class="label">
                                                        <div class="optional">
                                                            <input type="radio" :value="obj.KEY" name="siharai_hoho_kbn"
                                                                class="margin-left-10px"
                                                                :id="'_siharai_hoho_kbn_' + obj.KEY"
                                                                :checked="obj.KEY == siharaiHohoKbn ? 'checked' : ''"
                                                                @click="selectSiharaiHoho(obj.KEY)" />
                                                            <label :for="'_siharai_hoho_kbn_' + obj.KEY" onClick="">
                                                                <strong>{{ obj.VALUE }}</strong>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="input">
                                                        <!--決済方法のメッセージ -->
                                                        <span v-html="sh050DescriptionInfo[obj.KEY]"
                                                            v-if="obj.KEY !== '1'"></span>
                                                        <!-- お支払方法 クレジットカード KessaiCd='1' -->
                                                        <div class="settingMainSh060OneColumn" v-if="obj.KEY == '1'">
                                                            <div class="personal mb64"
                                                                :summary="$t('sh060.labels.newPayment')">
                                                                <!--クレジットカード情報 -->
                                                                <template v-if="pt125Init.teikiFlg == '0'">
                                                                    <template
                                                                        v-if="common.stringNvl(pt125Init.cardNoDisp) != ''">
                                                                        <input type="radio" name="card_flg" value="1"
                                                                            v-model="pt125ReqModel.cardFlg"
                                                                            id="card_flg1"
                                                                            @click="showCloseNewCardArea(0)" />
                                                                        <label for="card_flg1">
                                                                            <!-- 前回と同じカードを使う -->
                                                                            {{
                                                                            $t('sh060.labels.usethesamecardaslasttime')
                                                                            }}
                                                                        </label>
                                                                        <div v-if="showNowCardFlg === 0"
                                                                            class="sh060tbl">
                                                                            <div>
                                                                                <!-- カード番号 -->
                                                                                <div>
                                                                                    <label
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{ $t('sh060.labels.cardnumber')
                                                                                        }}
                                                                                    </label>
                                                                                </div>
                                                                                <div>
                                                                                    {{ pt125Init.cardNoDisp }}
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <!-- 有効期限 -->
                                                                                <div>
                                                                                    <label
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.expirationdate')
                                                                                        }}
                                                                                    </label>
                                                                                </div>
                                                                                <div>
                                                                                    {{ pt125Init.cardLimit }}
                                                                                </div>
                                                                            </div>
                                                                            <div v-if="pt125Init.securityCodeUseFlg">
                                                                                <div>
                                                                                    <!-- セキュリティコード -->
                                                                                    <label
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.securitycode')
                                                                                        }}
                                                                                    </label>
                                                                                </div>
                                                                                <div>
                                                                                    <input-check type="text" size="4"
                                                                                        maxlength="4"
                                                                                        name="cardSecurity"
                                                                                        class="numcode"
                                                                                        id="cardSecurity"
                                                                                        v-model="pt125ReqModel.cardSecurity"
                                                                                        autocomplete="off" />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <!-- お支払方法 -->
                                                                                <div>
                                                                                    <label
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.paymentMethod')
                                                                                        }}
                                                                                    </label>
                                                                                </div>
                                                                                <div>
                                                                                    <select
                                                                                        v-model="pt125ReqModel.lastCardPayCnt"
                                                                                        name="lastCardPayCnt"
                                                                                        id="lastCardPayCnt"
                                                                                        @change="chgCardPayCnt">
                                                                                        <option
                                                                                            v-for="payCnt in pt125Init.payCntList"
                                                                                            :key="payCnt.KEY"
                                                                                            :value="payCnt.KEY">
                                                                                            {{ payCnt.VALUE }}</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                v-if="isBunkatu(pt125ReqModel.lastCardPayCnt)">
                                                                                <!-- お支払回数 -->
                                                                                <div>
                                                                                    <label
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.paymentfrequency')
                                                                                        }}
                                                                                    </label>
                                                                                </div>
                                                                                <div>
                                                                                    <select
                                                                                        v-model="pt125ReqModel.lastBunkatuKaisu"
                                                                                        name="lastBunkatuKaisu"
                                                                                        id="lastBunkatuKaisu">
                                                                                        <option
                                                                                            v-for="kaisu in pt125Init.bunkatuKaisuList"
                                                                                            :key="kaisu.KEY"
                                                                                            :value="kaisu.KEY">
                                                                                            {{ kaisu.VALUE }}</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <hr>
                                                                        <input type="radio" name="card_flg"
                                                                            v-model="pt125ReqModel.cardFlg" value="0"
                                                                            id="card_flg0"
                                                                            @click="showCloseNewCardArea(1)" />
                                                                        <label for="card_flg0">
                                                                            <!-- 新しいカードを使う -->
                                                                            {{ $t('sh060.labels.usenewcard') }}
                                                                        </label>
                                                                    </template>
                                                                    <template v-if="showNowCardFlg === 1">
                                                                        <span v-html="sh060DescriptionInfo[5]"></span>
                                                                        <template
                                                                            v-if="pt125Init.kessaiCompKbn == 'JCS' || pt125Init.kessaiCompKbn == 'GMO' || pt125Init.kessaiCompKbn == 'SGP'">
                                                                            <iframe name="dummyframe" id="dummyframe"
                                                                                ref="dummyframe"
                                                                                style="display:none"></iframe>
                                                                            <form :action="pt125Init.serverUrl"
                                                                                METHOD="POST" ref="form" name="form"
                                                                                ENCTYPE="application/x-www-form-urlencode"
                                                                                target="dummyframe">

                                                                                <input type="hidden" name="tourokuKbn"
                                                                                    :value="tourokuKbn"> <!-- 登録区分 -->
                                                                                <input type="hidden" name="merchantId"
                                                                                    :value="pt125Init.merchantId">
                                                                                <!-- 加盟店ID -->
                                                                                <input v-if="pt125ReqModel.cardSaveFlg"
                                                                                    type="hidden" name="dbKey1"
                                                                                    :value="pt125Init.newDbKey">
                                                                                <!-- 加盟店ID -->
                                                                                <input type="hidden" name="amount"
                                                                                    :value="pt125Init.seikyuKin">
                                                                                <!-- オーソリ金額 -->
                                                                                <input type="hidden" name="backUrl"
                                                                                    :value="pt125Init.backUrl">
                                                                                <!-- 戻りURL -->
                                                                                <input type="hidden" name="orderNum"
                                                                                    :value="pt125Init.orderNum">
                                                                                <!-- 注文番号 -->
                                                                                <input type="hidden" name="cardKbn"
                                                                                    :value="pt125Init.cardKbn">
                                                                                <!-- カード情報返却区分 -->
                                                                                <input type="hidden"
                                                                                    name="optionalAreaName1"
                                                                                    value="coNo">
                                                                                <input type="hidden"
                                                                                    name="optionalAreaValue1"
                                                                                    :value="pt125Init.coNo">
                                                                                <!-- 会社NO -->
                                                                                <input type="hidden"
                                                                                    name="optionalAreaName2"
                                                                                    value="kessaiCd">
                                                                                <input type="hidden"
                                                                                    name="optionalAreaValue2"
                                                                                    :value="pt125Init.kessaiCd">
                                                                                <!-- 決済方法CD -->
                                                                                <input type="hidden" name="shopID"
                                                                                    :value="pt125Init.bgShopId">
                                                                                <!-- blueGate Shop ID -->
                                                                                <input type="hidden" name="paymentMode"
                                                                                    :value="pt125ReqModel.cardPayCnt">
                                                                                <!-- 支払区分コード -->
                                                                                <input
                                                                                    v-if="isBunkatu(pt125ReqModel.cardPayCnt)"
                                                                                    type="hidden" name="paymentCount"
                                                                                    :value="pt125ReqModel.bunkatuKaisu">
                                                                                <!-- 分割回数 -->
                                                                                <input type="hidden" name="msgDigest"
                                                                                    :value="msgDigest">
                                                                                <!-- 注文受付メッセージダイジェスト -->

                                                                                <input type="hidden" name="pan"
                                                                                    :value="pan">
                                                                                <input type="hidden" name="expiryDate"
                                                                                    :value="expiryDate">
                                                                                <input
                                                                                    v-if="pt125Init.securityCodeUseFlg"
                                                                                    type="hidden" name="securityCode"
                                                                                    :value="pt125ReqModel.securityCode">
                                                                            </form>

                                                                            <!--JCS 3D-->
                                                                            <template
                                                                                v-if="pt125Init.kessaiCompKbn == 'JCS' && pt125Init.security3DFlg == '1'">
                                                                                <form :action="pt125Init.serverUrl"
                                                                                    METHOD="POST"
                                                                                    ENCTYPE="application/x-www-form-urlencode"
                                                                                    ref="formJasTaking"
                                                                                    name="formJasTaking" target="_self">

                                                                                    <input type="hidden"
                                                                                        name="tourokuKbn"
                                                                                        v-model="jasNewCardTaking.tourokuKbn">
                                                                                    <!-- 登録区分 -->
                                                                                    <input type="hidden"
                                                                                        name="merchantId"
                                                                                        v-model="jasNewCardTaking.merchantId">
                                                                                    <!-- 加盟店ID -->
                                                                                    <input type="hidden" name="senddate"
                                                                                        v-model="jasNewCardTaking.senddate">
                                                                                    <!-- 電文送信日 -->
                                                                                    <input type="hidden" name="sendtime"
                                                                                        v-model="jasNewCardTaking.sendtime">
                                                                                    <!-- 電文送信時間 -->
                                                                                    <input type="hidden" name="pan"
                                                                                        v-model="jasNewCardTaking.pan">
                                                                                    <!-- カード番号 -->
                                                                                    <input type="hidden"
                                                                                        name="expiryDate"
                                                                                        v-model="jasNewCardTaking.expiryDate">
                                                                                    <!-- 有効期限 -->
                                                                                    <input type="hidden" name="cardKbn"
                                                                                        v-model="jasNewCardTaking.cardKbn">
                                                                                    <!-- カード情報返却区分 -->
                                                                                    <input type="hidden" name="backUrl"
                                                                                        v-model="jasNewCardTaking.backUrl">
                                                                                    <!-- 戻りURL -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName1"
                                                                                        v-model="jasNewCardTaking.optionalAreaName1">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue1"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue1">
                                                                                    <!-- 会社NO -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName2"
                                                                                        v-model="jasNewCardTaking.optionalAreaName2">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue2"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue2">
                                                                                    <!-- 決済方法CD -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName3"
                                                                                        v-model="jasNewCardTaking.optionalAreaName3">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue3"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue3">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName4"
                                                                                        v-model="jasNewCardTaking.optionalAreaName4">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue4"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue4">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName5"
                                                                                        v-model="jasNewCardTaking.optionalAreaName5">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue5"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue5">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName6"
                                                                                        v-model="jasNewCardTaking.optionalAreaName6">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue6"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue6">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName7"
                                                                                        v-model="jasNewCardTaking.optionalAreaName7">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue7"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue7">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName8"
                                                                                        v-model="jasNewCardTaking.optionalAreaName8">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue8"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue8">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName9"
                                                                                        v-model="jasNewCardTaking.optionalAreaName9">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue9"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue9">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName10"
                                                                                        v-model="jasNewCardTaking.optionalAreaName10">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue10"
                                                                                        v-model="jasNewCardTaking.optionalAreaValue10">

                                                                                    <input type="hidden" name="shopID"
                                                                                        v-model="jasNewCardTaking.shopID">
                                                                                    <!-- blueGate Shop ID -->
                                                                                    <input type="hidden"
                                                                                        name="msgDigest"
                                                                                        v-model="jasNewCardTaking.msgDigest">
                                                                                    <!-- 注文受付メッセージダイジェスト -->
                                                                                </form>

                                                                                <form :action="pt125Init.serverUrl"
                                                                                    METHOD="POST"
                                                                                    ENCTYPE="application/x-www-form-urlencode"
                                                                                    ref="formJas3D" name="formJas3D"
                                                                                    target="_self">

                                                                                    <input type="hidden"
                                                                                        name="tourokuKbn"
                                                                                        v-model="jasNewCard3D.tourokuKbn">
                                                                                    <!-- 登録区分 -->
                                                                                    <input type="hidden"
                                                                                        name="merchantId"
                                                                                        v-model="jasNewCard3D.merchantId">
                                                                                    <!-- 加盟店ID -->
                                                                                    <input type="hidden"
                                                                                        name="cardPassword"
                                                                                        v-model="jasNewCard3D.cardPassword"
                                                                                        v-if="jcsMemberType == '0' || jcsMemberType == '1'">
                                                                                    <!-- カード情報パスワード  -->
                                                                                    <input type="hidden" name="dbKey1"
                                                                                        v-model="jasNewCard3D.dbKey1"
                                                                                        v-if="jcsMemberType == '2'">
                                                                                    <!-- DB キー -->
                                                                                    <input type="hidden" name="orderNum"
                                                                                        v-model="jasNewCard3D.orderNum">
                                                                                    <!-- 注文番号 -->
                                                                                    <input type="hidden" name="amount"
                                                                                        v-model="jasNewCard3D.amount">
                                                                                    <!-- 売上金額 -->
                                                                                    <input type="hidden"
                                                                                        name="taxAndDeliCharge"
                                                                                        v-model="jasNewCard3D.taxAndDeliCharge">
                                                                                    <!-- 税送料  -->
                                                                                    <input type="hidden" name="backUrl"
                                                                                        v-model="jasNewCard3D.backUrl">
                                                                                    <!-- 戻りURL -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName1"
                                                                                        v-model="jasNewCard3D.optionalAreaName1">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue1"
                                                                                        v-model="jasNewCard3D.optionalAreaValue1">
                                                                                    <!-- 会社NO -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName2"
                                                                                        v-model="jasNewCard3D.optionalAreaName2">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue2"
                                                                                        v-model="jasNewCard3D.optionalAreaValue2">
                                                                                    <!-- 決済方法CD -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName3"
                                                                                        v-model="jasNewCard3D.optionalAreaName3">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue3"
                                                                                        v-model="jasNewCard3D.optionalAreaValue3">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName4"
                                                                                        v-model="jasNewCard3D.optionalAreaName4">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue4"
                                                                                        v-model="jasNewCard3D.optionalAreaValue4">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName5"
                                                                                        v-model="jasNewCard3D.optionalAreaName5">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue5"
                                                                                        v-model="jasNewCard3D.optionalAreaValue5">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName6"
                                                                                        v-model="jasNewCard3D.optionalAreaName6">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue6"
                                                                                        v-model="jasNewCard3D.optionalAreaValue6">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName7"
                                                                                        v-model="jasNewCard3D.optionalAreaName7">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue7"
                                                                                        v-model="jasNewCard3D.optionalAreaValue7">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName8"
                                                                                        v-model="jasNewCard3D.optionalAreaName8">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue8"
                                                                                        v-model="jasNewCard3D.optionalAreaValue8">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName9"
                                                                                        v-model="jasNewCard3D.optionalAreaName9">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue9"
                                                                                        v-model="jasNewCard3D.optionalAreaValue9">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName10"
                                                                                        v-model="jasNewCard3D.optionalAreaName10">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue10"
                                                                                        v-model="jasNewCard3D.optionalAreaValue10">
                                                                                    <input type="hidden" name="shopID"
                                                                                        v-model="jasNewCard3D.shopID"
                                                                                        v-if="jcsMemberType == '2'">
                                                                                    <!-- BlueGate ショップ ID -->
                                                                                    <!--<input type="hidden" name="accountMethod"      v-model="jasNewCard3D.accountMethod" v-if="jcsMemberType == '2'"> -->
                                                                                    <!-- 決済手段登録番号 -->

                                                                                    <input type="hidden"
                                                                                        name="authenticationInd"
                                                                                        v-model="jasNewCard3D.authenticationInd">
                                                                                    <input type="hidden"
                                                                                        name="threeDSReqAuthMethod"
                                                                                        v-model="jasNewCard3D.threeDSReqAuthMethod">
                                                                                    <input type="hidden"
                                                                                        name="threeDSReqAuthTimestamp"
                                                                                        v-model="jasNewCard3D.threeDSReqAuthTimestamp">
                                                                                    <input type="hidden"
                                                                                        name="challengeInd"
                                                                                        v-model="jasNewCard3D.challengeInd">
                                                                                    <input type="hidden" name="acctType"
                                                                                        v-model="jasNewCard3D.acctType">
                                                                                    <input type="hidden"
                                                                                        name="merchantName"
                                                                                        v-model="jasNewCard3D.merchantName">
                                                                                    <input type="hidden"
                                                                                        name="chAccAgeInd"
                                                                                        v-model="jasNewCard3D.chAccAgeInd">
                                                                                    <input type="hidden"
                                                                                        name="chAccChange"
                                                                                        v-model="jasNewCard3D.chAccChange">
                                                                                    <input type="hidden"
                                                                                        name="chAccChangeInd"
                                                                                        v-model="jasNewCard3D.chAccChangeInd">
                                                                                    <input type="hidden"
                                                                                        name="chAccDate"
                                                                                        v-model="jasNewCard3D.chAccDate">
                                                                                    <input type="hidden"
                                                                                        name="chAccPwChange"
                                                                                        v-model="jasNewCard3D.chAccPwChange">
                                                                                    <input type="hidden"
                                                                                        name="chAccPwChangeInd"
                                                                                        v-model="jasNewCard3D.chAccPwChangeInd">
                                                                                    <input type="hidden"
                                                                                        name="nbPurchaseAccount"
                                                                                        v-model="jasNewCard3D.nbPurchaseAccount">
                                                                                    <input type="hidden"
                                                                                        name="provisionAttemptsDay"
                                                                                        v-model="jasNewCard3D.provisionAttemptsDay">
                                                                                    <input type="hidden"
                                                                                        name="txnActivityDay"
                                                                                        v-model="jasNewCard3D.txnActivityDay">
                                                                                    <input type="hidden"
                                                                                        name="txnActivityYear"
                                                                                        v-model="jasNewCard3D.txnActivityYear">
                                                                                    <input type="hidden"
                                                                                        name="paymentAccAge"
                                                                                        v-model="jasNewCard3D.paymentAccAge">
                                                                                    <input type="hidden"
                                                                                        name="paymentAccInd"
                                                                                        v-model="jasNewCard3D.paymentAccInd">
                                                                                    <input type="hidden"
                                                                                        name="shipAddressUsage"
                                                                                        v-model="jasNewCard3D.shipAddressUsage">
                                                                                    <input type="hidden"
                                                                                        name="shipAddressUsageInd"
                                                                                        v-model="jasNewCard3D.shipAddressUsageInd">
                                                                                    <input type="hidden"
                                                                                        name="shipNameIndicator"
                                                                                        v-model="jasNewCard3D.shipNameIndicator">
                                                                                    <input type="hidden"
                                                                                        name="suspiciousAccActivity"
                                                                                        v-model="jasNewCard3D.suspiciousAccActivity">
                                                                                    <input type="hidden"
                                                                                        name="addrMatch"
                                                                                        v-model="jasNewCard3D.addrMatch">
                                                                                    <input type="hidden"
                                                                                        name="billAddrCity"
                                                                                        v-model="jasNewCard3D.billAddrCity">
                                                                                    <input type="hidden"
                                                                                        name="billAddrCountry"
                                                                                        v-model="jasNewCard3D.billAddrCountry">
                                                                                    <input type="hidden"
                                                                                        name="billAddrLine1"
                                                                                        v-model="jasNewCard3D.billAddrLine1">
                                                                                    <input type="hidden"
                                                                                        name="billAddrLine2"
                                                                                        v-model="jasNewCard3D.billAddrLine2">
                                                                                    <input type="hidden"
                                                                                        name="billAddrLine3"
                                                                                        v-model="jasNewCard3D.billAddrLine3">
                                                                                    <input type="hidden"
                                                                                        name="billAddrPostCode"
                                                                                        v-model="jasNewCard3D.billAddrPostCode">
                                                                                    <input type="hidden"
                                                                                        name="billAddrState"
                                                                                        v-model="jasNewCard3D.billAddrState">
                                                                                    <input type="hidden" name="email"
                                                                                        v-model="jasNewCard3D.email">
                                                                                    <input type="hidden"
                                                                                        name="homePhoneCc"
                                                                                        v-model="jasNewCard3D.homePhoneCc">
                                                                                    <input type="hidden"
                                                                                        name="homePhoneSubscriber"
                                                                                        v-model="jasNewCard3D.homePhoneSubscriber">
                                                                                    <input type="hidden"
                                                                                        name="mobilePhoneCc"
                                                                                        v-model="jasNewCard3D.mobilePhoneCc">
                                                                                    <input type="hidden"
                                                                                        name="mobilePhoneSubscriber"
                                                                                        v-model="jasNewCard3D.mobilePhoneSubscriber">
                                                                                    <input type="hidden"
                                                                                        name="cardholderName"
                                                                                        v-model="jasNewCard3D.cardholderName">
                                                                                    <input type="hidden"
                                                                                        name="shipAddrCity"
                                                                                        v-model="jasNewCard3D.shipAddrCity">
                                                                                    <input type="hidden"
                                                                                        name="shipAddrCountry"
                                                                                        v-model="jasNewCard3D.shipAddrCountry">
                                                                                    <input type="hidden"
                                                                                        name="shipAddrLine1"
                                                                                        v-model="jasNewCard3D.shipAddrLine1">
                                                                                    <input type="hidden"
                                                                                        name="shipAddrLine2"
                                                                                        v-model="jasNewCard3D.shipAddrLine2">
                                                                                    <input type="hidden"
                                                                                        name="shipAddrLine3"
                                                                                        v-model="jasNewCard3D.shipAddrLine3">
                                                                                    <input type="hidden"
                                                                                        name="shipAddrPostCode"
                                                                                        v-model="jasNewCard3D.shipAddrPostCode">
                                                                                    <input type="hidden"
                                                                                        name="shipAddrState"
                                                                                        v-model="jasNewCard3D.shipAddrState">
                                                                                    <input type="hidden"
                                                                                        name="workPhoneCc"
                                                                                        v-model="jasNewCard3D.workPhoneCc">
                                                                                    <input type="hidden"
                                                                                        name="workPhoneSubscriber"
                                                                                        v-model="jasNewCard3D.workPhoneSubscriber">
                                                                                    <input type="hidden"
                                                                                        name="purchaseInstalData"
                                                                                        v-model="jasNewCard3D.purchaseInstalData">
                                                                                    <input type="hidden"
                                                                                        name="deliveryEmailAddress"
                                                                                        v-model="jasNewCard3D.deliveryEmailAddress">
                                                                                    <input type="hidden"
                                                                                        name="deliveryTimeframe"
                                                                                        v-model="jasNewCard3D.deliveryTimeframe">
                                                                                    <input type="hidden"
                                                                                        name="giftCardAmount"
                                                                                        v-model="jasNewCard3D.giftCardAmount">
                                                                                    <input type="hidden"
                                                                                        name="giftCardCount"
                                                                                        v-model="jasNewCard3D.giftCardCount">
                                                                                    <input type="hidden"
                                                                                        name="giftCardCurr"
                                                                                        v-model="jasNewCard3D.giftCardCurr">
                                                                                    <input type="hidden"
                                                                                        name="preOrderDate"
                                                                                        v-model="jasNewCard3D.preOrderDate">
                                                                                    <input type="hidden"
                                                                                        name="preOrderPurchaseInd"
                                                                                        v-model="jasNewCard3D.preOrderPurchaseInd">
                                                                                    <input type="hidden"
                                                                                        name="reorderItemsInd"
                                                                                        v-model="jasNewCard3D.reorderItemsInd">
                                                                                    <input type="hidden"
                                                                                        name="shipIndicator"
                                                                                        v-model="jasNewCard3D.shipIndicator">
                                                                                    <input type="hidden"
                                                                                        name="messageCategory"
                                                                                        v-model="jasNewCard3D.messageCategory">
                                                                                    <input type="hidden"
                                                                                        name="recurringExpiry"
                                                                                        v-model="jasNewCard3D.recurringExpiry">
                                                                                    <input type="hidden"
                                                                                        name="recurringFrequency"
                                                                                        v-model="jasNewCard3D.recurringFrequency">
                                                                                    <input type="hidden"
                                                                                        name="transType"
                                                                                        v-model="jasNewCard3D.transType">
                                                                                    <input type="hidden"
                                                                                        name="priorTransID"
                                                                                        v-model="jasNewCard3D.priorTransID">

                                                                                    <input type="hidden"
                                                                                        name="msgDigest"
                                                                                        v-model="jasNewCard3D.msgDigest">
                                                                                    <!-- 注文受付メッセージダイジェスト -->
                                                                                </form>

                                                                                <form :action="pt125Init.serverUrl"
                                                                                    METHOD="POST"
                                                                                    ENCTYPE="application/x-www-form-urlencode"
                                                                                    ref="formJasOsori"
                                                                                    name="formJasOsori" target="_self">

                                                                                    <input type="hidden"
                                                                                        name="tourokuKbn"
                                                                                        v-model="jasNewCardOsori.tourokuKbn">
                                                                                    <!-- 登録区分 -->
                                                                                    <input type="hidden"
                                                                                        name="merchantId"
                                                                                        v-model="jasNewCardOsori.merchantId">
                                                                                    <!-- 加盟店 ID -->
                                                                                    <input type="hidden" name="dbKey1"
                                                                                        v-model="jasNewCardOsori.dbKey1"
                                                                                        v-if="jcsMemberType == '1' || jcsMemberType == '2'">
                                                                                    <!-- DB キー -->
                                                                                    <input type="hidden" name="amount"
                                                                                        v-model="jasNewCardOsori.amount">
                                                                                    <!-- オーソリ金額 -->
                                                                                    <!--<input type="hidden" name="taxAndDeliCharge"    v-model="jasNewCardOsori.taxAndDeliCharge"> -->
                                                                                    <!-- 税送料 -->
                                                                                    <input type="hidden" name="backUrl"
                                                                                        v-model="jasNewCardOsori.backUrl">
                                                                                    <!-- 戻り URL -->
                                                                                    <input type="hidden" name="orderNum"
                                                                                        v-model="jasNewCardOsori.orderNum">
                                                                                    <!-- 注文番号  -->
                                                                                    <input type="hidden"
                                                                                        name="cardPassword"
                                                                                        v-model="jasNewCardOsori.cardPassword"
                                                                                        v-if="jcsMemberType == '0' || jcsMemberType == '1'">
                                                                                    <!-- カード情報パスワード -->
                                                                                    <input type="hidden"
                                                                                        name="securityCode"
                                                                                        v-model="jasNewCardOsori.securityCode">
                                                                                    <!-- セキュリティコード -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName1"
                                                                                        v-model="jasNewCardOsori.optionalAreaName1">
                                                                                    <!-- 自由使用領域1(項目名) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue1"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue1">
                                                                                    <!-- 自由使用領域1(設定値) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName2"
                                                                                        v-model="jasNewCardOsori.optionalAreaName2">
                                                                                    <!-- 自由使用領域2(項目名) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue2"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue2">
                                                                                    <!-- 自由使用領域2(設定値) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName3"
                                                                                        v-model="jasNewCardOsori.optionalAreaName3">
                                                                                    <!-- 自由使用領域3(項目名) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue3"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue3">
                                                                                    <!-- 自由使用領域3(設定値) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName4"
                                                                                        v-model="jasNewCardOsori.optionalAreaName4">
                                                                                    <!-- 自由使用領域4(項目名) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue4"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue4">
                                                                                    <!-- 自由使用領域4(設定値) -->
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName5"
                                                                                        v-model="jasNewCardOsori.optionalAreaName5">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue5"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue5">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName6"
                                                                                        v-model="jasNewCardOsori.optionalAreaName6">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue6"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue6">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName7"
                                                                                        v-model="jasNewCardOsori.optionalAreaName7">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue7"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue7">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName8"
                                                                                        v-model="jasNewCardOsori.optionalAreaName8">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue8"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue8">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName9"
                                                                                        v-model="jasNewCardOsori.optionalAreaName9">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue9"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue9">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaName10"
                                                                                        v-model="jasNewCardOsori.optionalAreaName10">
                                                                                    <input type="hidden"
                                                                                        name="optionalAreaValue10"
                                                                                        v-model="jasNewCardOsori.optionalAreaValue10">
                                                                                    <input type="hidden"
                                                                                        name="msgVerNum"
                                                                                        v-model="jasNewCardOsori.msgVerNum">
                                                                                    <!-- 3D version -->
                                                                                    <input type="hidden" name="xid"
                                                                                        v-model="jasNewCardOsori.xid">
                                                                                    <!-- 3D xid -->
                                                                                    <input type="hidden" name="xStatus"
                                                                                        v-model="jasNewCardOsori.xStatus">
                                                                                    <!-- 3D status  -->
                                                                                    <input type="hidden" name="eci"
                                                                                        v-model="jasNewCardOsori.eci">
                                                                                    <!-- 3D eci -->
                                                                                    <input type="hidden" name="cavv"
                                                                                        v-model="jasNewCardOsori.cavv">
                                                                                    <!-- 3D cavv -->
                                                                                    <input type="hidden"
                                                                                        name="cavvAlgorithm"
                                                                                        v-model="jasNewCardOsori.cavvAlgorithm">
                                                                                    <!-- 3D cavvAlgorithm -->
                                                                                    <input type="hidden"
                                                                                        name="paymentMode"
                                                                                        v-model="jasNewCardOsori.paymentMode">
                                                                                    <!-- 支払区分コード -->
                                                                                    <input type="hidden"
                                                                                        name="startPayMonth"
                                                                                        v-model="jasNewCardOsori.startPayMonth">
                                                                                    <!-- 支払開始月  -->
                                                                                    <input type="hidden"
                                                                                        name="paymentCount"
                                                                                        v-model="jasNewCardOsori.paymentCount">
                                                                                    <!-- 分割回数  -->
                                                                                    <input type="hidden"
                                                                                        name="initialAmount"
                                                                                        v-model="jasNewCardOsori.initialAmount">
                                                                                    <!-- 初回金額  -->
                                                                                    <input type="hidden"
                                                                                        name="bonusMonth"
                                                                                        v-model="jasNewCardOsori.bonusMonth">
                                                                                    <!-- ボーナス支払月 -->
                                                                                    <input type="hidden"
                                                                                        name="bonusAmount"
                                                                                        v-model="jasNewCardOsori.bonusAmount">
                                                                                    <!-- ボーナス支払金額 -->
                                                                                    <input type="hidden"
                                                                                        name="bonusCount"
                                                                                        v-model="jasNewCardOsori.bonusCount">
                                                                                    <!-- ボーナス回数  -->
                                                                                    <input type="hidden" name="shopID"
                                                                                        v-model="jasNewCardOsori.shopID"
                                                                                        v-if="jcsMemberType == '2'">
                                                                                    <!-- BlueGate ショップ ID -->
                                                                                    <input type="hidden" name="bgpasswd"
                                                                                        v-model="jasNewCardOsori.bgpasswd"
                                                                                        v-if="jcsMemberType == '2'">
                                                                                    <!-- BlueGate password -->
                                                                                    <input type="hidden"
                                                                                        name="accountMethod"
                                                                                        v-model="jasNewCardOsori.accountMethod"
                                                                                        v-if="jcsMemberType == '2'">
                                                                                    <!-- 決済手段登録番号 -->
                                                                                    <input type="hidden"
                                                                                        name="msgDigest"
                                                                                        v-model="jasNewCardOsori.msgDigest">
                                                                                    <!-- 注文受付メッセージダイジェスト -->
                                                                                </form>
                                                                            </template>

                                                                            <div class="">
                                                                                <div class="sh060tbl"
                                                                                    :summary="$t('sh060.labels.cardnumber')">
                                                                                    <div class="creditCardnumberArea">
                                                                                        <!-- カード番号(タイトル) -->
                                                                                        <div>
                                                                                            <label
                                                                                                class="col-form-label font-weight-bold">
                                                                                                {{
                                                                                                $t('sh060.labels.cardnumber')
                                                                                                }}
                                                                                            </label>
                                                                                        </div>
                                                                                        <!-- カード番号(入力内容) -->
                                                                                        <div v-if="pt125Init.creditInpNumOption == 0"
                                                                                            class="form-row">
                                                                                            <div
                                                                                                class="d-flex justify-content-between h-100">
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <input-check
                                                                                                        type="tel"
                                                                                                        class="num"
                                                                                                        size="4"
                                                                                                        style=" width:50px;"
                                                                                                        :maxlength="4"
                                                                                                        v-model="pt125ReqModel.cardNoDisp1"
                                                                                                        autocomplete="off" />
                                                                                                    -
                                                                                                </div>
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <input-check
                                                                                                        type="tel"
                                                                                                        class="num"
                                                                                                        size="4"
                                                                                                        style=" width:50px;"
                                                                                                        :maxlength="4"
                                                                                                        v-model="pt125ReqModel.cardNoDisp2"
                                                                                                        autocomplete="off" />
                                                                                                    -
                                                                                                </div>
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <input-check
                                                                                                        type="tel"
                                                                                                        class="num"
                                                                                                        size="4"
                                                                                                        style=" width:50px;"
                                                                                                        :maxlength="4"
                                                                                                        v-model="pt125ReqModel.cardNoDisp3"
                                                                                                        autocomplete="off" />
                                                                                                    -
                                                                                                </div>
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <input-check
                                                                                                        type="tel"
                                                                                                        class="num"
                                                                                                        size="4"
                                                                                                        style=" width:50px;"
                                                                                                        :maxlength="4"
                                                                                                        v-model="pt125ReqModel.cardNoDisp4"
                                                                                                        autocomplete="off" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div v-else>
                                                                                            <div
                                                                                                class="d-flex justify-content-between w-100 h-100">
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <input-check
                                                                                                        type="tel"
                                                                                                        class="num"
                                                                                                        size="20"
                                                                                                        style=" width:50%;"
                                                                                                        :maxlength="20"
                                                                                                        v-model="pt125ReqModel.cardNoDisp"
                                                                                                        autocomplete="off"
                                                                                                        @on-input-change="onCredit"
                                                                                                        @input="onCredit" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="creditExpirationdateArea">
                                                                                        <!-- 有効期限(タイトル) -->
                                                                                        <div>
                                                                                            <label
                                                                                                class="col-form-label font-weight-bold">
                                                                                                {{
                                                                                                $t('sh060.labels.expirationdate')
                                                                                                }}
                                                                                            </label>
                                                                                        </div>
                                                                                        <!-- 有効期限(タイトル) -->
                                                                                        <template
                                                                                            v-if="pt125Init.ymPulldownFlg == 1">
                                                                                            <div class="form-row">
                                                                                                <div
                                                                                                    class="d-flex justify-content-between ">
                                                                                                    <div
                                                                                                        class="form-check form-check-inline">
                                                                                                        <select
                                                                                                            v-model="pt125ReqModel.limitMonth"
                                                                                                            name="limitMonth"
                                                                                                            id="limitMonth"
                                                                                                            class="cardPayCnt">
                                                                                                            <option
                                                                                                                v-for="payCnt in pt125Init.monKbnList"
                                                                                                                :key="payCnt.KEY"
                                                                                                                :value="payCnt.KEY">
                                                                                                                {{
                                                                                                                payCnt.VALUE
                                                                                                                }}
                                                                                                            </option>
                                                                                                        </select>/
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div
                                                                                                    class="d-flex justify-content-between">
                                                                                                    <div
                                                                                                        class="form-check form-check-inline">
                                                                                                        <select
                                                                                                            v-model="pt125ReqModel.limitYear"
                                                                                                            name="limitYear"
                                                                                                            id="limitYear"
                                                                                                            class="cardPayCnt">
                                                                                                            <option
                                                                                                                v-for="payCnt in pt125Init.yearList"
                                                                                                                :key="payCnt.KEY"
                                                                                                                :value="payCnt.KEY">
                                                                                                                {{
                                                                                                                payCnt.VALUE
                                                                                                                }}
                                                                                                            </option>
                                                                                                        </select>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <input-check type="tel"
                                                                                                class="num" size="2"
                                                                                                maxlength="2"
                                                                                                v-model="pt125ReqModel.limitMonth"
                                                                                                name="limitMonth"
                                                                                                id="limitMonth"
                                                                                                autocomplete="off"
                                                                                                @on-input-change="onBlurLimitMonth" />
                                                                                            <!-- 月 -->
                                                                                            {{ $t('sh060.labels.month')
                                                                                            }}/20
                                                                                            <input-check type="tel"
                                                                                                class="num" size="2"
                                                                                                maxlength="2"
                                                                                                v-model="pt125ReqModel.limitYear"
                                                                                                name="limitYear"
                                                                                                id="limitYear"
                                                                                                autocomplete="off" />
                                                                                            <!-- 年 -->
                                                                                            {{ $t('sh060.labels.year')
                                                                                            }}
                                                                                        </template>
                                                                                    </div>
                                                                                    <!--GMOの場合のみ表示-->
                                                                                    <div v-if="pt125Init.kessaiCompKbn == 'GMO'"
                                                                                        class="creditCardHolderArea">
                                                                                        <!-- カードの名義人(タイトル) -->
                                                                                        <div
                                                                                            class="col-form-label font-weight-bold">
                                                                                            {{
                                                                                            $t('sh060.labels.cardHolder')
                                                                                            }}
                                                                                        </div>
                                                                                        <!-- カードの名義人(入力内容) -->
                                                                                        <div class="form-row">
                                                                                            <div
                                                                                                class="d-flex justify-content-between">
                                                                                                <div v-if="pt125Init.cardNameOption == 1"
                                                                                                    class="form-check form-check-inline">
                                                                                                    <span
                                                                                                        v-html="sh060DescriptionInfo[21]"></span>
                                                                                                    <input-check
                                                                                                        type="text"
                                                                                                        size="10"
                                                                                                        name="cardNameNamae"
                                                                                                        maxlength="50"
                                                                                                        class="code"
                                                                                                        id="cardNameNamae"
                                                                                                        v-model="pt125ReqModel.cardNameNamae"
                                                                                                        autocomplete="off"
                                                                                                        :placeholder="sh060DescriptionInfo[23]" />
                                                                                                    <span
                                                                                                        v-html="sh060DescriptionInfo[22]"></span>
                                                                                                    <input-check
                                                                                                        type="text"
                                                                                                        size="10"
                                                                                                        maxlength="50"
                                                                                                        name="cardNameMyouji"
                                                                                                        class="code"
                                                                                                        id="cardNameMyouji"
                                                                                                        v-model="pt125ReqModel.cardNameMyouji"
                                                                                                        autocomplete="off"
                                                                                                        :placeholder="sh060DescriptionInfo[24]" />
                                                                                                </div>
                                                                                                <div v-else
                                                                                                    class="form-check form-check-inline">
                                                                                                    <input type="text"
                                                                                                        size="20"
                                                                                                        name="cardUserNm"
                                                                                                        maxlength="100"
                                                                                                        id="cardUserNm"
                                                                                                        v-model="pt125ReqModel.cardUserNm"
                                                                                                        autocomplete="off"
                                                                                                        :placeholder="sh060DescriptionInfo[20]" />
                                                                                                </div>
                                                                                                <span
                                                                                                    class="form-check-inline"
                                                                                                    v-html="sh060DescriptionInfo[16]"></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-if="pt125Init.securityCodeUseFlg"
                                                                                        class="creditSecuritycodeArea">
                                                                                        <!-- セキュリティコード(タイトル) -->
                                                                                        <div>
                                                                                            <label
                                                                                                class="col-form-label font-weight-bold">
                                                                                                {{
                                                                                                $t('sh060.labels.securitycode')
                                                                                                }}
                                                                                            </label>
                                                                                        </div>
                                                                                        <!-- セキュリティコード(入力内容) -->
                                                                                        <div class="form-row">
                                                                                            <div
                                                                                                class="d-flex justify-content-between ">
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <input-check
                                                                                                        type="text"
                                                                                                        size="4"
                                                                                                        maxlength="4"
                                                                                                        name="cardSecurity"
                                                                                                        class="numcode"
                                                                                                        id="cardSecurity"
                                                                                                        v-model="pt125ReqModel.securityCode"
                                                                                                        autocomplete="off" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="creditPaymentMethodArea">
                                                                                        <!-- お支払方法(タイトル)  -->
                                                                                        <div>
                                                                                            <label
                                                                                                class="col-form-label font-weight-bold">
                                                                                                {{
                                                                                                $t('sh060.labels.paymentMethod')
                                                                                                }}
                                                                                            </label>
                                                                                        </div>
                                                                                        <!-- お支払方法(入力内容)  -->
                                                                                        <div class="form-row">
                                                                                            <div
                                                                                                class="d-flex justify-content-between">
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <select
                                                                                                        v-model="pt125ReqModel.cardPayCnt"
                                                                                                        name="cardPayCnt"
                                                                                                        id="cardPayCnt"
                                                                                                        @change="chgCardPayModel">
                                                                                                        <option
                                                                                                            v-for="payCnt in pt125Init.payCntList"
                                                                                                            :key="payCnt.KEY"
                                                                                                            :value="payCnt.KEY">
                                                                                                            {{
                                                                                                            payCnt.VALUE
                                                                                                            }}
                                                                                                        </option>
                                                                                                    </select>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-if="isBunkatu(pt125ReqModel.cardPayCnt)"
                                                                                        class="creditPaymentfrequencyArea">
                                                                                        <!-- お支払回数(タイトル) -->
                                                                                        <div>
                                                                                            <label
                                                                                                class="col-form-label font-weight-bold">
                                                                                                {{
                                                                                                $t('sh060.labels.paymentfrequency')
                                                                                                }}
                                                                                            </label>
                                                                                        </div>
                                                                                        <!-- お支払回数(入力内容) -->
                                                                                        <div class="form-row">
                                                                                            <div
                                                                                                class="d-flex justify-content-between ">
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <select
                                                                                                        v-model="pt125ReqModel.bunkatuKaisu"
                                                                                                        name="bunkatuKaisu"
                                                                                                        id="bunkatuKaisu">
                                                                                                        <option
                                                                                                            v-for="kaisu in pt125Init.bunkatuKaisuList"
                                                                                                            :key="kaisu.KEY"
                                                                                                            :value="kaisu.KEY">
                                                                                                            {{
                                                                                                            kaisu.VALUE
                                                                                                            }}
                                                                                                        </option>
                                                                                                    </select>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </template>
                                                                        <div v-else class="">
                                                                            <div class="sh060tbl"
                                                                                :summary="$t('sh060.labels.cardnumber')">
                                                                                <div class="creditCardnumberArea">
                                                                                    <!-- カード番号(タイトル) -->
                                                                                    <div>
                                                                                        <label
                                                                                            class="col-form-label font-weight-bold">
                                                                                            {{
                                                                                            $t('sh060.labels.cardnumber')
                                                                                            }}
                                                                                        </label>
                                                                                    </div>
                                                                                    <!-- カード番号(入力内容) -->
                                                                                    <div v-if="pt125Init.creditInpNumOption == 0"
                                                                                        class="form-row">
                                                                                        <div
                                                                                            class="d-flex justify-content-between h-100">
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <input-check type="tel"
                                                                                                    class="num" size="4"
                                                                                                    style=" width:50px;"
                                                                                                    :maxlength="4"
                                                                                                    v-model="pt125ReqModel.cardNoDisp1"
                                                                                                    autocomplete="off" />
                                                                                                -
                                                                                            </div>
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <input-check type="tel"
                                                                                                    class="num" size="4"
                                                                                                    style=" width:50px;"
                                                                                                    :maxlength="4"
                                                                                                    v-model="pt125ReqModel.cardNoDisp2"
                                                                                                    autocomplete="off" />
                                                                                                -
                                                                                            </div>
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <input-check type="tel"
                                                                                                    class="num" size="4"
                                                                                                    style=" width:50px;"
                                                                                                    :maxlength="4"
                                                                                                    v-model="pt125ReqModel.cardNoDisp3"
                                                                                                    autocomplete="off" />
                                                                                                -
                                                                                            </div>
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <input-check type="tel"
                                                                                                    class="num" size="4"
                                                                                                    style=" width:50px;"
                                                                                                    :maxlength="4"
                                                                                                    v-model="pt125ReqModel.cardNoDisp4"
                                                                                                    autocomplete="off" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        <div
                                                                                            class="d-flex justify-content-between w-100 h-100">
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <input-check type="tel"
                                                                                                    class="num"
                                                                                                    size="20"
                                                                                                    style=" width:50%;"
                                                                                                    :maxlength="20"
                                                                                                    v-model="pt125ReqModel.cardNoDisp"
                                                                                                    autocomplete="off"
                                                                                                    @on-input-change="onCredit"
                                                                                                    @input="onCredit" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <input type="hidden"
                                                                                        id="cardNoDisp" />
                                                                                </div>
                                                                                <div class="creditExpirationdateArea">
                                                                                    <!-- 有効期限(タイトル) -->
                                                                                    <div
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.expirationdate')
                                                                                        }}
                                                                                    </div>
                                                                                    <!-- 有効期限(入力内容) -->
                                                                                    <template
                                                                                        v-if="pt125Init.ymPulldownFlg == 1">
                                                                                        <div class="form-row">
                                                                                            <div
                                                                                                class="d-flex justify-content-between ">
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <select
                                                                                                        v-model="pt125ReqModel.limitMonth"
                                                                                                        name="limitMonth"
                                                                                                        id="limitMonth"
                                                                                                        class="cardPayCnt">
                                                                                                        <option
                                                                                                            v-for="payCnt in pt125Init.monKbnList"
                                                                                                            :key="payCnt.KEY"
                                                                                                            :value="payCnt.KEY">
                                                                                                            {{
                                                                                                            payCnt.VALUE
                                                                                                            }}
                                                                                                        </option>
                                                                                                    </select>/
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                class="d-flex justify-content-between">
                                                                                                <div
                                                                                                    class="form-check form-check-inline">
                                                                                                    <select
                                                                                                        v-model="pt125ReqModel.limitYear"
                                                                                                        name="limitYear"
                                                                                                        id="limitYear"
                                                                                                        class="cardPayCnt">
                                                                                                        <option
                                                                                                            v-for="payCnt in pt125Init.yearList"
                                                                                                            :key="payCnt.KEY"
                                                                                                            :value="payCnt.KEY">
                                                                                                            {{
                                                                                                            payCnt.VALUE
                                                                                                            }}
                                                                                                        </option>
                                                                                                    </select>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </template>
                                                                                    <template v-else>
                                                                                        <input-check type="tel"
                                                                                            class="num" size="2"
                                                                                            maxlength="2"
                                                                                            v-model="pt125ReqModel.limitMonth"
                                                                                            name="limitMonth"
                                                                                            id="limitMonth"
                                                                                            autocomplete="off"
                                                                                            @on-input-change="onBlurLimitMonth" />
                                                                                        <!-- 月 -->
                                                                                        {{ $t('sh060.labels.month')
                                                                                        }}/20
                                                                                        <input-check type="tel"
                                                                                            class="num" size="2"
                                                                                            maxlength="2"
                                                                                            v-model="pt125ReqModel.limitYear"
                                                                                            name="limitYear"
                                                                                            id="limitYear"
                                                                                            autocomplete="off" />
                                                                                        <!-- 年 -->
                                                                                        {{ $t('sh060.labels.year') }}
                                                                                    </template>
                                                                                </div>
                                                                                <div class="creditCardHolderArea">
                                                                                    <!-- カードの名義人(タイトル) -->
                                                                                    <div
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{ $t('sh060.labels.cardHolder')
                                                                                        }}
                                                                                    </div>
                                                                                    <!-- カードの名義人(入力内容) -->
                                                                                    <div class="form-row">
                                                                                        <div
                                                                                            class="d-flex justify-content-between">
                                                                                            <div v-if="pt125Init.cardNameOption == 1"
                                                                                                class="form-check form-check-inline">
                                                                                                <span
                                                                                                    v-html="sh060DescriptionInfo[21]"></span>
                                                                                                <input-check type="text"
                                                                                                    size="10"
                                                                                                    name="cardNameNamae"
                                                                                                    maxlength="50"
                                                                                                    class="code"
                                                                                                    id="cardNameNamae"
                                                                                                    v-model="pt125ReqModel.cardNameNamae"
                                                                                                    autocomplete="off"
                                                                                                    :placeholder="sh060DescriptionInfo[23]" />
                                                                                                <span
                                                                                                    v-html="sh060DescriptionInfo[22]"></span>
                                                                                                <input-check type="text"
                                                                                                    size="10"
                                                                                                    maxlength="50"
                                                                                                    name="cardNameMyouji"
                                                                                                    class="code"
                                                                                                    id="cardNameMyouji"
                                                                                                    v-model="pt125ReqModel.cardNameMyouji"
                                                                                                    autocomplete="off"
                                                                                                    :placeholder="sh060DescriptionInfo[24]" />
                                                                                            </div>
                                                                                            <div v-else
                                                                                                class="form-check form-check-inline">
                                                                                                <input type="text"
                                                                                                    size="20"
                                                                                                    name="cardUserNm"
                                                                                                    maxlength="100"
                                                                                                    id="cardUserNm"
                                                                                                    v-model="pt125ReqModel.cardUserNm"
                                                                                                    autocomplete="off"
                                                                                                    :placeholder="sh060DescriptionInfo[20]" />
                                                                                            </div>
                                                                                            <span
                                                                                                class="form-check-inline"
                                                                                                v-html="sh060DescriptionInfo[16]"></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="creditPaymentMethodArea">
                                                                                    <!--お支払方法(タイトル) -->
                                                                                    <div
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.paymentMethod')
                                                                                        }}
                                                                                    </div>
                                                                                    <!--お支払方法(入力内容) -->
                                                                                    <div class="form-row">
                                                                                        <div
                                                                                            class="d-flex justify-content-between ">
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <select
                                                                                                    v-model="pt125ReqModel.cardPayCnt"
                                                                                                    name="cardPayCnt"
                                                                                                    id="cardPayCnt"
                                                                                                    class="cardPayCnt"
                                                                                                    @change="chgCardPayModel">
                                                                                                    <option
                                                                                                        v-for="payCnt in pt125Init.payCntList"
                                                                                                        :key="payCnt.KEY"
                                                                                                        :value="payCnt.KEY">
                                                                                                        {{ payCnt.VALUE
                                                                                                        }}
                                                                                                    </option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-if="isBunkatu(pt125ReqModel.cardPayCnt)"
                                                                                    class="creditPaymentfrequencyArea">
                                                                                    <!-- お支払回数(タイトル) -->
                                                                                    <div
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.paymentfrequency')
                                                                                        }}
                                                                                    </div>
                                                                                    <!-- お支払回数(入力内容) -->
                                                                                    <div class="form-row">
                                                                                        <div
                                                                                            class="d-flex justify-content-between ">
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <select
                                                                                                    v-model="pt125ReqModel.bunkatuKaisu"
                                                                                                    name="bunkatuKaisu"
                                                                                                    id="bunkatuKaisu">
                                                                                                    <option
                                                                                                        v-for="kaisu in pt125Init.bunkatuKaisuList"
                                                                                                        :key="kaisu.KEY"
                                                                                                        :value="kaisu.KEY">
                                                                                                        {{ kaisu.VALUE
                                                                                                        }}
                                                                                                    </option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="creditSecuritycodeArea">
                                                                                    <!-- セキュリティコード(タイトル) -->
                                                                                    <div
                                                                                        class="col-form-label font-weight-bold">
                                                                                        {{
                                                                                        $t('sh060.labels.securitycode')
                                                                                        }}
                                                                                    </div>
                                                                                    <!-- セキュリティコード(入力内容) -->
                                                                                    <div class="form-row">
                                                                                        <div
                                                                                            class="d-flex justify-content-between ">
                                                                                            <div
                                                                                                class="form-check form-check-inline">
                                                                                                <input-check type="text"
                                                                                                    size="4"
                                                                                                    maxlength="4"
                                                                                                    name="cardSecurity"
                                                                                                    class="numcode"
                                                                                                    id="cardSecurity"
                                                                                                    v-model="pt125ReqModel.securityCode"
                                                                                                    autocomplete="off" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                    <template>
                                                                        <!--v-if="pt125Init.kokyakuNo != '999999999'"-->
                                                                        <hr>
                                                                        <div style="margin:10px 0px 5px 0px;">
                                                                            <input v-if="pt125Init.teikiFlg == '1'"
                                                                                type="hidden"
                                                                                v-model="pt125ReqModel.cardSaveFlg"
                                                                                name="card_save_flg" id="_card_save_flg"
                                                                                value="1">
                                                                            <input v-if="pt125Init.teikiFlg == '1'"
                                                                                disabled="true" name="card_save_flg"
                                                                                id="_card_save_flg"
                                                                                v-model="pt125ReqModel.cardSaveFlg"
                                                                                @click="setCardSaveFlg()"
                                                                                type="checkbox" value="1">
                                                                            <input v-else name="card_save_flg"
                                                                                id="_card_save_flg"
                                                                                v-model="pt125ReqModel.cardSaveFlg"
                                                                                @click="setCardSaveFlg()"
                                                                                type="checkbox" value="1">
                                                                            <label for="_card_save_flg" onclick="">
                                                                                <!-- クレジットカード情報を保存する -->
                                                                                {{
                                                                                $t("sh060.labels.savecreditcardinformation")
                                                                                }}
                                                                            </label>
                                                                            <template v-if="pt125Init.teikiFlg == '1'">
                                                                                <br>
                                                                                <span
                                                                                    v-html="sh060DescriptionInfo[2]"></span>
                                                                            </template>
                                                                            <template v-else>
                                                                                <template
                                                                                    v-if="common.stringNvl(pt125Init.cardNoDisp) != ''">
                                                                                    <br>
                                                                                    <span
                                                                                        v-html="sh060DescriptionInfo[4]"></span>
                                                                                </template>
                                                                                <br>
                                                                                <span
                                                                                    v-html="sh060DescriptionInfo[1]"></span>
                                                                            </template>
                                                                        </div>
                                                                        <input type="hidden"
                                                                            v-model="pt125ReqModel.token"
                                                                            name="card_token" id="card_token">
                                                                    </template>
                                                                </template>
                                                            </div>
                                                        </div>
                                                        <!-- お支払方法 コンビニ REAL_AUTHORI_KBN=='2'-->
                                                        <div class="settingMainSh060OneColumn"
                                                            v-if="obj.REAL_AUTHORI_KBN == '2'">
                                                            <div class="personal mb64"
                                                                :summary="$t('sh060.labels.newPayment')">
                                                                <!--コンビニ情報 -->
                                                                <template>
                                                                    <table class="purchase-history">
                                                                        <tbody>
                                                                            <tr>
                                                                                <th>
                                                                                    <!-- コンビニ名 -->
                                                                                    {{
                                                                                    $t('sh060.labels.conveniencestorename')
                                                                                    }}
                                                                                    <span class="※">※</span>
                                                                                </th>
                                                                                <td width="65%" bgcolor="#FFFFFF">
                                                                                    <select name="cvsCd" id="_cvsCd">
                                                                                        <option
                                                                                            v-for="cvsCd in pt125Init.cvsCdList"
                                                                                            :key="cvsCd.KEY"
                                                                                            :value="cvsCd.KEY">
                                                                                            {{ cvsCd.VALUE }}</option>
                                                                                    </select>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </template>
                                                            </div>
                                                        </div>
                                                        <!-- お支払方法 AmazonPay KessaiCd='83' -->
                                                        <div class="settingMainSh060OneColumn"
                                                            v-if="obj.KEY == Constants.KESSAI_AMAZONPAY">
                                                            <div @click="buyStepAmazon()"
                                                                v-if="pt125Init.amazonPayFlg == 1"
                                                                style="margin-top:12px;" id="AmazonPayButton" />
                                                            <span id="ampPaymentUserNm"></span> &nbsp; <span
                                                                id="ampPaymentDescriptor"></span>
                                                            <input @click="changeAmazonAddress()"
                                                                v-if="amazonCheckoutSessionId !== ''"
                                                                id="changeAmazonPay" class="submit-button" type="submit"
                                                                :value="$t('common.buttons.change')" />

                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </template>
                                </div>
                                <p class="sh050Paytblmb32" v-if="descriptionInfo[7] != ''">
                                    <span v-html="descriptionInfo[7]"></span>
                                </p>

                            </div>
                            <!--REAL_AUTHORI_KBN,KESSAI_COMP_KBN-->

                        </template>

                        <!--熨斗情報-->
                        <template>
                            <!--熨斗情報- -->
                            <div class="subTitle">
                                <h4>{{ $t("pt125.labels.noshiInfo") }}</h4>
                            </div>
                            <div class="customer delivery sh030-body-guest-area">
                                <div class="noshiLine">
                                    <div class="label">
                                        <label class="optional" id="wrappingPaper_lbl">
                                            <span>{{ $t('sh060.labels.wrappingPaper') }}</span>
                                        </label>
                                    </div>
                                    <div class="input">
                                        <!-- のし -->
                                        {{ $t("sh030.labels.works") }}&nbsp;
                                        <select name="" id="sagyoKanriKomokuCd"
                                            v-model="pt125ReqModel.sagyoKanriKomokuCd">
                                            <option value=""></option>
                                            <option v-for="noshi in pt125Init.noshiList" :key="noshi.KEY"
                                                :value="noshi.KEY">{{ noshi.VALUE }}</option>
                                        </select>
                                        <!-- 包装紙 -->
                                        {{ $t("sh030.labels.wrappingPaper") }}&nbsp;
                                        <select id="sagyoKanriKomokuCd2" v-model="pt125ReqModel.sagyoKanriKomokuCd2">
                                            <option value=""></option>
                                            <option v-for="housoushi in pt125Init.housoushiList" :key="housoushi.KEY"
                                                :value="housoushi.KEY">{{ housoushi.VALUE }}</option>
                                        </select>
                                        <br>
                                        <div v-html="sh030DescriptionInfo['28']"></div>
                                        <div v-html="sh030DescriptionInfo['27']"></div>
                                        <br>
                                        <!-- 送り主名 -->
                                        {{ $t("sh030.labels.senderName") }}１&nbsp;
                                        <input-check id="noshiNaire1" class="multi input-okurinushi-mei-css" type="text"
                                            v-model="pt125ReqModel.noshiNaire1" />
                                        <div v-html="sh030DescriptionInfo['29']"></div>
                                        <br>
                                        <!-- 送り主名 -->
                                        {{ $t("sh030.labels.senderName") }}２&nbsp;
                                        <input-check id="noshiNaire2" class="multi input-okurinushi-mei-css" type="text"
                                            v-model="pt125ReqModel.noshiNaire2" />
                                        <div v-html="sh030DescriptionInfo['30']"></div>
                                        <br>
                                        <div v-html="sh030DescriptionInfo['35']"></div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!--会員規約-->
                        <div class="membership" v-if="pageType == PAGE_INSERT">
                            <div class="membershipAgreement">{{ $t('pt400.labels.membership') }}</div>
                            <div class="membershipDescription" v-html="pt400DescriptionInfo['40']"></div>
                            <div class="AgreeFlag">
                                <!--同意する-->
                                <input type="radio" id="AgreeFlag1" name="AgreeFlag" value="1" class="AgreeFlag1Input"
                                    v-model="pt125ReqModel.agreeFlag">
                                <label for="AgreeFlag1">{{ $t('pt400.labels.agreeItems') }}</label>
                                <!-- 規約に同意しない -->
                                <input type="radio" id="AgreeFlag0" name="AgreeFlag" value="0" class="AgreeFlag0Input"
                                    v-model="pt125ReqModel.agreeFlag">
                                <label for="AgreeFlag0">{{ $t('pt400.labels.dontAgree') }}</label>
                            </div>
                        </div>

                        <div class="button-column mb32 btnSubmitpt120">
                            <!-- 注文確定 -->
                            <li><button @click="confirmDoSubmit()" type="button">{{ $t("pt125.buttons.submit")
                                    }}</button>
                            </li>
                        </div>

                        <!--プライバシーポリシーリンク-->
                        <p class="noteLink">
                            <span v-html="pt400DescriptionInfo['21']"></span>
                            <router-link class="blank" target="_blank"
                                :to="{ name: SiteConstants.PG010MAIN, query: { pageNo: 70 } }">
                                {{ $t('common.labels.noteLink') }}
                            </router-link>
                            <span v-html="pt400DescriptionInfo['22']"></span>
                        </p>
                    </div>

                    <span style="display:none" id="mail_confirm_lbl">{{ $t("pt125.labels.subMailAddress") }}</span>

                    <span style="display:none" id="name_lbl">{{ $t("sh030.labels.name") }}</span>
                    <span style="display:none" id="nameKana_lbl">{{ $t("sh030.labels.nameKana") }}</span>
                    <span style="display:none" id="nameComp_lbl">{{ $t("sh030.labels.kaisyame") }}</span>
                    <span style="display:none" id="nameKanaComp_lbl">{{ $t("sh030.labels.kaisyamekana") }}</span>
                    <!-- 都道府県 -->
                    <span style="display:none" id="prefectures_lbl">{{ $t('sh030.labels.prefectures') }}</span>
                    <!-- 郵便番号 -->
                    <span style="display:none" id="postalCode_lbl">{{ $t('sh030.labels.postalCode') }}</span>
                    <!-- 電話番号 -->
                    <span style="display:none" id="phoneNumber_lbl">{{ $t('common.labels.phoneNumber') }}</span>
                    <!-- 営業所コード -->
                    <span style="display:none" id="yaOfficeCd_lbl">{{ $t('sh030.labels.yaOfficeCd') }}</span>
                </div>
                <alert-confirm v-if="isErrorAlert" :msgConfirm="errorMsg" :isButtonCancel="false"
                    @closedModal="isErrorAlert = false" size="md"></alert-confirm>

                <!--アラート表示-->
                <alert-confirm v-if="isModalShow" :msgConfirm="msgConfirm" :okAction="doSubmit"
                    :isButtonCancel="isButtonCancel">
                </alert-confirm>
                <CC212InputPostal v-if="cc212Dislay" @modal-close="cc212Dislay = false"
                    :propTdkZip1="dataCc212.propTdkZip1" :propTdkZip2="dataCc212.propTdkZip2"
                    :propIdx="dataCc212.propIdx" @set-addr-value="setAddrValue" />
                <ModalComponent v-if="isModalVisible" :show="isModalVisible" :tableData="tableData"
                    :selectedShouhin="selectedShouhin" :selectedShouhinLst="selectedShouhinLst" :note="note"
                    @close="isModalVisible = false" />
            </div>
        </div>
    </div>
</template>
<script>
import common from "assets/js/common";
import $ from 'jquery';
import commonEc from "assets/js/common_ec";
import EventBus from 'assets/js/eventBus';
import AlertConfirm from 'components/AlertConfirm';
import axios from "assets/js/request";
import Message from 'components/MessageEcSite';
import InputCheck from "components/InputCheck.vue";
import InputNumber from "components/InputNumber.vue";
import { Carousel, Slide } from 'vue-carousel';
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import ModalComponent from '../popup/HanbaiSuuSettingPopup.vue';
import { mapMutations } from 'vuex';

import starsParts from '../productDetailsParts/starsParts.vue';
import sellYmd from '../productDetailsParts/sellYmd.vue'
import colorSize from '../productDetailsParts/colorSize.vue'
import itemNmContainer from '../productDetailsParts/itemNmContainer.vue'
import itemMatome from '../productDetailsParts/itemMatome.vue'
import generalPriceInfo from '../productDetailsParts/generalPriceInfo.vue'
import catchCopy from '../productDetailsParts/catchCopy.vue'
import hrCom from '../productDetailsParts/hrCom.vue'
// import nebikiPriceInfo from '../productDetailsParts/nebikiPriceInfo.vue'
import teikiPriceInfo from '../productDetailsParts/teikiPriceInfo.vue'
// import pointGrantNum from '../productDetailsParts/pointGrantNum.vue'
import taxRateInfo from '../productDetailsParts/taxRateInfo.vue'
import productCode from '../productDetailsParts/productCode.vue'
import ondotaiInfo from '../productDetailsParts/ondotaiInfo.vue'
import optionInfo from '../productDetailsParts/optionInfo.vue'
import buyCountInfo from '../productDetailsParts/buyCountInfo.vue'
import buyAnimalQty from '../productDetailsParts/buyAnimalQty.vue'
import cartContainer from '../productDetailsParts/cartContainer.vue'
import matomeAddCart from '../productDetailsParts/matomeAddCart.vue'
import kanrenOrder from '../productDetailsParts/kanrenOrder.vue'
import likeContainer from '../productDetailsParts/likeContainer.vue'
import pointItemKbnInfo from '../productDetailsParts/pointItemKbnInfo.vue'
// import pointInfo from '../productDetailsParts/pointInfo.vue'
import limitMsgShow from '../productDetailsParts/limitMsgShow.vue'
import itemBuyContainer from '../productDetailsParts/itemBuyContainer.vue'
import itemGalleryImage from '../productDetailsParts/itemGalleryImage.vue'
import intruductionContainer from '../productDetailsParts/intruductionContainer.vue'
import itemStdListDl from '../productDetailsParts/itemStdListDl.vue'
import allergenInfo from '../productDetailsParts/allergenInfo.vue'
import specInfo from '../productDetailsParts/specInfo.vue'
import ReviewListContainer from '../productDetailsParts/reviewListContainer.vue'
import inOneOrder from '../productDetailsParts/inOneOrder.vue'
import autoHatchuNgIcon from '../productDetailsParts/autoHatchuNgIcon.vue'
import toyakiContainer from '../productDetailsParts/toyakiContainer.vue'
import clearfix from '../productDetailsParts/clearfix.vue'
import detailHtmlParts from "../productDetailsParts/detailHtmlParts";
import PT150BannerHtmlParts from "./PT150BannerHtmlParts";
import nebikiRtRate from '../productDetailsParts/nebikiRtRate.vue';
import point from '../productDetailsParts/point.vue';
import generalCartContainer from '../productDetailsParts/generalCartContainer.vue';
import nebikiPriceInfo from '../productDetailsParts/nebikiPriceInfo.vue';
import teikiCartContainer from '../productDetailsParts/teikiCartContainer.vue';
import pointGrantNum from '../productDetailsParts/pointGrantNum.vue';

export default {
    name: "PT125ProductDetailsParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components: {
        Message,
        InputCheck,
        InputNumber,
        AlertConfirm,
        Carousel,
        Slide,
        Breadcrumb,
        toastr,
        ModalComponent,

        starsParts,
        sellYmd,
        colorSize,
        itemNmContainer,
        catchCopy,
        hrCom,
        generalPriceInfo,
        // nebikiPriceInfo,
        teikiPriceInfo,
        // pointGrantNum,
        taxRateInfo,
        pointItemKbnInfo,
        productCode,
        ondotaiInfo,
        optionInfo,
        buyCountInfo,
        buyAnimalQty,
        itemMatome,
        cartContainer,
        matomeAddCart,
        kanrenOrder,
        likeContainer,
        // pointInfo,
        limitMsgShow,
        itemBuyContainer,
        itemGalleryImage,
        intruductionContainer,
        itemStdListDl,
        allergenInfo,
        specInfo,
        ReviewListContainer,
        inOneOrder,
        autoHatchuNgIcon,
        toyakiContainer,
        clearfix,
        detailHtmlParts,
        PT150BannerHtmlParts,
        
        point,
        generalCartContainer,
        nebikiPriceInfo,
        nebikiRtRate,
        teikiCartContainer,
        pointGrantNum,
    },
    data() {
        return {
            PT125_PART: 'pt125',
            amazonPayInited: false,
            urlLocation: '',
            common: common,
            commonEc: commonEc,
            sh050RespModel_daiNgFlg: null,
            siharaiHohoKbn: null,
            tdkIndex: null,
            teikiKounyuu: 0,
            isLp: false,
            pt125Init: {
                productInfo: [],
                navList: [],
                colSizList: [],
                detailList: [],
                favoritesList: [],
                totalReviewRank: [],
                uketoriServiceKbn: {},
                descriptionInfo: {},
                pt400DescriptionInfo: {},
                sh030DescriptionInfo: {},
                sh050DescriptionInfo: {},
                sh060DescriptionInfo: {},
                colorTitle: '',
                sizeTitle: '',
                syukkaYoteiDate: '',
                siteFlg: null,
                priceFlg: null,
                facebookUrl: null,
                facebookAttr: null,
                loginKbn: false,
                shahanFlg: null,
                colorSizeFlg: false,
                reviewList: null,
                itemStdFlg: 0,
            },
            isModalVisible: false,
            tableData: [],
            selectedShouhinLst: [],
            selectedShouhin: '',
            note: '',
            pt125ReqModel: {
                //商品情報部----------------
                sItemNo: null,
                colSzSItemNo: null,
                yoyakuItemFlg: null,
                categoryCd: null,
                buyCount: null,
                wariPrice: null,
                cartAddKbn: null,
                pointFlg: 0,
                //会員情報部----------------
                agreeFlag: 0,
                kokyakuCd: null,
                mail: null,
                mailOld: null,
                mail_confirm: null,
                password: null,
                passwordSub: null,
                prePassword: null,
                nm1: null,
                nm2: null,
                nm3: null,
                kana1: null,
                kana2: null,
                kana3: null,
                birthDayYYYY: null,
                birthDayMM: null,
                birthDayDD: null,
                sexKbn: '9',
                zip: null,
                zip1: null,
                zip2: null,
                kenCd: null,
                kenNm: null,
                addr1: null,
                addr2: null,
                addr3: null,
                tel1: null,
                fax: null,
                newsMailRcvFlg: '0',
                dmFlg: '0',
                kokyakuRankKbn: null,
                kokyakuRankKbnNm: null,
                pointNum: null,
                exclCnt: null,
                nickname: null,
                ageOpenFlg: '0',
                sexOpenFlg: '0',
                kaiinCheck: null,
                //配送先情報部----------------
                radioGroup: '1',
                tdkNo: '0',
                tdkNm1: '',
                tdkNm2: '',
                tdkKana1: '',
                tdkKana2: '',
                tdkZip: '',
                tdkKenCd: '',
                tdkKenNm: '',
                tdkAddr1: '',
                tdkAddr2: '',
                tdkAddr3: '',
                tdkTel: '',
                tdkMail1: '',
                //決済情報----------------
                kessaiCd: null,
                //熨斗情報----------------
                sagyoKanriKomokuCd: null,
                sagyoKanriKomokuCd2: null,
                noshiNaire1: null,
                noshiNaire2: null,

                securityCode: '',
                cardSecurity: '',
                sbp3DVerFlg: 0,
                tds2InfoToken: '',
                tds2InfoTokenKey: '',
                sbp3DVerBackUr: '',
                tdsAuthenticationId: '',
                resSbpCustId: '',
                apiRequestId: '',
                resApiErrCode: '',
                resApiResult: ''
            },
            sh050SiharaiHohoKbnList: {},
            PAGE_INSERT: '3',
            PAGE_UPDATE: '4',
            pageType: 3,
            isModalShow: false,
            cc212Dislay: false,
            dataCc212: {},
            cc212ReqModel: {},
            showReviewFlg: 0,
            backPageNo: 0,
            categoryCd: null,
            ptPageNo: 1,
            ptPageSize: 10,
            searchItemNm: null,
            itemNmOnly: null,
            priceS: null,
            priceE: null,
            allergyMaterialKbn: null,
            descriptionInfo: [],
            pt400DescriptionInfo: [],
            sh030DescriptionInfo: [],
            sh050DescriptionInfo: {},
            sh060DescriptionInfo: {},
            listIdErr: [],
            listMessValid: [],
            mapMessValid: [],
            navListCustom: [],
            SiteConstants: SiteConstants,
            Constants: Constants,
            imgResult: '',
            site: "",
            customFlg: 0,
            msgConfirm: '',
            isErrorAlert: false,
            numOptions: [
                {
                    value: '1',
                    lable: '1',
                },
                {
                    value: '2',
                    lable: '2',
                },
                {
                    value: '10',
                    lable: '10',
                },
            ],
            NO_CART_ERR: "001",
            CART_INFO_INVALID_ERR: "002",
            SHOW_ERR_PAGE: "003",
            BESE_KIN_ERR: "004",
            LEAD_DAY_ERR: "005",
            showNowCardFlg: 1,
            security3DFlg: 0,
            securityGmo3DFlg: 0,
            resGmoVer2ACS: "",
            resGmoVer2RedirectUrl: "",
            gmo2AuthAccessID: "",
            jcsMemberType: '',
            jasApiSeqNo: '',
            jasApiResult: {},
            jasNewCardTaking: {
                memberType: '',
                tourokuKbn: '',
                merchantId: '',
                senddate: '',
                sendtime: '',
                pan: '',
                expiryDate: '',
                cardKbn: '',
                backUrl: '',
                resultUrl: '',
                optionalAreaName1: '',
                optionalAreaValue1: '',
                optionalAreaName2: '',
                optionalAreaValue2: '',
                optionalAreaName3: '',
                optionalAreaValue3: '',
                optionalAreaName4: '',
                optionalAreaValue4: '',
                optionalAreaName5: '',
                optionalAreaValue5: '',
                optionalAreaName6: '',
                optionalAreaValue6: '',
                optionalAreaName7: '',
                optionalAreaValue7: '',
                optionalAreaName8: '',
                optionalAreaValue8: '',
                optionalAreaName9: '',
                optionalAreaValue9: '',
                optionalAreaName10: '',
                optionalAreaValue10: '',
                shopID: '',
                msgDigest: ''
            },
            jasNewCard3D: {
                memberType: '',
                tourokuKbn: '',
                merchantId: '',
                cardPassword: '',
                dbKey1: '',
                orderNum: '',
                amount: '',
                taxAndDeliCharge: '',
                backUrl: '',
                resultUrl: '',
                optionalAreaName1: '',
                optionalAreaValue1: '',
                optionalAreaName2: '',
                optionalAreaValue2: '',
                optionalAreaName3: '',
                optionalAreaValue3: '',
                optionalAreaName4: '',
                optionalAreaValue4: '',
                optionalAreaName5: '',
                optionalAreaValue5: '',
                optionalAreaName6: '',
                optionalAreaValue6: '',
                optionalAreaName7: '',
                optionalAreaValue7: '',
                optionalAreaName8: '',
                optionalAreaValue8: '',
                optionalAreaName9: '',
                optionalAreaValue9: '',
                optionalAreaName10: '',
                optionalAreaValue10: '',
                shopID: '',
                accountMethod: '',
                msgDigest: '',
                teikiFlg: '',
                authenticationInd: '',
                threeDSReqAuthMethod: '',
                threeDSReqAuthTimestamp: '',
                challengeInd: '',
                acctType: '',
                merchantName: '',
                chAccAgeInd: '',
                chAccChange: '',
                chAccChangeInd: '',
                chAccDate: '',
                chAccPwChange: '',
                chAccPwChangeInd: '',
                nbPurchaseAccount: '',
                provisionAttemptsDay: '',
                txnActivityDay: '',
                txnActivityYear: '',
                paymentAccAge: '',
                paymentAccInd: '',
                shipAddressUsage: '',
                shipAddressUsageInd: '',
                shipNameIndicator: '',
                suspiciousAccActivity: '',
                addrMatch: '',
                billAddrCity: '',
                billAddrCountry: '',
                billAddrLine1: '',
                billAddrLine2: '',
                billAddrLine3: '',
                billAddrPostCode: '',
                billAddrState: '',
                email: '',
                homePhoneCc: '',
                homePhoneSubscriber: '',
                mobilePhoneCc: '',
                mobilePhoneSubscriber: '',
                cardholderName: '',
                shipAddrCity: '',
                shipAddrCountry: '',
                shipAddrLine1: '',
                shipAddrLine2: '',
                shipAddrLine3: '',
                shipAddrPostCode: '',
                shipAddrState: '',
                workPhoneCc: '',
                workPhoneSubscriber: '',
                purchaseInstalData: '',
                deliveryEmailAddress: '',
                deliveryTimeframe: '',
                giftCardAmount: '',
                giftCardCount: '',
                giftCardCurr: '',
                preOrderDate: '',
                preOrderPurchaseInd: '',
                reorderItemsInd: '',
                shipIndicator: '',
                messageCategory: '',
                recurringExpiry: '',
                recurringFrequency: '',
                transType: "",
                priorTransID: '',
                msgDigest2: ''
            },
            //epsOsori: {
            //    epsPublicAPIKey:'',
            //    epsId:'',
            //    epsAccessId:'',
            //},
            epsCard: {
                card_no: '',
                expire: '',
                holder_name: '',
                security_code: ''
            },
            jasNewCardOsori: {
                memberType: '',
                tourokuKbn: '',
                merchantId: '',
                dbKey1: '',
                amount: '',
                taxAndDeliCharge: '',
                backUrl: '',
                orderNum: '',
                cardPassword: '',
                securityCode: '',
                resultUrl: '',
                optionalAreaName1: '',
                optionalAreaValue1: '',
                optionalAreaName2: '',
                optionalAreaValue2: '',
                optionalAreaName3: '',
                optionalAreaValue3: '',
                optionalAreaName4: '',
                optionalAreaValue4: '',
                optionalAreaName5: '',
                optionalAreaValue5: '',
                optionalAreaName6: '',
                optionalAreaValue6: '',
                optionalAreaName7: '',
                optionalAreaValue7: '',
                optionalAreaName8: '',
                optionalAreaValue8: '',
                optionalAreaName9: '',
                optionalAreaValue9: '',
                optionalAreaName10: '',
                optionalAreaValue10: '',
                msgVerNum: '',
                xid: '',
                xStatus: '',
                eci: '',
                cavv: '',
                cavvAlgorithm: '',
                paymentMode: '',
                startPayMonth: '',
                paymentCount: '',
                initialAmount: '',
                bonusMonth: '',
                bonusAmount: '',
                bonusCount: '',
                shopID: '',
                bgpasswd: '',
                accountMethod: '',
                msgDigest: ''
            },
            allergenStr: "",
            specDispFlg: 0,

            printData: {},
            kanrenItemInfo: {},
            KanrenColorSizeFlg: false,

            securitySbp3DFlg: 0,
            sbpTdsAuthenticationId: '',
            sbpEmv3dsStatus: '',
            sbpErrorCode: '',
            fullImageUrl: ''
        }
    },
    /*
    * 初期処理
    */
    mounted() {
        var _this = this;

        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        var host = window.location.protocol + "//" + window.location.host;
        _this.pt125ReqModel.clientHost = host;
        _this.pt125ReqModel.selfFullPath = window.location.href;
        if (_this.ptInitData) {
            _this.pt125Init = _this.ptInitData;
            _this.customFlg = _this.ptInitData.customFlg;
            _this.securitySbp3DFlg = _this.ptInitData.securitySbp3DFlg;

            // カラーサイズリストが存在する場合に表示
            if (_this.getLengthObj(_this.pt125Init.colSizList) > 0) {
                for (var i = 0; i < _this.pt125Init.colSizList.length; i++) {
                    var colSize = _this.pt125Init.colSizList[i];
                    if (colSize.VALUE != '' && colSize.VALUE != undefined) {
                        // カラーサイズ表示フラグON
                        _this.pt125Init.colorSizeFlg = true;
                    } else {
                        _this.pt125Init.colorSizeFlg = false;
                    }
                }
            }

            _this.pt125ReqModel = Object.assign({}, _this.pt125ReqModel, _this.ptInitData.reqModel);
            _this.descriptionInfo = _this.pt125Init.descriptionInfo;
            _this.pt400DescriptionInfo = _this.pt125Init.pt400DescriptionInfo;
            _this.sh030DescriptionInfo = _this.pt125Init.sh030DescriptionInfo;
            _this.sh050DescriptionInfo = _this.pt125Init.sh050DescriptionInfo;
            _this.sh060DescriptionInfo = _this.pt125Init.sh060DescriptionInfo;
            _this.sh050SiharaiHohoKbnList = _this.pt125Init.resultSiharaiHohoKbnList;
            // 商品カテゴリ名をセット
            if (_this.pt125Init.productInfo != undefined) {
                if (_this.pt125Init.productInfo.CATEGORY_NM != undefined && _this.pt125Init.productInfo.CATEGORY_NM != null && _this.pt125Init.productInfo.CATEGORY_NM != '') {
                    _this.navListCustom = [{ "CATEGORY_NM": _this.pt125Init.productInfo.CATEGORY_NM, "CATEGORY_CD": _this.pt125Init.productInfo.CATEGORY_CD }];
                }
            }
            if (_this.pt125ReqModel.optionGroupList != null || _this.pt125ReqModel.optionList != null) {
                for (var i = 0; i < _this.pt125ReqModel.optionGroupList.length; i++) {
                    if (_this.pt125ReqModel.optionGroupList[i].REQUIRED_FLG == 0) {
                        for (var j = 0; j < _this.pt125ReqModel.optionList.length; j++) {
                            _this.pt125ReqModel.optionGroupList[i].OPTION_VALUE2 = _this.pt125ReqModel.optionList[0].OPTION_VALUE;
                        }
                    }
                }
            }

            _this.$nextTick(() => {
                let robots = document.querySelector('meta[name="robots"]');
                let searchTargetFlg = _this.pt125Init.productInfo != null && _this.pt125Init.productInfo != undefined ? _this.pt125Init.productInfo.SEARCH_TARGET_FLG : '';
                let webItemNm = _this.pt125Init.productInfo != null && _this.pt125Init.productInfo != undefined ? _this.pt125Init.productInfo.WEB_ITEM_NM : '';
                if (searchTargetFlg == '0') {
                    //サイト用商品マスタにブラウザ検索対象カラム追加して、1が立っていない場合は検索対象外<meta name="robots" content="noindex,nofollow" />とする
                    if (robots) {
                        robots.setAttribute("content", "noindex,nofollow");
                    } else {
                        robots = document.createElement("meta");
                        robots.setAttribute("name", "robots");
                        robots.setAttribute("content", "noindex,nofollow");
                        document.head.appendChild(robots);
                    }

                } else {
                    if (robots) {
                        document.head.removeChild(robots);
                    }

                    //<meta property="og:site_name">タグでcontentをサイト名とする
                    let ogSiteName = document.querySelector('meta[property="og:site_name"]');
                    if (ogSiteName) {
                        ogSiteName.setAttribute("content", _this.pt125Init.siteNm);
                    }
                    //<meta keywords>に「商品名,」を先頭に追加する
                    let keywords = document.querySelector('meta[name="keywords"]');
                    if (keywords) {
                        let keywordsText = keywords.getAttribute("content");
                        if (webItemNm) {
                            if (keywordsText) {
                                keywords.setAttribute("content", webItemNm + "," + keywordsText);
                            } else {
                                keywords.setAttribute("content", webItemNm);
                            }
                        } else {
                            keywords.setAttribute("content", keywordsText);
                        }

                    }
                    let imageUrl = document.querySelector('meta[property="og:image"]');
                    if (_this.pt125Init.productInfo != undefined && _this.pt125Init.productInfo != null && _this.pt125Init.productInfo != '') {
                        // <meta og:image>タグでcontentを商品画像URLとする
                        if (_this.pt125Init.productInfo.IMG_URL1 != null && _this.pt125Init.productInfo.IMG_URL1 != undefined && _this.pt125Init.productInfo.IMG_URL1 != '') {
                            // サイトのURL（プロトコル＋ホスト名）取得する
                            const siteUrl = window.location.protocol + "//" + window.location.host;
                            // 画像URLの設定
                            _this.fullImageUrl = siteUrl + _this.pt125Init.productInfo.IMG_URL1;
                        }
                        imageUrl.setAttribute("content", _this.fullImageUrl);
                    }
                }

                //商品レビューの全てを読むボタンの制御
                let reviewHeightLimit = this.pt125Init.reviewHeightLimit;
                let readmore = document.querySelectorAll('.readMoreInner');
                Array.from(readmore).forEach(function (more) {

                    let btn = more.querySelector('.readMoreBtn');
                    let content = more.querySelector('.readMoreContainer');

                    if (reviewHeightLimit > 0) {
                        content.style.maxHeight = reviewHeightLimit + 'px';

                        // ボタンクリックでイベント処理
                        btn.addEventListener('click', () => {
                            if (!content.classList.contains('show')) {
                                content.style.maxHeight = content.scrollHeight + 'px';
                                content.classList.add('show');
                                btn.innerText = _this.$i18n.t("pt125.labels.reviewItemReadClose");
                            } else {
                                content.style.maxHeight = reviewHeightLimit + 'px';
                                content.classList.remove('show');
                                btn.innerText = _this.$i18n.t("pt125.labels.reviewItemReadAll");
                            }
                        });

                        //表示直後は高さが不正確なので1.0秒後にボタン表示判定(高さ閾値以下ならボタン表示しない)
                        setTimeout(() => {
                            if (content.scrollHeight < reviewHeightLimit) {
                                btn.style.display = 'none';
                            }
                        }, 1000);
                    } else {
                        btn.style.display = 'none';
                    }
                });
                // カノニカルURL設定
                common.isSetCanonical();
            });

            //カラー/サイズが初期で選択
            _this.pt125ReqModel.colSzSItemNo = _this.pt125Init.productInfo != null && _this.pt125Init.productInfo != undefined ? _this.pt125Init.productInfo.S_ITEM_NO : '';
        } else {
            _this.doinit();
        }
        //_this.getItemSyukkaYoteiTdkYmd();

        if (_this.pt125Init.siteFlg == 1) {
            //BtoB Site.
            if (_this.pt125Init.kokyakuSeikyuKubun == '1') {
                _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] != "6");
            } else if (_this.pt125Init.kokyakuSeikyuKubun == '2') {
                _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] != "6" && kessaiCd['KEY'] != "13");
            } else if (_this.pt125Init.kokyakuSeikyuKubun == '0') {
                _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] == '6');
            } else {
                _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList;
            }
        }

        // アレルギー物質情報作成
        if (_this.pt125Init.productInfo.ALLERGEN_KBN && _this.pt125Init.productInfo.ALLERGEN_DISP_KBN == '1') {
            var allergenList = _this.pt125Init.productInfo.ALLERGEN_KBN.split(',');

            for (var i = 0; i < _this.pt125Init.allergyMaterialList.length; i++) {
                for (var j = 0; j < allergenList.length; j++) {
                    if (_this.pt125Init.allergyMaterialList[i].KEY == allergenList[j]) {
                        _this.allergenStr = _this.allergenStr + _this.pt125Init.allergyMaterialList[i].VALUE + '、';
                        break;
                    }
                }
            }
            if (_this.allergenStr.length > 0) {
                _this.allergenStr = _this.allergenStr.slice(0, -1);
            }
        }

        // スペック情報の取得
        for (var i = 0; i < 10; i++) {
            if (_this.pt125Init.productInfo['SPEC_TITLE' + (i + 1)] || _this.pt125Init.productInfo['SPEC_DTL' + (i + 1)]) {
                _this.specDispFlg = 1;
                break;
            }
        }

        if (common.stringNvl(_this.pt125Init.cardNoDisp) != '') {
            _this.pt125ReqModel.cardFlg = '1';//old card
            _this.showNowCardFlg = 0;
        } else {
            _this.pt125ReqModel.cardFlg = '0';//new card
            _this.showNowCardFlg = 1;
        }

        // 初期値を最初の決済にする
        if (common.isNullItem(_this.siharaiHohoKbn) || _this.siharaiHohoKbn == "993") {
            _this.pt125ReqModel.realAuthoriFlg = _this.sh050SiharaiHohoKbnList[0].REAL_AUTHORI_KBN;
            _this.pt125ReqModel.kessaiCompKbn = common.stringNvl(_this.sh050SiharaiHohoKbnList[0].KESSAI_COMP_KBN);
            _this.siharaiHohoKbn = _this.sh050SiharaiHohoKbnList[0].KEY;
            _this.pt125ReqModel.kessaiCd = _this.siharaiHohoKbn;
        }

        //Amazon Pay
        if (!common.isNullItem(_this.amazonCheckoutSessionId) && _this.pt125Init.amazonPayFlg == 1) {
            _this.selectSiharaiHoho(_this.Constants.KESSAI_AMAZONPAY);
        }
        //AmazonPay 決済の場合
        if (sessionStorage['pt125ReqModel']) {
            _this.pt125ReqModel = JSON.parse(sessionStorage['pt125ReqModel']);
            sessionStorage.removeItem('pt125ReqModel');
        }
        if (sessionStorage['doAmazonPayComplete']) {
            sessionStorage.removeItem('doAmazonPayComplete');
            _this.$emit("event-loading", true);
            _this.$nextTick(() => {
                _this.doOrder();
            });
        }
        //
        //jas 3d
        if (_this.jasApiSeqNo) {
            _this.is3DLoding = true;
            _this.getJasApiInfo();
        }

        //gmo 3d
        if (_this.gmo2AuthAccessID) {
            _this.is3DLoding = true;
            _this.doGmo2Order();
        }

        //sbp 3d
        if (_this.sbpEmv3dsStatus) {
            if (sessionStorage['sbp_pt125ReqModel']) {
                _this.pt125ReqModel = Object.assign({}, _this.pt125ReqModel, JSON.parse(sessionStorage['sbp_pt125ReqModel']));
            }
            sessionStorage.removeItem('sbp_pt125ReqModel');

            if (sessionStorage['sbp_ccdd']) {
                _this.pt125ReqModel.resSbpCustId = sessionStorage['sbp_ccdd'];
            }
            sessionStorage.removeItem('sbp_ccdd');

            if (_this.sbpEmv3dsStatus == 'ok' && _this.sbpTdsAuthenticationId) {
                _this.is3DLoding = true;
                _this.pt125ReqModel.tdsAuthenticationId = _this.sbpTdsAuthenticationId;

                _this.doOrder();
            } else {
                //SBペイメントの3DS認証要求NG
                if (_this.sbpEmv3dsStatus == 'ng') {
                    _this.is3DLoding = true;

                    _this.listMessValid.push(_this.$i18n.t('pt125.messages.sbp3dsNgMsg'));
                    EventBus.$emit('message', {});
                    common.scrollTop();
                }
                _this.is3DLoding = false;
            }
            _this.sbpEmv3dsStatus = '';
        }

        //POPUPを閉じるイベント
        EventBus.$on('closed', function () {
            _this.isModalShow = false;
        });
    },
    watch: {
        pt125Init: {
            handler(value) {
                this.syncPt125InitState(value);
            },
            deep: true,
            immediate: true,
        },
        pt125ReqModel: {
            handler(value) {
                this.syncPt125ReqModelState(value);
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        ...mapMutations('pt125', {
            commitSetPt125Init: 'SET_PT125_INIT',
            commitSetPt125ReqModel: 'SET_PT125_REQ_MODEL'
        }),
        syncPt125InitState(payload) {
            this.commitSetPt125Init(Object.assign({}, payload));
        },
        syncPt125ReqModelState(payload) {
            this.commitSetPt125ReqModel(Object.assign({}, payload));
        },
        /*
        * 初期処理
        */
        doinit() {
            var _this = this;
            _this.site = _this.$router.history.current.fullPath.split("/")[1];
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_INIT, _this.pt125ReqModel).then(function (response) {
                _this.pt125Init = response.data;
                _this.customFlg = response.data.customFlg;
                _this.securitySbp3DFlg = response.data.securitySbp3DFlg;

                // カラーサイズリストが存在する場合に表示
                if (_this.getLengthObj(_this.pt125Init.colSizList) > 0) {
                    for (var i = 0; i < _this.pt125Init.colSizList.length; i++) {
                        var colSize = _this.pt125Init.colSizList[i];
                        if (colSize.VALUE != '' && colSize.VALUE != undefined) {
                            // カラーサイズ表示フラグON
                            _this.pt125Init.colorSizeFlg = true;
                        } else {
                            _this.pt125Init.colorSizeFlg = false;
                        }
                    }
                }

                _this.pt125ReqModel = Object.assign({}, _this.pt125ReqModel, response.data.reqModel);
                _this.descriptionInfo = _this.pt125Init.descriptionInfo;
                _this.pt400DescriptionInfo = _this.pt125Init.pt400DescriptionInfo;
                _this.sh030DescriptionInfo = _this.pt125Init.sh030DescriptionInfo;
                _this.sh050DescriptionInfo = _this.pt125Init.sh050DescriptionInfo;
                _this.sh060DescriptionInfo = _this.pt125Init.sh060DescriptionInfo;
                _this.sh050SiharaiHohoKbnList = _this.pt125Init.resultSiharaiHohoKbnList;

                // 商品カテゴリ名をセット
                if (_this.pt125Init.productInfo != undefined) {
                    if (_this.pt125Init.productInfo.CATEGORY_NM != undefined && _this.pt125Init.productInfo.CATEGORY_NM != null && _this.pt125Init.productInfo.CATEGORY_NM != '') {
                        _this.navListCustom = [{ "CATEGORY_NM": _this.pt125Init.productInfo.CATEGORY_NM, "CATEGORY_CD": _this.pt125Init.productInfo.CATEGORY_CD }];
                    }
                }
                if (_this.pt125ReqModel.optionGroupList != null || _this.pt125ReqModel.optionList != null) {
                    for (var i = 0; i < _this.pt125ReqModel.optionGroupList.length; i++) {
                        if (_this.pt125ReqModel.optionGroupList[i].REQUIRED_FLG == 0) {
                            for (var j = 0; j < _this.pt125ReqModel.optionList.length; j++) {
                                _this.pt125ReqModel.optionGroupList[i].OPTION_VALUE2 = _this.pt125ReqModel.optionList[0].OPTION_VALUE;
                            }
                        }
                    }
                }
            }).catch(function (error) {
                common.errorAPI(error);
            });
            //get url location
            _this.urlLocation = window.location.href;
        },
        showModal() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + "/getShipYotei", _this.pt125ReqModel).then(function (response) {
                if (response.data && response.data.inventoryItemModelLst) {
                    _this.tableData = response.data.inventoryItemModelLst;
                    _this.selectedShouhinLst = response.data.itemNmLst;
                    var shouhin = response.data.colSizList.find(item => item['KEY'] === _this.pt125ReqModel.sItemNo);
                    _this.selectedShouhin = shouhin ? shouhin['VALUE'] : response.data.itemNmLst[0];
                    _this.isModalVisible = true;
                    _this.note = response.data.memo;
                }
            })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },
        /*
        * AmazonPay初期処理
        */
        doAmazonPayInit() {
            var _this = this;
            if (_this.amazonPayInited) {
                return;
            }
            //Amazon Pay
            var fullPath = window.location.href;

            // 画面上部にAmazonPayボタンを表示(0だったら非表示)
            if (_this.pt125Init.amazonPayFlg == '1') {
                var reqModel = {};
                reqModel.amazonCheckoutSessionId = _this.amazonCheckoutSessionId;
                reqModel.selfFullPath = fullPath;
                reqModel.ajaxKbn = '1';
                _this.$emit("event-loading", true);
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_AJAX, reqModel).then(function (response) {
                    _this.$emit("event-loading", false);
                    if (response.data.status == 'OK') {
                        _this.pt125Init.ampMerchantId = response.data.response.ampMerchantId;
                        _this.pt125Init.ampPayloadJson = response.data.response.ampPayloadJson;
                        _this.pt125Init.ampSignature = response.data.response.ampSignature;
                        _this.pt125Init.ampPublicKeyId = response.data.response.ampPublicKeyId;
                        _this.pt125Init.ampPaymentDescriptor = response.data.response.ampPaymentDescriptor;
                        $('#ampPaymentDescriptor').text(_this.pt125Init.ampPaymentDescriptor);
                        $('#ampPaymentUserNm').text(response.data.response.ampPaymentUserNm);
                        // Dynamically load the Amazon Pay SDK script
                        const script = document.createElement('script');
                        script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                        script.async = true;
                        document.head.appendChild(script);
                        // Wait for the script to be loaded before rendering the button
                        script.onload = () => {
                            _this.amazonPayInited = true;
                            // Check if the AmazonPay object is available
                            amazon.Pay.renderButton('#AmazonPayButton', {
                                // set checkout environment
                                merchantId: _this.pt125Init.ampMerchantId,
                                ledgerCurrency: 'JPY',
                                // customize the buyer experience
                                checkoutLanguage: 'ja_JP',
                                productType: 'PayAndShip',
                                placement: 'Checkout',
                                buttonColor: 'Gold',
                                // configure Create Checkout Session request
                                createCheckoutSessionConfig: {
                                    payloadJSON: _this.pt125Init.ampPayloadJson,
                                    signature: _this.pt125Init.ampSignature,
                                    publicKeyId: _this.pt125Init.ampPublicKeyId
                                }
                            });

                            //変更
                            amazon.Pay.bindChangeAction('#changeAmazonPay', {
                                amazonCheckoutSessionId: _this.amazonCheckoutSessionId,
                                changeAction: 'changeAddress'
                            });
                        };
                    }
                }).catch(function (error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                });
            }
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        getItemSyukkaYoteiTdkYmd: async function () {
            var _this = this;
            //_this.pt125Init.syukkaYoteiDate = await commonEc.getItemSyukkaYoteiTdkYmd();
            _this.$forceUpdate();
        },
        /**
         * カート登録
         * order products
         */
        pt125doOrder: function (processNo) {
             var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            if (processNo == 0) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18, fromCart: 3 } });
                return;
            }
            // カラーサイズチェック
            if (_this.pt125Init.colorSizeFlg && _this.pt125ReqModel.colSzSItemNo == "" || _this.pt125Init.colorSizeFlg && _this.pt125ReqModel.colSzSItemNo == undefined) {
                alert(_this.$i18n.t("common.messages.colorSizeCheck"));
                return;
            } else if (_this.pt125Init.colorSizeFlg) {
                _this.pt125ReqModel.sItemNo = _this.pt125ReqModel.colSzSItemNo;
            }
            var itemCheckFlg = _this.pt125Init.itemCheckFlg;
            var itemCnt = _this.pt125Init.itemCnt;
            var message1 = _this.$i18n.t('pt125.labels.itemCntCheck[0]');
            var message2 = _this.$i18n.t('pt125.labels.itemCntCheck[1]');
            common.clearMessageEcSite(_this.listIdErr, _this.PT125_PART);
            if (_this.pt125Init.productInfo.NEBIKI_PRICE) {
                _this.pt125ReqModel.wariPrice = _this.pt125Init.productInfo.NEBIKI_PRICE;
            } else {
                if (_this.pt125Init.productInfo.TAX_KBN == 1) {
                    _this.pt125ReqModel.wariPrice = _this.pt125Init.productInfo.SALE_ZEI_K_TNK;
                } else {
                    _this.pt125ReqModel.wariPrice = _this.pt125Init.productInfo.SALE_TNK;
                }
            }

            _this.pt125ReqModel.cartAddKbn = _this.pt125Init.productInfo.CART_ADD_KBN;
            _this.pt125ReqModel.qtyMin = _this.pt125Init.qtyMin;
            // カート内同一商品チェック
            if (itemCheckFlg == 1 && itemCnt > 0) {
                if (confirm(message1 + "\n" + message2)) {
                    //なにもしない
                } else {
                    return;
                }
            }
            //定期購入フラグ／0:通常商品として購入 1:定期商品として購入
            _this.pt125ReqModel.teikiKounyuuFlg = 0;
            if (processNo == -1) {
                _this.pt125ReqModel.teikiKounyuuFlg = 1;
            }
            //まとめ買い割引フラグ／0:なし 1:あり
            _this.pt125ReqModel.matomeFlg = 0;
            if (processNo == 3) {
                _this.pt125ReqModel.matomeFlg = 1;
            }
            
			_this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_ORDER, _this.pt125ReqModel).then(function (response) {
                _this.$emit("event-loading", false);
                if (response.data.status == 'OK') {
                    // カートへ入れるだけの場合は遷移しない
                    if (processNo == 2) {
                        _this.msgConfirm = _this.pt125Init.productInfo.WEB_ITEM_NM + _this.$i18n.t("pt110.labels.Order");
                        toastr.success(_this.msgConfirm);
                        _this.$emit('evt-change-quantily');
                        return;
                    }
                    var backPageNo = _this.backPageNo;
                    var categoryCd = _this.categoryCd;
                    var ptPageNo = _this.ptPageNo;
                    var ptPageSize = _this.ptPageSize;
                    var searchItemNm = _this.searchItemNm;
                    var itemNmOnly = _this.itemNmOnly;
                    var priceS = _this.priceS;
                    var priceE = _this.priceE;
                    var allergyMaterialKbn = _this.allergyMaterialKbn;
                    _this.$router.push({
                        name: _this.SiteConstants.PG010MAIN, query: { pageNo: 16 }, params: {
                            backPageNo: backPageNo
                            , categoryCd: categoryCd, ptPageNo: ptPageNo, ptPageSize: ptPageSize
                            , searchItemNm: searchItemNm, itemNmOnly: itemNmOnly, priceS: priceS, priceE: priceE, allergyMaterialKbn: allergyMaterialKbn
                        }
                    });
                }
            }).catch(function (error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if (error != null && error != undefined) {
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.PT125_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                //alert(resultValid.mapMsg[0].mess);
                                _this.errorMsg = resultValid.mapMsg[0].mess;
                                _this.isErrorAlert = true;
                                _this.isButtonCancel = false;
                                _this.isButtonOK = true;
                                return;
                            }
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /**
         * 関連注文商品情報取得
         * order products
         */
        pt125doKanrenOrder: function (itemCd, buttonKbn) {
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];

            //関連注文商品
            _this.pt125ReqModel.sMotoItemNo = _this.pt125ReqModel.sItemNo;
            _this.pt125ReqModel.sItemNo = itemCd;

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_SEARCH, _this.pt125ReqModel).then(function (response) {
                _this.kanrenItemInfo = response.data;

                // カラーサイズリストが存在する場合に表示
                if (_this.getLengthObj(_this.kanrenItemInfo.colSizList) > 0) {
                    for (var i = 0; i < _this.kanrenItemInfo.colSizList.length; i++) {
                        var colSize = _this.kanrenItemInfo.colSizList[i];
                        if (colSize.VALUE != '' && colSize.VALUE != undefined) {
                            // カラーサイズ表示フラグON
                            _this.KanrenColorSizeFlg = true;
                        } else {
                            _this.KanrenColorSizeFlg = false;
                        }
                    }
                }
                _this.pt125doKanrenOrderInsert(itemCd, buttonKbn);
            }).catch(function (error) {
                common.errorAPI(error);
            });
        },
        /**
         * カート登録
         * order products
         */
        pt125doKanrenOrderInsert: function (itemCd, buttonKbn) {
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];



            // カラーサイズチェック
            if (_this.KanrenColorSizeFlg && _this.pt125ReqModel.sItemNo == "" || _this.KanrenColorSizeFlg && _this.pt125ReqModel.sItemNo == undefined) {
                alert(_this.$i18n.t("common.messages.colorSizeCheck"));
                return;
            }

            var itemCheckFlg = _this.pt125Init.itemCheckFlg;
            var itemCnt = _this.pt125Init.itemCnt;
            var message1 = _this.$i18n.t('pt125.labels.itemCntCheck[0]');
            var message2 = _this.$i18n.t('pt125.labels.itemCntCheck[1]');
            common.clearMessageEcSite(_this.listIdErr, _this.PT125_PART);
            if (_this.kanrenItemInfo.productInfo.NEBIKI_PRICE) {
                _this.pt125ReqModel.wariPrice = _this.kanrenItemInfo.productInfo.NEBIKI_PRICE;
            } else {
                if (_this.kanrenItemInfo.productInfo.TAX_KBN == 1) {
                    _this.pt125ReqModel.wariPrice = _this.kanrenItemInfo.productInfo.SALE_ZEI_K_TNK;
                } else {
                    _this.pt125ReqModel.wariPrice = _this.kanrenItemInfo.productInfo.SALE_TNK;
                }
            }

            // カート追加区分はnullにし、再取得対象とする。
            _this.pt125ReqModel.cartAddKbn = null;
            _this.pt125ReqModel.qtyMin = _this.pt125Init.qtyMin;
            // カート内同一商品チェック
            if (itemCheckFlg == 1 && itemCnt > 0) {
                if (confirm(message1 + "\n" + message2)) {
                    //なにもしない
                } else {
                    return;
                }
            }
            //定期購入フラグ／0:通常商品として購入 1:定期商品として購入
            _this.pt125ReqModel.teikiKounyuuFlg = 0;
            //まとめ買い割引フラグ／0:なし 1:あり
            _this.pt125ReqModel.matomeFlg = 0;

            _this.$emit("event-loading", true);
            if (buttonKbn == 0) {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_ORDER, _this.pt125ReqModel).then(function (response) {
                    _this.$emit("event-loading", false);
                    if (response.data.status == 'OK') {
                        var backPageNo = _this.backPageNo;
                        var categoryCd = _this.categoryCd;
                        var ptPageNo = _this.ptPageNo;
                        var ptPageSize = _this.ptPageSize;
                        var searchItemNm = _this.searchItemNm;
                        var itemNmOnly = _this.itemNmOnly;
                        var priceS = _this.priceS;
                        var priceE = _this.priceE;
                        var allergyMaterialKbn = _this.allergyMaterialKbn;
                        _this.$router.push({
                            name: _this.SiteConstants.PG010MAIN, query: { pageNo: 16 }, params: {
                                backPageNo: backPageNo
                                , categoryCd: categoryCd, ptPageNo: ptPageNo, ptPageSize: ptPageSize
                                , searchItemNm: searchItemNm, itemNmOnly: itemNmOnly, priceS: priceS, priceE: priceE, allergyMaterialKbn: allergyMaterialKbn
                            }
                        });
                    }
                }).catch(function (error) {
                    _this.$emit("event-loading", false);
                    // eslint-disable-next-line
                    if (error != null && error != undefined) {
                        if (error.response != null && error.response != undefined) {
                            if (406 == error.response.status) {
                                var resultValid = common.excuteValidationEcSite(error, _this.PT125_PART);
                                if (resultValid) {
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    //alert(resultValid.mapMsg[0].mess);
                                    _this.errorMsg = resultValid.mapMsg[0].mess;
                                    _this.isErrorAlert = true;
                                    _this.isButtonCancel = false;
                                    _this.isButtonOK = true;
                                    return;
                                }
                            } else {
                                common.errorAPI(error);
                            }
                        }
                    }
                });
            } else {
                _this.$router.push({ name: _this.SiteConstants.PG030, params: { pageNo: 3, sItemNo: itemCd } });
            }

        },
        /*
        * まとめ買い割引詳細画面へ
        */
        showMatomeDetail: function (product) {
            var _this = this;
            var matomeCd = product.MATOME_CD;
            _this.$emit("event-loading", true);
            var ptPageNo = _this.ptPageNo;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 27, matomeCd: matomeCd, backPageNo: ptPageNo } });
        },
        /**
         * add favorite for product
         * @param {String} sItem, sitem
         */
        pt125favorites: function () {
            var _this = this;
            _this.$emit("event-loading", true);
            //doFavourite
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_FAVORITE, _this.pt125ReqModel).then(function (response) {
                if (response.data.isLogin == false) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18 } });
                } else {
                    // ボタンを解除ボタンに切り替える
                    _this.pt125Init.favoritesList = [{}];
                    var webItemNm = _this.pt125Init.productInfo ? _this.pt125Init.productInfo.WEB_ITEM_NM : '';
                    toastr.success(webItemNm + _this.$i18n.t('pt110.labels.favouriteAdd'));
                }
                _this.$emit("event-loading", false);
            }).catch(function (error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /*
        * お気に入り解除
        */
        pt125removeFavorites: function () {
            var _this = this;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_DELETE, { sItemNo: _this.pt125ReqModel.sItemNo }).then(function (response) {
                if (response.data.isLogin == false) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18 } });
                } else {
                    // ボタンを追加ボタンに切り替える
                    _this.pt125Init.favoritesList = [];
                    var webItemNm = _this.pt125Init.productInfo ? _this.pt125Init.productInfo.WEB_ITEM_NM : '';
                    toastr.success(webItemNm + _this.$i18n.t('pt110.labels.favouriteDel'));
                }
                _this.$emit("event-loading", false);
            }).catch(function (error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /*
        * カラーサイズ変更処理
        */
        // 子コンポーネントにて、pt125ReqModel を更新する
        getColSize: function (data) {
            var _this = this;
            if (_this.pt125Init.variFlg == 1) {
                _this.pt125ReqModel.colSzSItemNo = data
                _this.pt125ReqModel.sItemNo = _this.pt125ReqModel.colSzSItemNo;
                _this.doinit();
            }
        },
        /*
        * お問合せ画面へ
        */
        pt125contact: function (_itemNm) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 4 }, params: { itemNm: _itemNm } });
        },
        /*
        * レビュー一覧画面へ
        */
        pt461reviewList: function (_itemCd) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 83, itemCd: _itemCd } });
        },
        /**
         * format number value to currency value
         * @param {number} value, number to format
         */
        formatPrice: function (value) {
            return common.formatPrice(value);
        },
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function (obj) {
            if (obj != undefined)
                return common.getLengthObj(obj);
        },
        stepDown: function () {
            if (this.pt125ReqModel.buyCount > 1) {
                this.pt125ReqModel.buyCount = parseInt(this.pt125ReqModel.buyCount) - 1;
            } else if (this.pt125ReqModel.buyCount == '') {
                this.pt125ReqModel.buyCount = 1;
            }
        },
        stepUp: function () {
            if (this.pt125ReqModel.buyCount == '') {
                this.pt125ReqModel.buyCount = 1;
            } else {
                this.pt125ReqModel.buyCount = parseInt(this.pt125ReqModel.buyCount) + 1;
            }
        },
        /*
        * チェックが付いたら 会員ID重複チェックを行う
        */
        check: function () {
            var _this = this;

            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT125_PART);
            if (common.isNullItem(_this.pt125ReqModel.kokyakuCd)) {
                _this.pt125ReqModel.kaiinCheck = 2;
            } else {
                _this.$emit("event-loading", true);
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_CHECK, _this.pt125ReqModel).then(function (response) {
                    _this.pt125ReqModel.kaiinCheck = response.data;
                    // エラーがあった場合
                    if (response.data.errList != null && response.data.errList.length > 0) {
                        _this.displayWaring(response.data.errList);
                    }
                    _this.$emit("event-loading", false);
                }).catch(function (error) {
                    _this.$emit("event-loading", false);
                    if (error != null && error != undefined) {
                        if (error.response != null && error.response != undefined) {
                            if (406 == error.response.status) {
                                var resultValid = common.excuteValidationEcSite(error, _this.PT125_PART);
                                if (resultValid) {
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                    _this.pt125ReqModel.kaiinCheck = 1;
                                }
                                common.scrollTop();
                            } else {
                                common.errorAPI(error);
                            }
                        }
                    }
                });
            }
        },
        /*
        * 住所検索処理
        */
        addrAutoInput: function (tdkIndex) {
            var _this = this;
            _this.tdkIndex = tdkIndex;
            var zip = _this.pt125ReqModel.zip;

            if (_this.tdkIndex != 'kokyaku') {
                zip = _this.pt125ReqModel.tdkZip;
            }

            // 空の場合
            if (common.isNullItem(zip)) {
                if (_this.isModalShow != true) {
                    _this.isModalShow = true;
                }
                // 郵便番号は必須です。
                _this.msgConfirm = _this.$i18n.t('sh030.labels.zipCodeIsMandatory');
                _this.isButtonCancel = true;
                _this.isButtonOK = false;
                return;
            }
            var zipArr = zip.split("-");
            var zip1 = "";
            var zip2 = "";
            // 7桁以上の場合
            if (zip.length >= 7) {
                // ハイフンが含まれている場合
                if (zip.includes("-")) {
                    zip1 = zipArr[0];
                    zip2 = zipArr[1];
                    // 3桁-4桁でない場合はエラー
                    if (zip1.length != 3 && zip2.length != 4) {
                        _this.msgConfirm = _this.$t("sh030.labels.zipCodeDoesNotExist");
                        _this.isModalShow = true;
                        return;
                    }
                    // ハイフンが含まれていない場合
                } else {
                    zip1 = zip.substring(0, 3);
                    zip2 = zip.substring(3, 7);

                    _this.pt125ReqModel.zip = zip1 + "-" + zip2;
                }
            } else {
                return;
            }

            _this.cc212ReqModel.tdkZip1 = zip1;
            _this.cc212ReqModel.tdkZip2 = zip2;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.POPUP + _this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, _this.cc212ReqModel).then(function (response) {
                if (response.data.allAddr == 'juufuku') {
                    _this.dataCc212.propTdkZip1 = zip1;
                    _this.dataCc212.propTdkZip2 = zip2;
                    _this.cc212Dislay = true;
                }
                else {
                    _this.setAddr(response.data.allAddr, response.data.kenCd, response.data.kenNm, zip1, zip2);
                }
                _this.$emit("event-loading", false);
            }).catch(function (error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        // 住所検索Ajaxの戻り
        // パラメータの_addrに「住所,町名番地,建物名・部屋番号」の形で戻ってくる(30文字ずつ)
        setAddr: function (addr, kenCd, kenNm, zip1, zip2) {
            var _this = this;
            var sp = new Array("", "", "");
            if (addr) {
                sp = addr.split(",");
                var displayAddr = sp[0] == null ? '' : sp[0];
                displayAddr += sp[1] == null ? '' : sp[1];
                displayAddr += sp[2] == null ? '' : sp[2];

                if (_this.tdkIndex == 'kokyaku') {
                    //都道府県のプルダウンを使用しない場合
                    if (_this.pt125Init.kenPulldownDispFlg == 0) {
                        _this.pt125ReqModel.addr1 = kenNm + displayAddr;
                    } else {
                        _this.pt125ReqModel.addr1 = displayAddr;
                    }
                    _this.pt125ReqModel.kenCd = kenCd;
                    _this.pt125ReqModel.kenNm = kenNm;
                    _this.pt125ReqModel.zip = zip1 + "-" + zip2;
                } else {
                    //都道府県のプルダウンを使用しない場合
                    if (_this.pt125Init.kenPulldownDispFlg == 0) {
                        _this.pt125ReqModel.tdkAddr1 = kenNm + displayAddr;
                    } else {
                        _this.pt125ReqModel.tdkAddr1 = displayAddr;
                    }
                    _this.pt125ReqModel.tdkKenCd = kenCd;
                    _this.pt125ReqModel.tdkKenNm = kenNm;
                    _this.pt125ReqModel.tdkZip = zip1 + "-" + zip2;
                }
                _this.$forceUpdate();
            } else {
                if (_this.isModalShow != true) {
                    _this.isModalShow = true;
                }
                // 郵便番号が存在しません
                _this.msgConfirm = _this.$i18n.t('sh030.labels.zipCodeDoesNotExist');
                if (_this.tdkIndex == 'kokyaku') {
                    _this.pt125ReqModel.addr1 = '';
                    _this.pt125ReqModel.kenCd = '';
                    _this.pt125ReqModel.zip = '';
                } else {
                    _this.pt125ReqModel.tdkAddr1 = '';
                    _this.pt125ReqModel.tdkKenCd = '';
                    _this.pt125ReqModel.tdkZip = '';
                }
            }
        },
        setAddrValue: function (data) {
            var _this = this;
            var addr1 = data.addr.ALL_ADDR ? data.addr.ALL_ADDR : "";

            var kenCd = data.kenCd + "";
            if (_this.tdkIndex == 'kokyaku') {
                //都道府県のプルダウンを使用しない場合
                if (_this.pt125Init.kenPulldownDispFlg == 0) {
                    _this.pt125ReqModel.addr1 = addr1;
                } else {
                    _this.pt125ReqModel.addr1 = _this.outKenNm(kenCd, addr1);
                }
                _this.pt125ReqModel.kenCd = kenCd;
            } else {
                //都道府県のプルダウンを使用しない場合
                if (_this.pt125Init.kenPulldownDispFlg == 0) {
                    _this.pt125ReqModel.tdkAddr1 = addr1;
                } else {
                    _this.pt125ReqModel.tdkAddr1 = _this.outKenNm(kenCd, addr1);
                }
                _this.pt125ReqModel.tdkKenCd = kenCd;
            }
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },
        /*
        * 都道府県名を削除
        */
        outKenNm: function (kenCd, addr) {
            var kenList = this.pt125Init.kenCdList;
            for (var i = 0; kenList.length > i; i++) {
                if (kenList[i].KEY == kenCd) {
                    return addr.replace(kenList[i].VALUE, "");
                }
            }
        },
        /*
        * 自届先、別届先ラジオボタン選択時
        */
        radioClick: function () {
            this.tdkReset();
            this.$forceUpdate();
        },
        /*
        * 届先情報をリセット
        */
        tdkReset() {
            var _this = this;
            _this.pt125ReqModel.tdkNo = "0";
            _this.pt125ReqModel.tdkNm1 = "";
            _this.pt125ReqModel.tdkNm2 = "";
            _this.pt125ReqModel.tdkKana1 = "";
            _this.pt125ReqModel.tdkKana2 = "";
            _this.pt125ReqModel.tdkZip = "";
            _this.pt125ReqModel.tdkKenCd = "";
            _this.pt125ReqModel.tdkAddr1 = "";
            _this.pt125ReqModel.tdkAddr2 = "";
            _this.pt125ReqModel.tdkAddr3 = "";
            _this.pt125ReqModel.tdkTel = "";
            _this.pt125ReqModel.tdkMail1 = "";
            //    _this.pt125ReqModel.tdkNm1 = _this.pt125ReqModel.kokyakuNm1;
            //    _this.pt125ReqModel.tdkNm2 = _this.pt125ReqModel.kokyakuNm2;
            //    _this.pt125ReqModel.tdkKana1 = _this.pt125ReqModel.kokyakuKana1 ;
            //    _this.pt125ReqModel.tdkKana2 = _this.pt125ReqModel.kokyakuKana2;
        },
        /*
        * AmazonPay購入手続きへ処理
        */
        buyStepAmazon: function () {
            var _this = this;
            sessionStorage['pt125ReqModel'] = JSON.stringify(_this.pt125ReqModel);
        },
        changeAmazonAddress: function () {
            var _this = this;
            sessionStorage['pt125ReqModel'] = JSON.stringify(_this.pt125ReqModel);
        },
        // 支払い方法選択
        selectSiharaiHoho: async function (key) {
            var hasAmazonPay = false;
            for (var i = 0; i < this.sh050SiharaiHohoKbnList.length; i++) {
                if (this.sh050SiharaiHohoKbnList[i].KEY == this.Constants.KESSAI_AMAZONPAY) {
                    hasAmazonPay = true;
                }
                if (this.sh050SiharaiHohoKbnList[i].KEY == key) {
                    //_this.creditFlg = _this.sh050SiharaiHohoKbnList[i].REAL_AUTHORI_KBN==1?true:false;
                    this.pt125ReqModel.realAuthoriFlg = this.sh050SiharaiHohoKbnList[i].REAL_AUTHORI_KBN;
                    this.pt125ReqModel.kessaiCompKbn = common.stringNvl(this.sh050SiharaiHohoKbnList[i].KESSAI_COMP_KBN);
                }
            }
            this.pt125ReqModel.kessaiCd = key;
            this.siharaiHohoKbn = key;
            //Amazon Pay
            if (key == this.Constants.KESSAI_AMAZONPAY && hasAmazonPay && !this.amazonPayInited) {
                this.doAmazonPayInit();
            }
        },
        /*
        * カード保存フラグのセット
        */
        setCardSaveFlg: function () {
            // 定期商品フラグ
            if (this.pt125Init.teikiFlg == 1) {
                // クレジットの場合
                if (this.pt125Init.realAuthoriFlg == '1') {
                    this.pt125ReqModel.cardSaveFlg = 1;
                } else {
                    this.pt125ReqModel.cardSaveFlg = 0;
                }
            } else {
                if ($('#_card_save_flg').prop('checked')) {
                    this.pt125ReqModel.cardSaveFlg = 1;
                } else {
                    this.pt125ReqModel.cardSaveFlg = 0;
                }
            }
        },
        /*
        * isBunkatu:分割であるかどうか
        */
        isBunkatu(key) {
            if (this.pt125Init.payCntList.length > 0) {
                for (var i = 0; i < this.pt125Init.payCntList.length; i++) {
                    var item = this.pt125Init.payCntList[i];
                    if (key == item.KEY && '1' == item.PARAM_MARK) {
                        return true;
                    }
                }
            }
            return false;
        },

        chgCardPayCnt() {
            this.pt125ReqModel.lastBunkatuKaisu = '';
            if (this.isBunkatu(this.pt125ReqModel.lastCardPayCnt)) {
                this.pt125ReqModel.lastBunkatuKaisu = this.pt125Init.bunkatuKaisuList[0]['KEY'];
            }
        },
        chgCardPayModel() {
            this.pt125ReqModel.bunkatuKaisu = '';
            if (this.isBunkatu(this.pt125ReqModel.cardPayCnt)) {
                this.pt125ReqModel.bunkatuKaisu = this.pt125Init.bunkatuKaisuList[0]['KEY'];
            }
        },
        // フォーカスが外れた時、月を前０をセットする
        onBlurLimitMonth: function () {
            var limMonth = this.pt125ReqModel.limitMonth;
            this.pt125ReqModel.limitMonth = limMonth.padStart(2, "0");
        },
        // クレジット番号の4桁区切りでスペースを入れる処理
        onCredit: function () {
            var cardNo = this.pt125ReqModel.cardNoDisp;
            const regexp = /^(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,4})?$/;
            const digits = cardNo.replace(/[^0-9]/g, '');
            this.pt125ReqModel.cardNoDisp = [...regexp.exec(digits)].slice(1).filter(e => e).join(' ');
        },
        //新しいカードを使う
        showCloseNewCardArea: function (cardFlg) {
            this.showNowCardFlg = cardFlg;
        },

        /*
        * 注文確定処理(GMO 3DS2.0)
        */
        doGmo2Order: function () {
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT125_PART);
            _this.pt125ReqModel.gmo3DVer2Flg = _this.securityGmo3DFlg; //GMO 3D 2.0 セキュア利用フラグ
            _this.pt125ReqModel.gmo2AuthAccessID = _this.gmo2AuthAccessID;
            //_this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_INSERT, _this.pt125ReqModel).then(function (response) {
                if (response.data.respCode == _this.SHOW_ERR_PAGE) {
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError" });
                    _this.is3DLoding = false
                    return;
                }
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function () {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if (response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if (response.data.response != null) {
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('totalPointKin');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params: { message: message, orderCd: orderCd }, query: { pageNo: 23 } });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                _this.is3DLoding = false;
                if (error != null && error != undefined) {
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
            }).finally(function () {
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
            });
        },

        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        getItemSyukkaYoteiTdkYmd: async function () {
            var _this = this;
            _this.pt125Init.syukkaYoteiDate = await commonEc.getItemSyukkaYoteiTdkYmd();
            _this.$forceUpdate();
        },

        /*
        * 注文確定 ボタン押下処理
        */
        confirmDoSubmit: function () {
            // 同意ラジオボタン
            if (this.pt125ReqModel.agreeFlag != 1) {
                // 規約に同意いただける場合のみ注文することができます。
                this.msgConfirm = this.$i18n.t('pt125.messages.messg1')
                this.isModalShow = true;
                this.isButtonCancel = false;
                this.actionFlg = -1;
                return;
            }
            //AmazonPayチェック
            if (this.pt125ReqModel.kessaiCd == this.Constants.KESSAI_AMAZONPAY) {
                if (common.isNullItem(this.pt125Init.ampPaymentDescriptor) || common.isNullItem(this.amazonCheckoutSessionId)) {
                    this.msgConfirm = this.$i18n.t('pt125.messages.messgAmazonLogin');
                    this.isModalShow = true;
                    this.isButtonCancel = false;
                    this.actionFlg = -1;
                    return;
                }
            }
            //注文確定を行います。<br/>よろしいですか？
            this.msgConfirm = this.$i18n.t('pt125.messages.messg2')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 1;
        },
        /*
        *  注文確定 処理
        */
        doSubmit: function () {
            var _this = this;
            this.isModalShow = false;
            if (_this.actionFlg == -1) {
                return;
            }
            // 商品規格書ダウンロード時 未ログイン時のログイン画面遷移
            if (_this.actionFlg == -2) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18, fromCart: 3 } });
                return;
            }

            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT125_PART);

            //
            _this.pt125ReqModel.realAuthoriFlg = '0';
            _this.pt125ReqModel.kessaiCompKbn = '';
            if (_this.pt125ReqModel.kessaiCd == '1') {
                _this.pt125ReqModel.realAuthoriFlg = _this.pt125Init.realAuthoriFlg;
                _this.pt125ReqModel.kessaiCompKbn = _this.pt125Init.kessaiCompKbn;
            }
            _this.$emit("event-loading", true);
            //入力チェック、ワークテーブル作成、金額計算
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_CONFIRM, _this.pt125ReqModel).then(function (response) {
                _this.$emit("event-loading", false);
                // エラーがあった場合
                if (response.data.errList != null && response.data.errList.length > 0) {
                    _this.displayWaring(response.data.errList);
                }
                if (response.data.status == 'OK' && response.data.response != null && response.data.response != undefined && response.data.response.seikyuKin != null && response.data.response.seikyuKin != undefined) {
                    _this.pt125Init.seikyuKin = response.data.response.seikyuKin;//請求金額
                    _this.pt125ReqModel.seikyuKin = response.data.response.seikyuKin;//請求金額
                    if (_this.pt125ReqModel.kessaiCd == '993') {
                    }
                }

                if (response.data.status == 'OK') {
                    if (_this.pt125ReqModel.kessaiCd == '1') {
                        //与信処理
                        _this.doAuthorize();
                    } else if (_this.pt125ReqModel.kessaiCd == _this.Constants.KESSAI_AMAZONPAY) {
                        //AmazonPay Update
                        _this.doAmazonPayUpdate();
                    } else {
                        //注文作成
                        _this.doOrder();
                    }
                }
            }).catch(function (error) {
                _this.$emit("event-loading", false);
                if (error != null && error != undefined) {
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.PT125_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /**
         * AmazonPay与信処理
         *  成功後、画面遷移を行う
         */
        doAmazonPayUpdate: function () {
            var _this = this;
            _this.$emit("event-loading", true);
            //AmazonPay与信処理、金額設定
            _this.pt125ReqModel.ajaxKbn = '2';
            _this.pt125ReqModel.amazonCheckoutSessionId = _this.amazonCheckoutSessionId;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_AJAX, _this.pt125ReqModel).then(function (response) {
                // エラーがあった場合
                if (response.data.errList != null && response.data.errList.length > 0) {
                    _this.displayWaring(response.data.errList);
                }
                if (response.data.status == 'OK') {
                    _this.amazonPayRedirectUrl = response.data.response.amazonPayRedirectUrl;//URL
                    //画面遷移する前に、データを保存する
                    sessionStorage['pt125ReqModel'] = JSON.stringify(_this.pt125ReqModel);
                    sessionStorage['doAmazonPayComplete'] = '1';
                    window.location.href = _this.amazonPayRedirectUrl;
                }
                //_this.$emit("event-loading", false);
            }).catch(function (error) {
                //_this.$emit("event-loading", false);
                if (error != null && error != undefined) {
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.PT125_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /**
         * 与信処理
         *  成功後、注文作成を行う
         */
        doAuthorize: function () {
            var _this = this;
            //this.pt125Init.realAuthoriFlg == '1'
            if (this.pt125Init.kessaiCompKbn == 'JPF') {
                //Multipayment: call use api for pay method
                var cardNoDisp = common.stringNvl(this.pt125Init.cardNoDisp, '');
                var creditUser = '';
                var cardNo = "";
                var cardYm = "";
                if (cardNoDisp != "") {
                    cardNo = this.pt125Init.cardNoDisp;
                    cardYm = this.pt125Init.cardLimit;
                    creditUser = this.pt125Init.cardName;
                } else {
                    if (this.pt125Init.creditInpNumOption == 1) {
                        cardNo = this.pt125ReqModel.cardNoDisp;
                        if (cardNo != undefined) {
                            cardNo = cardNo.replaceAll(' ', '');
                        }
                    } else {
                        cardNo = this.pt125ReqModel.cardNoDisp1 + this.pt125ReqModel.cardNoDisp2 + this.pt125ReqModel.cardNoDisp3 + this.pt125ReqModel.cardNoDisp4;
                    }
                    cardYm = this.pt125ReqModel.limitYear + this.pt125ReqModel.limitMonth;
                    cardYm = this.pt125ReqModel.limitYear + this.pt125ReqModel.limitMonth;
                    if (this.pt125Init.cardNameOption == 1) {
                        creditUser = this.pt125ReqModel.cardNameNamae + this.pt125ReqModel.cardNameMyouji;
                    } else {
                        creditUser = this.pt125ReqModel.cardUserNm;
                    }
                }
                // URL get from database
                var apiUrl = this.pt125Init.tokenUrl;
                this.$loadScript(apiUrl).then(() => {
                    Multipayment.init(this.pt125Init.shopId);
                    Multipayment.getToken({
                        cardno: cardNo,
                        expire: cardYm,
                        securitycode: this.pt125ReqModel.cardSecurity,
                        holdername: creditUser
                    }, function (response) {
                        //this.someCallbackFunction(response);
                        if (response.resultCode != "000") {
                            _this.msgConfirm = this.$i18n.t('sh060.labels.erMessg');
                            _this.isModalShow = true;
                            _this.isButtonCancel = false;
                            return;
                        } else {
                            if (response.resultCode == "000") {
                                //予め購入フォームに用意した token フィールドに、値を設定
                                _this.pt125ReqModel.token = response.tokenObject.token;
                                _this.doOrder();
                                return true;
                            } else if (response.resultCode == 500) {
                                //document.getElementById("button").disabled ='';
                            }
                        }
                    }
                    );
                })
                    .catch(function (error) {
                        console.log(error);
                    });
                // GMOクレジットの場合  
            } else if (this.pt125Init.kessaiCompKbn == 'GMO' || this.pt125Init.kessaiCompKbn == "SGP") {
                this.doPurchase();
                // SMBCクレジットの場合
            } else if (this.pt125Init.kessaiCompKbn == 'SMBC') {
                this.doSmbc();
            } else if (this.pt125Init.kessaiCompKbn == 'EPS') {
                this.doEps();
                // JCSクレジットの新規カードの場合
            } else if (this.pt125ReqModel.cardFlg != '1' && this.pt125Init.kessaiCompKbn == 'JCS') {

                let _this = this;

                //セキュリティ3D 使用
                if (_this.security3DFlg == 1) {

                    let check = _this.doJac3DCheck();
                    if (check) {
                        _this.is3DLoding = false;
                        return false;
                    }

                    if (_this.pt125ReqModel.cardFlg == '1') {
                        //【既存会員・登録済み】 
                        _this.jcsMemberType = "2";
                    } else {
                        //【新規会員】
                        if (_this.pt125ReqModel.cardSaveFlg) {
                            // 【カード保存】 
                            _this.jcsMemberType = "1";
                        } else {
                            // 【カード保存しない】
                            _this.jcsMemberType = "0";
                        }
                    }
                    //要求処理（カード情報タンキング）
                    _this.doJasNewCardTaking(_this.jcsMemberType);
                } else {
                    // セッションの確認
                    //axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_CHECK).then(function(response) {
                    //    if(response.data.status === 'OK') {
                    //        _this.doJac();
                    //    } else {
                    //        //router to top page
                    //        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:1}});
                    //    }
                    //}).catch(function(error) {
                    //    _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                    //    _this.isModalShow = true;
                    //    _this.isButtonCancel = false;
                    //
                    //    EventBus.$on('evtClickOk', function() {
                    //        common.errorAPI(error);
                    //    });
                    //});
                    _this.doJac();
                }

                // JCSクレジットの前回と同じカードを使う
            } else if (this.pt125Init.realAuthoriFlg == '1' && this.pt125ReqModel.cardFlg == '1' && this.pt125Init.kessaiCompKbn == 'JCS') {
                let _this = this;

                //セキュリティ3D 使用
                if (_this.security3DFlg == 1) {
                    //【既存会員・登録済み】 
                    _this.jcsMemberType = "2";

                    _this.doJacCardInfo3D(_this.jcsMemberType);
                } else {
                    // 注文確定処理
                    _this.doOrder();
                }

                // SBPクレジットの場合
            } else if (this.pt125Init.realAuthoriFlg == '1' && this.pt125Init.kessaiCompKbn == 'SBP') {
                this.doSbp();
            } else if (this.pt125Init.realAuthoriFlg == '1' && this.pt125ReqModel.cardFlg != '1' && this.pt125Init.kessaiCompKbn == 'PAY') {
                this.doPayG();
                // クレジット以外の場合orderSucc
            } else {
                // 注文確定処理
                this.doOrder();
            }
        },
        getJasApiInfo: function () {
            let _this = this;
            _this.is3DLoding = true;

            let apiRequest = {
                seqNo: _this.jasApiSeqNo
            }
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_GET_JCS_NEW_CARD_API_INFO, apiRequest).then(function (response) {
                _this.jasApiResult = response.data;
                if (_this.jasApiResult) {
                    _this.jcsMemberType = _this.jasApiResult.apiType;
                    let tourokuKbn = _this.jasApiResult.tourokuKbn;

                    //データを戻る
                    _this.pt125ReqModel.cardFlg = _this.jasApiResult.cardFlg;
                    _this.pt125ReqModel.cardSaveFlg = _this.jasApiResult.cardSaveFlg;

                    _this.$nextTick(() => {
                        if (_this.pt125ReqModel.cardSaveFlg == '1') {
                            $('#_card_save_flg').prop('checked', true);
                        } else {
                            $('#_card_save_flg').prop('checked', false);
                        }

                        if (_this.pt125ReqModel.cardFlg == '1') {
                            $('#card_flg1').prop('checked', true);
                            $('#card_flg1').focus();
                        } else {
                            $('#card_flg0').prop('checked', true);
                            $('#card_flg0').focus();
                        }
                    });

                    _this.pt125ReqModel.approvalCode = _this.jasApiResult.approvalCode;
                    _this.pt125ReqModel.acqCode = _this.jasApiResult.acqCode;
                    if (_this.jasApiResult.apiType == "2") {
                        //【既存会員・登録済み】場合
                        _this.pt125ReqModel.cardSecurity = _this.jasApiResult.securityCode;
                        _this.pt125ReqModel.lastCardPayCnt = _this.jasApiResult.cardPayCnt;
                        _this.pt125ReqModel.lastBunkatuKaisu = _this.jasApiResult.bunkatuKaisu;
                        _this.pt125ReqModel.jaccs3DVer2NewFlg = 0;
                    }
                    else {
                        //【新規会員】場合
                        _this.pt125ReqModel.securityCode = "";
                        _this.pt125ReqModel.cardPayCnt = "";
                        _this.pt125ReqModel.bunkatuKaisu = "";
                        _this.pt125ReqModel.jaccs3DVer2NewFlg = 1;
                    }

                    if (_this.jasApiResult.errCode == "OLM-IT00000000") {
                        //要求処理（3D セキュア認証）
                        if (tourokuKbn == "p") {
                            _this.doJacCardInfo3D(_this.jcsMemberType);

                            //要求処理（都度購入）
                        } else if (tourokuKbn == "o" || tourokuKbn == "8") {

                            _this.doJacCardInfoOsori(_this.jcsMemberType);

                            //要求処理（都度購入）後
                        } else if (tourokuKbn == "k" || tourokuKbn == "n" || tourokuKbn == "W") {
                            if (tourokuKbn == "k" || tourokuKbn == "n") {
                                _this.orderSuccJas3D(_this.jasApiResult);
                            } else {
                                // 注文確定処理
                                _this.orderSuccJas3D(_this.jasApiResult);
                            }

                        }
                    } else {
                        //BlueGateエラーコードだったら、既存のオーソリ処理
                        let blueGateErrorList = new Array("S102000E", "S102000F", "S102000W", "S2023DA0");
                        if (blueGateErrorList.indexOf(_this.jasApiResult.bgErrCode) >= 0) {
                            _this.security3DFlg = 0;
                            //【既存会員・登録済み】場合
                            if (_this.jasApiResult.apiType == "2") {
                                _this.pt125ReqModel.cardSecurity = _this.jasApiResult.securityCode;
                                _this.pt125ReqModel.lastCardPayCnt = _this.jasApiResult.cardPayCnt;
                                _this.pt125ReqModel.lastBunkatuKaisu = _this.jasApiResult.bunkatuKaisu;

                                _this.pt125ReqModel.securityCode = "";
                                _this.pt125ReqModel.cardPayCnt = "";
                                _this.pt125ReqModel.bunkatuKaisu = "";

                                if (_this.pt125Init.teikiAddFlg == '1') {
                                    _this.doOrder();
                                } else {
                                    _this.doSubmit();
                                }
                            } else {
                                _this.listMessValid = [];
                                _this.listMessValid.push(_this.$i18n.t('sh060.messages.jcsApiToOldError'));
                                if (_this.listMessValid.length > 0) {
                                    _this.is3DLoding = false;
                                    EventBus.$emit('message', {});
                                    common.scrollTop();
                                }
                            }
                        } else {
                            _this.listMessValid = [];
                            // 決済処理時にエラーが発生しました。入力内容をご確認の上、再度ご入力いただくか、決済方法を変更してください。
                            _this.listMessValid.push(_this.pt125Init.jcsKessaiErrMsg);
                            if (_this.listMessValid.length > 0) {
                                _this.is3DLoding = false;
                                EventBus.$emit('message', {});
                                common.scrollTop();
                            }
                        }
                    }
                }
            }).catch(function (error) {
                _this.is3DLoding = false;
                common.errorAPI(error);
            }).finally(function () {
            });
        },
        sendDateJas: function () {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year.toString() + month.toString() + strDate.toString();
            return currentdate;
        },
        sendTimeJas: function () {
            var date = new Date();
            var hh = date.getHours();
            var mm = date.getMinutes();
            var ss = date.getSeconds();
            if (hh >= 0 && hh <= 9) {
                hh = "0" + hh;
            }
            if (mm >= 0 && mm <= 9) {
                mm = "0" + mm;
            }
            if (ss >= 0 && ss <= 9) {
                ss = "0" + ss;
            }
            var currentTime = hh.toString() + mm.toString() + ss.toString();
            return currentTime;
        },
        panJas: function () {
            var cardNo;
            if (this.pt125ReqModel.cardFlg == '1') {
                return this.pt125Init.cardNoDisp;
            } else {
                if (this.pt125Init.creditInpNumOption == 1) {
                    cardNo = this.pt125ReqModel.cardNoDisp;
                    if (cardNo != undefined) {
                        cardNo = cardNo.replaceAll(' ', '');
                    }
                    return cardNo;
                } else {
                    cardNo = this.pt125ReqModel.cardNoDisp1 + this.pt125ReqModel.cardNoDisp2 + this.pt125ReqModel.cardNoDisp3 + this.pt125ReqModel.cardNoDisp4
                    return cardNo;
                }
            }
        },
        expiryDateJas: function () {
            if (this.pt125ReqModel.cardFlg == '1') {
                return this.pt125Init.cardLimit;
            } else {
                return this.pt125ReqModel.limitMonth + this.pt125ReqModel.limitYear;
            }
        },
        securityCodeJas: function () {
            if (this.pt125ReqModel.cardFlg == 1) {
                return this.pt125ReqModel.cardSecurity;
            } else {
                if (this.pt125Init.securityCodeUseFlg) {
                    return this.pt125ReqModel.securityCode;
                }
            }
        },
        cardPayCntJas: function () {
            if (this.pt125ReqModel.cardFlg == 1) {
                return this.pt125ReqModel.lastCardPayCnt;
            } else {
                return this.pt125ReqModel.cardPayCnt;
            }
        },
        bunkatuKaisuJas: function () {
            if (this.pt125ReqModel.cardFlg == 1) {
                return this.pt125ReqModel.lastBunkatuKaisu;
            } else {
                return this.pt125ReqModel.bunkatuKaisu;
            }
        },
        /*
        * 3D カード情報タンキング
        */
        doJasNewCardTaking: function (apiType) {
            let _this = this;
            let tourokuKbn = "p";
            _this.is3DLoding = true;
            //_this.$emit("event-loading", true);

            //【新規会員・登録なし】
            if (apiType == '0') {
                tourokuKbn = "p";
                //【新規会員・登録あり】
            } else if (apiType == '1') {
                tourokuKbn = "p";
            }
            _this.jasNewCardTaking.memberType = apiType;
            _this.jasNewCardTaking.tourokuKbn = tourokuKbn;
            _this.jasNewCardTaking.merchantId = _this.pt125Init.merchantId;
            _this.jasNewCardTaking.senddate = _this.sendDateJas();
            _this.jasNewCardTaking.sendtime = _this.sendTimeJas();
            _this.jasNewCardTaking.pan = _this.panJas();
            _this.jasNewCardTaking.expiryDate = _this.expiryDateJas();
            _this.jasNewCardTaking.cardKbn = "9";
            //_this.jasNewCardTaking.backUrl = process.env.VUE_APP_API_URL + _this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_JCS_3D_POST_BACK;
            _this.jasNewCardTaking.backUrl = _this.pt125Init.back3DUrl;
            _this.jasNewCardTaking.resultUrl = "";
            _this.jasNewCardTaking.optionalAreaName1 = "coNo";
            _this.jasNewCardTaking.optionalAreaValue1 = _this.pt125Init.coNo;
            _this.jasNewCardTaking.optionalAreaName2 = "kessaiCd";
            _this.jasNewCardTaking.optionalAreaValue2 = _this.pt125Init.kessaiCd;
            _this.jasNewCardTaking.optionalAreaName3 = "apiType";
            _this.jasNewCardTaking.optionalAreaValue3 = apiType;
            _this.jasNewCardTaking.optionalAreaName4 = "pageNo";
            _this.jasNewCardTaking.optionalAreaValue4 = _this.curPage + "?pageNo=" + this.currPageNo;

            _this.jasNewCardTaking.optionalAreaName5 = "securityCode";
            _this.jasNewCardTaking.optionalAreaValue5 = _this.securityCodeJas();
            _this.jasNewCardTaking.optionalAreaName6 = "cardPayCnt";
            _this.jasNewCardTaking.optionalAreaValue6 = _this.cardPayCntJas();
            _this.jasNewCardTaking.optionalAreaName7 = "bunkatuKaisu";
            _this.jasNewCardTaking.optionalAreaValue7 = _this.bunkatuKaisuJas();
            _this.jasNewCardTaking.optionalAreaName8 = "cardFlg";
            _this.jasNewCardTaking.optionalAreaValue8 = _this.pt125ReqModel.cardFlg;
            _this.jasNewCardTaking.optionalAreaName9 = "cardSaveFlg";
            _this.jasNewCardTaking.optionalAreaValue9 = _this.pt125ReqModel.cardSaveFlg;
            _this.jasNewCardTaking.optionalAreaName10 = "expiryDate";
            _this.jasNewCardTaking.optionalAreaValue10 = _this.expiryDateJas();


            _this.jasNewCardTaking.shopID = _this.pt125Init.bgShopId;
            _this.jasNewCardTaking.msgDigest = "";

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_NEW_CARD_INFO_TAKING_MSGDIGEST, _this.jasNewCardTaking).then(function (response) {
                _this.jasNewCardTaking.msgDigest = response.data;
                _this.$refs.formJasTaking.msgDigest.value = _this.jasNewCardTaking.msgDigest;

                //post
                _this.$refs.formJasTaking.submit();

            }).catch(function (error) {
                _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                _this.isModalShow = true;
                _this.isButtonCancel = false;
                _this.is3DLoding = false;
                EventBus.$on('evtClickOk', function () {
                    common.errorAPI(error);
                });
            }).finally(function () {
                //_this.$emit("event-loading", true);
            });
        },

        /*
        * 3D セキュア認証
        */
        doJacCardInfo3D: function (apiType) {
            let _this = this;
            let tourokuKbn = "";
            let merchantId = "";
            let cardPassword = "";
            let dbKey1 = "";
            _this.is3DLoding = true;

            //【新規会員・登録なし】
            if (apiType == '0') {
                tourokuKbn = "o";
                merchantId = _this.jasApiResult.merchantId;
                cardPassword = _this.jasApiResult.cardPassword;
                dbKey1 = _this.jasApiResult.dbKey1;

                //【新規会員・登録あり】
            } else if (apiType == '1') {
                tourokuKbn = "o";
                merchantId = _this.jasApiResult.merchantId;
                cardPassword = _this.jasApiResult.cardPassword;
                dbKey1 = _this.jasApiResult.dbKey1;

                //【既存会員・登録済み】 
            } else if (apiType == '2') {
                tourokuKbn = "8";
                merchantId = _this.pt125Init.merchantId;
                cardPassword = _this.pt125Init.cardPassword;
                dbKey1 = _this.pt125Init.oldDbKey;
            }

            _this.jasNewCard3D.memberType = apiType;
            _this.jasNewCard3D.tourokuKbn = tourokuKbn;
            _this.jasNewCard3D.merchantId = merchantId;
            _this.jasNewCard3D.cardPassword = cardPassword;
            _this.jasNewCard3D.dbKey1 = dbKey1;
            _this.jasNewCard3D.orderNum = _this.pt125Init.orderNum;
            _this.jasNewCard3D.amount = _this.pt125Init.seikyuuKin;
            if (_this.pt125Init.orderInfo['TOTAL_SEIKYU_TAX']) {
                _this.jasNewCard3D.amount = _this.pt125Init.seikyuuKin - _this.pt125Init.orderInfo['TOTAL_SEIKYU_TAX'];
            }
            _this.jasNewCard3D.taxAndDeliCharge = _this.pt125Init.orderInfo['TOTAL_SEIKYU_TAX'];
            //_this.jasNewCard3D.backUrl =  process.env.VUE_APP_API_URL + _this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_JCS_3D_POST_BACK;
            _this.jasNewCard3D.backUrl = _this.pt125Init.back3DUrl;
            _this.jasNewCard3D.resultUrl = "";
            _this.jasNewCard3D.optionalAreaName1 = "coNo";
            _this.jasNewCard3D.optionalAreaValue1 = _this.pt125Init.coNo;
            _this.jasNewCard3D.optionalAreaName2 = "kessaiCd";
            _this.jasNewCard3D.optionalAreaValue2 = _this.pt125Init.kessaiCd;
            _this.jasNewCard3D.optionalAreaName3 = "apiType";
            _this.jasNewCard3D.optionalAreaValue3 = apiType;
            _this.jasNewCard3D.optionalAreaName4 = "pageNo";
            _this.jasNewCard3D.optionalAreaValue4 = _this.curPage + "?pageNo=" + this.currPageNo;

            if (apiType == '2') {
                _this.jasNewCard3D.optionalAreaName5 = "securityCode";
                _this.jasNewCard3D.optionalAreaValue5 = _this.securityCodeJas();
                _this.jasNewCard3D.optionalAreaName6 = "cardPayCnt";
                _this.jasNewCard3D.optionalAreaValue6 = _this.cardPayCntJas();
                _this.jasNewCard3D.optionalAreaName7 = "bunkatuKaisu";
                _this.jasNewCard3D.optionalAreaValue7 = _this.bunkatuKaisuJas();
                _this.jasNewCard3D.optionalAreaName8 = "cardFlg";
                _this.jasNewCard3D.optionalAreaValue8 = _this.pt125ReqModel.cardFlg;
                _this.jasNewCard3D.optionalAreaName9 = "cardSaveFlg";
                _this.jasNewCard3D.optionalAreaValue9 = _this.pt125ReqModel.cardSaveFlg;
                _this.jasNewCardTaking.optionalAreaName10 = "expiryDate";
                _this.jasNewCardTaking.optionalAreaValue10 = _this.expiryDateJas();
            } else {
                _this.jasNewCard3D.optionalAreaName5 = "securityCode";
                _this.jasNewCard3D.optionalAreaValue5 = _this.jasApiResult.securityCode;
                _this.jasNewCard3D.optionalAreaName6 = "cardPayCnt";
                _this.jasNewCard3D.optionalAreaValue6 = _this.jasApiResult.cardPayCnt;
                _this.jasNewCard3D.optionalAreaName7 = "bunkatuKaisu";
                _this.jasNewCard3D.optionalAreaValue7 = _this.jasApiResult.bunkatuKaisu;
                _this.jasNewCard3D.optionalAreaName8 = "cardFlg";
                _this.jasNewCard3D.optionalAreaValue8 = _this.jasApiResult.cardFlg;
                _this.jasNewCard3D.optionalAreaName9 = "cardSaveFlg";
                _this.jasNewCard3D.optionalAreaValue9 = _this.jasApiResult.cardSaveFlg;
                _this.jasNewCard3D.optionalAreaName10 = "expiryDate";
                _this.jasNewCard3D.optionalAreaValue10 = _this.jasApiResult.optionalareaValue10;
            }

            _this.jasNewCard3D.shopID = _this.pt125Init.bgShopId;
            _this.jasNewCard3D.accountMethod = '';
            _this.jasNewCard3D.msgDigest = "";
            _this.jasNewCard3D.teikiFlg = _this.pt125Init.teikiFlg;
            if (_this.jasNewCard3D.optionalAreaValue6 == '61') {
                _this.jasNewCard3D.teikiFlg = 0;
            }

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_NEW_CARD_INFO_3D_MSGDIGEST, _this.jasNewCard3D).then(function (res) {
                _this.jasNewCard3D = res.data;
                _this.$refs.formJas3D.msgDigest.value = _this.jasNewCard3D.msgDigest;

                _this.$nextTick(() => {
                    _this.$refs.formJas3D.submit();
                });

            }).catch(function (error) {
                _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                _this.isModalShow = true;
                _this.isButtonCancel = false;
                _this.is3DLoding = false;
                EventBus.$on('evtClickOk', function () {
                    common.errorAPI(error);
                });
            }).finally(function () {
            });
        },

        /*
        * 3D都度購入(オーソリ)機能
        */
        doJacCardInfoOsori: function (apiType) {
            let _this = this;
            let tourokuKbn = "";
            _this.is3DLoding = true;
            //【新規会員・登録なし】
            if (apiType == '0') {
                tourokuKbn = "k";

                //【新規会員・登録あり】
            } else if (apiType == '1') {
                tourokuKbn = "n";

                //【既存会員・登録済み】 
            } else if (apiType == '2') {
                tourokuKbn = "W";
            }

            _this.jasNewCardOsori.memberType = apiType;
            _this.jasNewCardOsori.tourokuKbn = tourokuKbn;
            _this.jasNewCardOsori.merchantId = _this.jasApiResult.merchantId;
            _this.jasNewCardOsori.dbKey1 = _this.jasApiResult.dbKey1;
            _this.jasNewCardOsori.amount = _this.pt125Init.seikyuuKin;
            _this.jasNewCardOsori.taxAndDeliCharge = "";
            //_this.jasNewCardOsori.backUrl = process.env.VUE_APP_API_URL + _this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_JCS_3D_POST_BACK;
            _this.jasNewCardOsori.backUrl = _this.pt125Init.back3DUrl;
            _this.jasNewCardOsori.orderNum = _this.jasApiResult.orderNum;
            _this.jasNewCardOsori.cardPassword = _this.jasApiResult.cardPassword;
            _this.jasNewCardOsori.securityCode = _this.jasApiResult.securityCode;
            _this.jasNewCardOsori.resultUrl = "";

            _this.jasNewCardOsori.optionalAreaName1 = "coNo";
            _this.jasNewCardOsori.optionalAreaValue1 = _this.pt125Init.coNo;
            _this.jasNewCardOsori.optionalAreaName2 = "kessaiCd";
            _this.jasNewCardOsori.optionalAreaValue2 = _this.pt125Init.kessaiCd;
            _this.jasNewCardOsori.optionalAreaName3 = "apiType";
            _this.jasNewCardOsori.optionalAreaValue3 = apiType;
            _this.jasNewCardOsori.optionalAreaName4 = "pageNo";
            _this.jasNewCardOsori.optionalAreaValue4 = _this.curPage + "?pageNo=" + this.currPageNo;

            _this.jasNewCardOsori.optionalAreaName5 = "securityCode";
            _this.jasNewCardOsori.optionalAreaValue5 = _this.jasApiResult.securityCode;
            _this.jasNewCardOsori.optionalAreaName6 = "cardPayCnt";
            _this.jasNewCardOsori.optionalAreaValue6 = _this.jasApiResult.cardPayCnt;
            _this.jasNewCardOsori.optionalAreaName7 = "bunkatuKaisu";
            _this.jasNewCardOsori.optionalAreaValue7 = _this.jasApiResult.bunkatuKaisu;
            _this.jasNewCardOsori.optionalAreaName8 = "cardFlg";
            _this.jasNewCardOsori.optionalAreaValue8 = _this.jasApiResult.cardFlg;
            _this.jasNewCardOsori.optionalAreaName9 = "cardSaveFlg";
            _this.jasNewCardOsori.optionalAreaValue9 = _this.jasApiResult.cardSaveFlg;
            _this.jasNewCardOsori.optionalAreaName10 = "expiryDate";
            _this.jasNewCardOsori.optionalAreaValue10 = _this.jasApiResult.optionalareaValue10;

            _this.jasNewCardOsori.msgVerNum = _this.jasApiResult.msgverNum;
            _this.jasNewCardOsori.xid = _this.jasApiResult.xID;
            _this.jasNewCardOsori.xStatus = _this.jasApiResult.xStatus;
            _this.jasNewCardOsori.eci = _this.jasApiResult.eci;
            _this.jasNewCardOsori.cavv = _this.jasApiResult.cavv;
            _this.jasNewCardOsori.cavvAlgorithm = _this.jasApiResult.cavvAlgorithm;

            _this.jasNewCardOsori.paymentMode = _this.jasApiResult.cardPayCnt;
            _this.jasNewCardOsori.paymentCount = _this.jasApiResult.bunkatuKaisu;
            _this.jasNewCardOsori.initialAmount = "";
            _this.jasNewCardOsori.bonusMonth = "";
            _this.jasNewCardOsori.bonusAmount = "";
            _this.jasNewCardOsori.bonusCount = "";
            _this.jasNewCardOsori.msgDigest = "";

            //【新規会員・登録なし】【新規会員・登録あり】
            if (apiType == '0' || apiType == '1') {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_NEW_CARD_INFO_OSORI_MSGDIGEST, _this.jasNewCardOsori).then(function (res) {
                    let msgDigest = res.data;
                    _this.jasNewCardOsori.msgDigest = msgDigest;
                    _this.$refs.formJasOsori.msgDigest.value = _this.jasNewCardOsori.msgDigest;

                    //post
                    _this.$refs.formJasOsori.submit();
                }).catch(function (error) {
                    _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                    _this.isModalShow = true;
                    _this.isButtonCancel = false;
                    _this.is3DLoding = false;
                    EventBus.$on('evtClickOk', function () {
                        common.errorAPI(error);
                    });
                }).finally(function () {
                });

                //【既存会員・登録済み】 
            } else if (apiType == '2') {
                _this.orderSuccJas3D(_this.jasApiResult);
            }
        },
        /*
        * JCS会員登録
        */
        doJac: function () {
            let _this = this;

            _this.listMessValid = [];
            if (!_this.pan) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            } else if (_this.pan.length < 14) {
                // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
            }
            if (!_this.expiryDate) {
                // カード有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            } else if (_this.expiryDate.length < 4) {
                // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
            }
            if (_this.pt125Init.securityCodeUseFlg) {
                if (!_this.pt125ReqModel.securityCode) {
                    // セキュリティコードを入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            if (_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                return;
            }
            _this.$refs.form.submit();

            _this.clearForm();

            var startTime = new Date().getTime();
            var waitTime = parseInt(_this.pt125Init.jcsWaitTime, 10);
            _this.timer = setInterval(function () {
                if ((new Date().getTime() - startTime) > (waitTime * 1000)) {
                    clearInterval(_this.timer);
                    _this.doConfirm('');
                } else {
                    let resp = _this.$refs['dummyframe'].contentWindow.document.body.innerHTML;
                    if (resp && resp.indexOf('bgErrCode') !== -1) {
                        clearInterval(_this.timer);
                        _this.doConfirm(resp);
                    }
                }

            }, 1000);
        },
        doConfirm(resp) {
            let _this = this;
            if (resp.indexOf(_this.pt125Init.orderNum) !== -1 && resp.indexOf('OLM-IT00000000') !== -1) {
                _this.orderSucc();
            } else {
                /*
                * JCS取引状況再確認
                */
                let request = {
                    kessaiCompKbn: _this.pt125Init.kessaiCompKbn,
                    kessaiCd: _this.pt125Init.kessaiCd,
                    orderId: _this.pt125Init.orderNum,
                    kokyakuNo: _this.pt125Init.KokyakuNo
                };
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_REAUTH, request).then(function (response) {
                    if (response.data.status === 'OK') {
                        _this.orderSucc();
                    } else {
                        //_this.$emit("event-loading", false);
                        _this.listMessValid = [];
                        // 決済処理時にエラーが発生しました。入力内容をご確認の上、再度ご入力いただくか、決済方法を変更してください。
                        _this.listMessValid.push(_this.pt125Init.jcsKessaiErrMsg);
                        EventBus.$emit('message', {});
                        common.scrollTop();
                        _this.doInit();
                    }

                }).catch(function (error) {
                    //_this.$emit("event-loading", false);
                    common.errorAPI(error);
                })
            }
        },

        /*
        * JCS 3Dクレジットカード決済成功後の注文情報生成
        */
        orderSuccJas3D(apiInfo) {
            let _this = this;
            _this.is3DLoding = true;

            _this.pt125ReqModel.orderNum = apiInfo.orderNum;
            _this.pt125ReqModel.teikiAddFlg = _this.pt125Init.teikiAddFlg;
            if (apiInfo.apiType == "0") {
                _this.pt125ReqModel.bgDbKey = "";
            } else {
                _this.pt125ReqModel.bgDbKey = apiInfo.dbKey1;
            }

            _this.pt125ReqModel.cardFlg = apiInfo.cardFlg;
            _this.pt125ReqModel.cardSaveFlg = apiInfo.cardSaveFlg;
            if (apiInfo.expiryDate) {
                _this.pt125ReqModel.limitMonth = apiInfo.expiryDate.substring(0, 2);
                _this.pt125ReqModel.limitYear = apiInfo.substring(2);
            }
            if (apiInfo.apiType == "2") {
                _this.pt125ReqModel.cardSecurity = apiInfo.securityCode;
            } else {
                _this.pt125ReqModel.securityCode = apiInfo.securityCode;
            }
            _this.pt125ReqModel.cardPayCnt = apiInfo.cardPayCnt;
            _this.pt125ReqModel.bunkatuKaisu = apiInfo.bunkatuKaisu;
            _this.pt125ReqModel.lastCardPayCnt = apiInfo.cardPayCnt;
            _this.pt125ReqModel.lastBunkatuKaisu = apiInfo.bunkatuKaisu;
            _this.pt125ReqModel.cardFlg = apiInfo.cardFlg;
            _this.pt125ReqModel.cardSaveFlg = apiInfo.cardSaveFlg;

            //【既存会員・登録済み】
            if (apiInfo.apiType == "2") {
                //JACCS 3D 2.0 セキュア フラグ
                _this.pt125ReqModel.jaccs3DVer2Flg = 1;
                _this.pt125ReqModel.msgVerNum = apiInfo.msgverNum;
                _this.pt125ReqModel.xid = apiInfo.xID;
                _this.pt125ReqModel.xStatus = apiInfo.xStatus;
                _this.pt125ReqModel.eci = apiInfo.eci;
                _this.pt125ReqModel.cavv = apiInfo.cavv;
                _this.pt125ReqModel.cavvAlgorithm = apiInfo.cavvAlgorithm;
            } else {
                //【新規会員・登録あり】
                _this.pt125ReqModel.jaccs3DVer2Flg = 0;
                _this.pt125ReqModel.msgVerNum = "";
                _this.pt125ReqModel.xid = "";
                _this.pt125ReqModel.xStatus = "";
                _this.pt125ReqModel.eci = "";
                _this.pt125ReqModel.cavv = "";
                _this.pt125ReqModel.cavvAlgorithm = "";
            }

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_INSERT, _this.pt125ReqModel).then(function (response) {
                if (response.data.respCode == _this.SHOW_ERR_PAGE) {
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError" });
                    _this.is3DLoding = false;
                    return;
                }
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    //_this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function () {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if (response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if (response.data.response) {
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('totalPointKin');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params: { message: message, orderCd: orderCd }, query: { pageNo: 23 } });
                } else {
                    _this.is3DLoding = false;
                    _this.clearForm();
                }

            }).catch(function (error) {
                // eslint-disable-next-line
                _this.is3DLoding = false;
                if (error) {
                    if (error.response) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }

            }).finally(function () {
                //_this.$emit("event-loading", false);
                //_this.is3DLoding = false;
            });
        },
        /*
        * JCSクレジットカード決済成功後の注文情報生成
        */
        orderSucc() {
            let _this = this;
            _this.pt125ReqModel.orderNum = _this.pt125Init.orderNum;
            _this.pt125ReqModel.bgDbKey = _this.pt125Init.newDbKey;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_INSERT, _this.pt125ReqModel).then(function (response) {
                if (response.data.respCode == _this.SHOW_ERR_PAGE) {
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError" });
                    _this.is3DLoding = false
                    return;
                }
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    //_this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function () {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if (response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if (response.data.response) {
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    sessionStorage.removeItem('hopeDayList');
                    //_this.$router.push({ name: _this.SiteConstants.PG010MAIN, params: {message:message, orderCd: orderCd}, query: {pageNo: 23}});
                }

            }).catch(function (error) {
                // eslint-disable-next-line
                _this.is3DLoding = false
                if (error) {
                    if (error.response) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.PT125_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }

            }).finally(function () {
                //_this.$emit("event-loading", false);
            });
        },
        /*
        *SMBCトークン取得
        */
        doSmbc: function () {
            var _this = this;
            var cardno;
            var cardFlg = _this.pt125ReqModel.cardFlg;
            // トークン取得のURL
            var apiUrl = _this.pt125Init.tokenUrl;
            // 契約コード
            var shopId = _this.pt125Init.shopId;
            // 収納企業コード
            var syunoCoCd = _this.pt125Init.confText1;
            // トークン変換キー
            var apiPass2 = _this.pt125Init.apiPass2;
            // 発行されたトークン
            var token;
            // エラーメッセージ
            var errMsg;
            // レスポンス
            var resp;
            // カード番号をまとめてセット
            if (_this.pt125Init.creditInpNumOption == 1) {
                cardno = this.pt125ReqModel.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ', '');
                }
            } else {
                cardno = this.pt125ReqModel.cardNoDisp1 + this.pt125ReqModel.cardNoDisp2 + this.pt125ReqModel.cardNoDisp3 + this.pt125ReqModel.cardNoDisp4;
            }
            document.getElementById('cardNoDisp').value = cardno;

            // 前回カードの場合
            if (cardFlg == '1') {
                _this.pt125ReqModel.token = "dummy";
                _this.doOrder();
                return true;
            }

            this.$loadScript(apiUrl).then(() => {

                Fstokenizer().setConfig({
                    shop_cd: shopId,
                    syuno_co_cd: syunoCoCd,
                    token: {
                        api_key: apiPass2,
                        mode: 'S',
                        usecvv: true
                    },
                    elems: {
                        card: 'cardNoDisp',
                        yy: 'limitYear',
                        mm: 'limitMonth',
                        cvv: 'cardSecurity',
                        token: 'card_token',
                        error: 'fsjs_error'
                    }
                });
                resp = Fstokenizer().getToken();
                // 結果true
                if (resp) {
                    token = document.getElementById('card_token');
                    _this.pt125ReqModel.token = token.value;
                    _this.doOrder();
                    return true;
                    // 結果false
                } else {
                    errMsg = document.getElementById('fsjs_error');
                    alert(errMsg.textContent);
                    common.scrollTop();
                }
            })
                .catch(function (error) {
                    console.log(error);
                });
        },
        /*
        *EPS イプシロン
        */
        doEps: function () {
            var _this = this;
            var cardno;
            var cardFlg = _this.pt125ReqModel.cardFlg;
            // トークン取得のURL
            var apiUrl = _this.pt125Init.tokenUrl;
            // トークン変換キー
            var publicApiKey = _this.pt125Init.apiPass2;
            // 発行されたトークン
            var token;
            // エラーメッセージ
            var errMsg;
            // レスポンス
            var resp;
            // カード番号をまとめてセット
            if (_this.pt125Init.creditInpNumOption == 1) {
                cardno = this.pt125ReqModel.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ', '');
                }
            } else {
                cardno = this.pt125ReqModel.cardNoDisp1 + this.pt125ReqModel.cardNoDisp2 + this.pt125ReqModel.cardNoDisp3 + this.pt125ReqModel.cardNoDisp4;
            }
            document.getElementById('cardNoDisp').value = cardno;

            // 前回カードの場合
            if (cardFlg == '1') {
                _this.pt125ReqModel.token = "dummy";
                _this.doOrder();
                return true;
            }

            //カード情報
            _this.epsCard.card_no = cardno;
            _this.epsCard.expire = _this.pt125ReqModel.limitYear + _this.pt125ReqModel.limitMonth;
            _this.epsCard.security_code = _this.pt125ReqModel.securityCode;
            _this.epsCard.holder_name = _this.pt125ReqModel.cardNameNamae + _this.pt125ReqModel.cardNameMyouji;
            if (_this.pt125Init.cardNameOption == 1) {
                _this.epsCard.holder_name = _this.pt125ReqModel.cardNameNamae + _this.pt125ReqModel.cardNameMyouji;
            } else {
                _this.epsCard.holder_name = _this.pt125ReqModel.cardUserNm;
            }
            //axiosでリクエストデータ送信（①fincode決済登録呼び出しAPI）
            let request = { ajaxKbn: "1", kessaiCd: _this.pt125ReqModel.kessaiCd, amount: _this.pt125Init.seikyuKin };
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_AJAX, request
            ).then(function (response) {

                //決済登録APIのレスポンスを設定
                //_this.epsOsori.epsId = response.data.epsId;
                //_this.epsOsori.epsAccessId = response.data.epsAccessId;

                _this.pt125ReqModel.epsId = response.data.epsId;
                _this.pt125ReqModel.epsAccessId = response.data.epsAccessId;

                _this.$loadScript(apiUrl).then(() => {
                    let fincode = Fincode(publicApiKey);
                    //トークンJS実行
                    fincode.tokens(_this.epsCard,
                        (status, response) => {
                            if (200 === status) {
                                // トークンJS リクエスト正常時の処理

                                //_this.pt125ReqModel.epsId = _this.epsOsori.epsId;
                                //_this.pt125ReqModel.epsAccessId = _this.epsOsori.epsAccessId
                                _this.pt125ReqModel.token = response.list[0].token, //トークンJSで取得した値
                                    _this.pt125ReqModel.epsPayMethod = (_this.isBunkatu(_this.pt125ReqModel.cardPayCnt) ? "2" : "1");//決済実行:支払方法:1 - 一括; 2 - 分割
                                _this.doOrder();
                                return true;
                            } else {
                                // トークンJS リクエストエラー時の処理
                                response.errors.forEach(error => {
                                    alert(error.error_message + "(" + error.error_code + ")");
                                });
                            }
                        },
                        () => {
                            // トークンJS 通信エラー処理。
                            alert("通信エラーが発生しました。しばらく経ってから再度お試しください。");
                        }
                    );
                    // 結果true
                    if (resp) {
                        token = document.getElementById('card_token');
                        _this.pt125ReqModel.token = token.value;
                        _this.doOrder();
                        return true;
                        // 結果false
                    } else {
                        errMsg = document.getElementById('fsjs_error');
                        alert(errMsg.textContent);
                        common.scrollTop();
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                        if (error != null && error != undefined) {
                            if (error.response != null && error.response != undefined) {
                                if (406 == error.response.status) {
                                    var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                                    if (resultValid) {
                                        _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                        _this.listMessValid = resultValid.msgList;
                                        _this.mapMessValid = resultValid.mapMsg;
                                    }
                                    common.scrollTop();
                                } else {
                                    common.errorAPI(error);
                                }
                            }
                        }
                    });


            }).catch(function (error) {
                _this.is3DLoding = false;
                if (error != null && error != undefined) {
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
            }).finally(function () {
                //_this.$emit("event-loading", false);
            });

        },
        /*
        * GMOトークン取得
        */
        doPurchase: function () {
            var _this = this;
            var cardFlg = _this.pt125ReqModel.cardFlg;
            //var cardNoDisp = _this.pt125Init.cardNoDisp;
            var cardno, expire, securitycode, holdername, tokennumber;
            // 前回カードの場合
            if (cardFlg == '1') {
                _this.pt125ReqModel.token = "dummy";
                _this.doOrder();
                return true;
            }
            if (_this.pt125Init.creditInpNumOption == 1) {
                cardno = this.pt125ReqModel.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ', '');
                }
            } else {
                cardno = this.pt125ReqModel.cardNoDisp1 + this.pt125ReqModel.cardNoDisp2 + this.pt125ReqModel.cardNoDisp3 + this.pt125ReqModel.cardNoDisp4;
            }
            expire = this.pt125ReqModel.limitYear + this.pt125ReqModel.limitMonth;
            securitycode = this.pt125ReqModel.securityCode;
            holdername = this.pt125ReqModel.cardUserNm;
            if (_this.pt125Init.cardNameOption == 1) {
                holdername = this.pt125ReqModel.cardNameNamae + ' ' + this.pt125ReqModel.cardNameMyouji;
            }
            // 取得したいトークンの数
            tokennumber = '2';
            // トークン取得のURL
            var apiUrl = this.pt125Init.tokenUrl;
            //var shopId = this.pt125Init.shopId;
            this.$loadScript(apiUrl).then(() => {
                Multipayment.init(this.pt125Init.shopId);
                Multipayment.getToken(
                    {
                        cardno: cardno,
                        expire: expire,
                        securitycode: securitycode,
                        holdername: holdername,
                        tokennumber: tokennumber
                    },
                    function (response) {
                        var errCode = response.resultCode;
                        if (errCode != '000') {
                            if (errCode == '100') {
                                alert('カード番号は必須です。');
                            } else if (errCode == '101') {
                                alert('カード番号の値が不正です。');
                            } else if (errCode == '102') {
                                alert('カード番号の桁数に誤りがあります。');
                            } else if (errCode == '110') {
                                alert('有効期限は必須です。');
                            } else if (errCode == '111') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '112') {
                                alert('有効期限の桁数に誤りがあります。');
                            } else if (errCode == '113') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '121') {
                                alert('セキュリティコードの値が不正です。');
                            } else if (errCode == '122') {
                                alert('セキュリティコードの桁数に誤りがあります。');
                            } else if (errCode == '131') {
                                alert('名義人の値が不正です。');
                            } else if (errCode == '132') {
                                alert('名義人の桁数に誤りがあります。');
                            } else {
                                alert('内部処理エラーが発生しました。');
                            }
                        } else {
                            for (var token = 0; token < response.tokenObject.token.length; token++) {
                                if (token == 0) {
                                    _this.pt125ReqModel.token = response.tokenObject.token[token];
                                } else {
                                    _this.pt125ReqModel.token = _this.pt125ReqModel.token + "," + response.tokenObject.token[token];
                                }
                            }
                            // 注文確定処理
                            _this.doOrder();
                            return true;
                        }
                    }
                );
            })
                .catch(function (error) {
                    console.log(error);
                });
        },
        /**
         * SBペイメントのトークン取得
         */
        doSbp: function () {
            const _this = this;

            const cardno = _this.pt125Init.creditInpNumOption == 1
                ? _this.pt125ReqModel.cardNoDisp
                : _this.pt125ReqModel.cardNoDisp1
                + _this.pt125ReqModel.cardNoDisp2
                + _this.pt125ReqModel.cardNoDisp3
                + _this.pt125ReqModel.cardNoDisp4;
            const currentYear = new Date().getFullYear().toString();
            const expiration = currentYear.substring(0, 2) + _this.pt125ReqModel.limitYear + _this.pt125ReqModel.limitMonth;

            if (_this.securitySbp3DFlg == 0) {
                // 前回カードの場合
                const cardFlg = _this.pt125ReqModel.cardFlg;
                if (cardFlg == '1') {
                    _this.doOrder();
                    return true;
                }
                const apiUrl = _this.pt125Init.tokenUrl;
                _this.$loadScript(apiUrl).then(() => {
                    com_sbps_system.generateToken({
                        merchantId: _this.pt125Init.confText1,
                        serviceId: _this.pt125Init.confText2,
                        ccNumber: cardno ? cardno.replaceAll(' ', '') : '',
                        ccExpiration: expiration,
                        securityCode: _this.pt125ReqModel.securityCode,
                    }, (response) => {
                        if (response.errorCode) {
                            const itemCode = response.errorCode.substring(2);
                            if (itemCode === '003') {
                                alert('クレジット番号に誤りがあります。');
                            } else if (itemCode === '004') {
                                alert('クレジット有効期限に誤りがあります。');
                            } else if (itemCode === '005') {
                                alert('セキュリティコードに誤りがあります。');
                            } else {
                                alert('内部処理エラーが発生しました。');
                            }
                            return false;
                        }
                        if (response.result === "OK") {
                            _this.pt125ReqModel.token = response.tokenResponse.token;
                            _this.pt125ReqModel.tokenKey = response.tokenResponse.tokenKey;
                            _this.doOrder();
                            return true;
                        } else {
                            alert('トークン取得に失敗しました。');
                        }
                    });
                });

                // SBP 3D 2.0
            } else {
                // 取得
                let shippingPostalCodeParam = "";
                let shippingCityParam = "";
                let shippingAddress1Param = "";
                let shippingAddress2Param = "";
                let shippingAddress3Param = "";
                if (_this.pt125ReqModel.radioGroup == '1') {
                    shippingPostalCodeParam = _this.common.stringNvl(_this.pt125ReqModel.zip).replace("-", "");
                    shippingCityParam = _this.common.stringNvl(_this.pt125ReqModel.kenNm, "");
                    shippingAddress1Param = _this.common.stringNvl(_this.pt125ReqModel.addr1, "").replace(_this.common.stringNvl(_this.pt125ReqModel.kenNm, ""), "");
                    shippingAddress2Param = _this.common.stringNvl(_this.pt125ReqModel.addr2, "");
                    shippingAddress3Param = _this.common.stringNvl(_this.pt125ReqModel.addr3, "");
                } else {
                    shippingPostalCodeParam = _this.common.stringNvl(_this.pt125ReqModel.tdkZip).replace("-", "");
                    shippingCityParam = _this.common.stringNvl(_this.pt125ReqModel.tdkKenNm, "");
                    shippingAddress1Param = _this.common.stringNvl(_this.pt125ReqModel.tdkAddr1, "").replace(_this.common.stringNvl(_this.pt125ReqModel.tdkKenNm, ""), "");
                    shippingAddress2Param = _this.common.stringNvl(_this.pt125ReqModel.tdkAddr2, "");
                    shippingAddress3Param = _this.common.stringNvl(_this.pt125ReqModel.tdkAddr3, "");
                }
                const tds2InfoTokenUrl = _this.pt125Init.tds2TokenUrl;
                _this.$loadScript(tds2InfoTokenUrl).then(() => {
                    com_sbps_system_tds2.generateToken({
                        merchantId: _this.pt125Init.confText1,
                        serviceId: _this.pt125Init.confText2,
                        billingLastName: _this.pt125ReqModel.cardNameMyouji,
                        billingFirstName: _this.pt125ReqModel.cardNameNamae,
                        billingPostalCode: _this.common.stringNvl(_this.pt125ReqModel.zip).replace("-", ""),
                        billingCity: _this.common.stringNvl(_this.pt125ReqModel.kenNm, ""),
                        billingAddress1: _this.common.stringNvl(_this.pt125ReqModel.addr1, "").replace(_this.common.stringNvl(_this.pt125ReqModel.kenNm, ""), ""),
                        billingAddress2: _this.common.stringNvl(_this.pt125ReqModel.addr2, ""),
                        billingAddress3: _this.common.stringNvl(_this.pt125ReqModel.addr3, ""),
                        billingPhone: _this.common.stringNvl(_this.pt125ReqModel.tel1, ""),
                        workPhone: "",
                        shippingPostalCode: shippingPostalCodeParam,
                        shippingCity: shippingCityParam,
                        shippingAddress1: shippingAddress1Param,
                        shippingAddress2: shippingAddress2Param,
                        shippingAddress3: shippingAddress3Param,
                        email: _this.common.stringNvl(_this.pt125ReqModel.mail, "")
                    }, (tds2Response) => {
                        if (tds2Response.result === "NG") {
                            if (tds2Response.errorCode) {
                                const tds2ItemCode = tds2Response.errorCode.substring(2);
                                if (tds2ItemCode === '003') {
                                    //Last name of billing destination
                                    alert('カードの名義人に誤りがあります。');
                                } else if (tds2ItemCode === '004') {
                                    //First name of billing destination
                                    alert('カードの名義人に誤りがあります。');
                                } else if (tds2ItemCode === '005') {
                                    //Billing postal code
                                    alert('請求者の郵便番号に誤りがあります。');
                                } else if (tds2ItemCode === '006') {
                                    //Billing prefecture
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '007') {
                                    //Billing city/town
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '008') {
                                    //Billing street/number
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '009') {
                                    //Billing building name
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '010') {
                                    //Billing phone number
                                    alert('請求者の電話番号に誤りがあります。');
                                } else if (tds2ItemCode === '011') {
                                    //Contact phone number
                                    alert('請求者の電話番号に誤りがあります。');
                                } else if (tds2ItemCode === '012') {
                                    //Delivery postal code
                                    alert('お届先の郵便番号に誤りがあります。');
                                } else if (tds2ItemCode === '013') {
                                    //Delivery prefecture
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '014') {
                                    //Delivery city/town
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '015') {
                                    //Delivery street/number
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '016') {
                                    //Delivery building name
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '017') {
                                    //Email address
                                    alert('請求者のメールアドレスに誤りがあります。');
                                } else {
                                    alert('内部処理エラーが発生しました。');
                                }
                            }
                            return false;
                        }

                        if (tds2Response.result === "OK") {
                            _this.securitySbp3DFlg = 1;
                            _this.pt125ReqModel.tds2InfoToken = tds2Response.tokenResponse.tds2infoToken;
                            _this.pt125ReqModel.tds2InfoTokenKey = tds2Response.tokenResponse.tds2infoTokenKey;

                            if ((_this.pt125ReqModel.cardFlg == undefined) || (_this.pt125ReqModel.cardFlg == 0) || (_this.pt125ReqModel.cardFlg == '0')) {
                                const apiUrl = _this.pt125Init.tokenUrl;
                                _this.$loadScript(apiUrl).then(() => {
                                    com_sbps_system.generateToken({
                                        merchantId: _this.pt125Init.confText1,
                                        serviceId: _this.pt125Init.confText2,
                                        ccNumber: cardno ? cardno.replaceAll(' ', '') : '',
                                        ccExpiration: expiration,
                                        securityCode: _this.pt125ReqModel.securityCode,
                                    }, (response) => {

                                        if (response.errorCode) {
                                            const itemCode = response.errorCode.substring(2);
                                            if (itemCode === '003') {
                                                alert('クレジット番号に誤りがあります。');
                                            } else if (itemCode === '004') {
                                                alert('クレジット有効期限に誤りがあります。');
                                            } else if (itemCode === '005') {
                                                alert('セキュリティコードに誤りがあります。');
                                            } else {
                                                alert('内部処理エラーが発生しました。');
                                            }
                                            return false;
                                        }
                                        if (response.result === "OK") {
                                            _this.pt125ReqModel.token = response.tokenResponse.token;
                                            _this.pt125ReqModel.tokenKey = response.tokenResponse.tokenKey;

                                            _this.doOrder();
                                            return true;
                                        } else {
                                            alert('トークン取得に失敗しました。');
                                        }
                                    });
                                });
                            } else {
                                _this.doOrder();
                                return true;
                            }

                            return true;
                        } else {
                            alert('カード利用者決済情報トークン取得に失敗しました。');
                            return false;
                        }
                    });
                });
            }
        },
        /*
        *ペイジェントのトークン取得
        */
        doPayG: function () {
            var _this = this;
            var tokenUrl = _this.pt125Init.tokenUrl;
            // マーチャントID
            var machantoId = _this.pt125Init.confText1;
            // トークン生成鍵
            var tokunSeiseikagi = _this.pt125Init.apiPass2;
            var cardno = "";

            if (_this.pt125Init.creditInpNumOption == 1) {
                cardno = this.pt125ReqModel.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ', '');
                }
            } else {
                cardno = this.pt125ReqModel.cardNoDisp1 + this.pt125ReqModel.cardNoDisp2 + this.pt125ReqModel.cardNoDisp3 + this.pt125ReqModel.cardNoDisp4;
            }
            var holdername = this.pt125ReqModel.cardUserNm;
            if (_this.pt125Init.cardNameOption == 1) {
                holdername = this.pt125ReqModel.cardNameNamae + ' ' + this.pt125ReqModel.cardNameMyouji;
            }
            this.$loadScript(tokenUrl).then(() => {
                var paygentToken = new PaygentToken();
                paygentToken.createToken(
                    machantoId, //マーチャントID
                    tokunSeiseikagi, //トークン生成鍵
                    {
                        card_number: cardno, //クレジットカード番号
                        expire_year: this.pt125ReqModel.limitYear, //有効期限-YY
                        expire_month: this.pt125ReqModel.limitMonth, //有効期限-MM
                        cvc: this.pt125ReqModel.cardSecurity, //セキュリティーコード
                        name: holdername //カード名義
                    }, function (response) {
                        console.log(response);
                        //正常終了
                        if (response.result == '0000') {
                            //トークン
                            _this.pt125ReqModel.token = response.tokenizedCardObject.token;
                            _this.doOrder();
                            //エラー
                        } else {
                            if (response.result == '1100') {
                                alert('マーチャントID - 必須エラー');
                            } else if (response.result == '1200') {
                                alert('トークン生成公開鍵 - 必須エラー');
                            } else if (response.result == '1200') {
                                alert('トークン生成公開鍵 - 必須エラー');
                            } else if (response.result == '1201') {
                                alert('トークン生成公開鍵 - 不正エラー');
                            } else if (response.result == '1300') {
                                alert('カード番号 - 必須チェックエラー');
                            } else if (response.result == '1301') {
                                alert('カード番号 - 書式チェックエラー');
                            } else if (response.result == '1400') {
                                alert('有効期限(年) - 必須チェックエラー');
                            } else if (response.result == '1401') {
                                alert('有効期限(年) - 書式チェックエラー');
                            } else if (response.result == '1500') {
                                alert('有効期限(月) - 必須チェックエラー');
                            } else if (response.result == '1501') {
                                alert('有効期限(月) - 書式チェックエラー');
                            } else if (response.result == '1502') {
                                alert('有効期限(年月)が不正です。');
                            } else if (response.result == '1600') {
                                alert('セキュリティコード - 書式チェックエラー');
                            } else if (response.result == '1601') {
                                alert('セキュリティコード - 必須エラー（セキュリティコードトークンの場合）');
                            } else if (response.result == '1700') {
                                alert('カード名義 - 書式チェックエラー');
                            } else if (response.result == '7000') {
                                alert('非対応のブラウザです。');
                            } else if (response.result == '7001') {
                                alert('ペイジェントとの通信に失敗しました。');
                            } else if (response.result == '8000') {
                                alert('システムメンテナンス中です。');
                            } else if (response.result == '9000') {
                                alert('ペイジェント決済システム内部エラー');
                            }
                        }

                    }
                );
            })
                .catch(function (error) {
                    console.log(error);
                });
        },
        /*
        * フォームをクリアする
        */
        clearForm() {
            // カード番号
            this.pt125ReqModel.cardNoDisp = "";
            this.pt125ReqModel.cardNoDisp1 = "";
            this.pt125ReqModel.cardNoDisp2 = "";
            this.pt125ReqModel.cardNoDisp3 = "";
            this.pt125ReqModel.cardNoDisp4 = "";
            // セキュリティコード
            this.pt125ReqModel.cardSecurity = "";
            this.pt125ReqModel.securityCode = "";
            // 名義人
            this.pt125ReqModel.cardNameMyouji = "";
            this.pt125ReqModel.cardNameNamae = "";
            this.pt125ReqModel.cardUserNm = "";
            // 有効期限
            this.pt125ReqModel.limitYear = "";
            this.pt125ReqModel.limitMonth = "";
        },
        doJac3DCheck: function () {
            let _this = this;

            _this.listMessValid = [];
            if (!_this.pan) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            } else if (_this.pan.length < 14) {
                // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
            }
            if (!_this.expiryDate) {
                // カード有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            } else if (_this.expiryDate.length < 4) {
                // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
            }
            if (_this.pt125Init.securityCodeUseFlg) {
                if (!_this.pt125ReqModel.securityCode) {
                    // セキュリティコードを入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            if (_this.listMessValid.length > 0) {
                _this.is3DLoding = false;
                EventBus.$emit('message', {});
                common.scrollTop();
                return true;
            }

            return false;
        },
        /**
         * 注文作成を行う
         */
        doOrder: function () {
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];

            if (_this.securitySbp3DFlg == 1) {
                _this.pt125ReqModel.sbp3DVerFlg = _this.securitySbp3DFlg;
                _this.pt125ReqModel.sbp3DVerBackUrl = window.location.origin + window.location.pathname;// + "?pageNo=" +  this.currPageNo;
            } else {
                _this.pt125ReqModel.sbp3DVerFlg = 0;
                _this.pt125ReqModel.sbp3DVerBackUrl = "";
            }

            common.clearMessageEcSite(_this.listIdErr, _this.PT125_PART);
            _this.$emit("event-loading", true);
            //注文作成
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_INSERT, _this.pt125ReqModel).then(function (response) {
                _this.$emit("event-loading", false);
                if (response.data.respCode == _this.SHOW_ERR_PAGE) {
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError" });
                    _this.is3DLoding = false
                    return;
                }
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function () {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if (response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if (response.data.response != null) {
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                        if (_this.securityGmo3DFlg == 1) {
                            _this.resGmoVer2ACS = response.data.response.resGmoVer2ACS;
                            _this.resGmoVer2RedirectUrl = response.data.response.resGmoVer2RedirectUrl;
                            if (_this.resGmoVer2ACS == '2') {
                                window.location.href = _this.resGmoVer2RedirectUrl;
                                return;
                            }
                        }

                        if (_this.securitySbp3DFlg == 1) {
                            //apiResult apiErrCode apiRequestId tdsAuthenticationId redirectUrl 
                            let apiRequestId = response.data.response.apiRequestId;

                            if (apiRequestId == 'TA02-00101-101') {
                                let redirectUrl = '';
                                if (response.data.response.redirectUrl) {
                                    redirectUrl = response.data.response.redirectUrl;
                                }

                                if (response.data.response.apiResult == "OK") {
                                    sessionStorage['sbpTdsAuthenticationId'] = response.data.response.tdsAuthenticationId;
                                    sessionStorage['sbp_ccdd'] = response.data.response.sbp_cust_cd;
                                    sessionStorage['sbp_pt125ReqModel'] = JSON.stringify(_this.pt125ReqModel);

                                    if (redirectUrl) {
                                        window.location.href = redirectUrl;
                                    }
                                } else {
                                    sessionStorage['tdsAuthenticationId'] = '';
                                    console.log(response.data.response.apiErrCode);
                                }
                                _this.$emit("event-loading", false);
                                return;
                            }
                        }
                    }
                    //sessionStorage.removeItem('hopeDayList');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params: { message: message, orderCd: orderCd }, query: { pageNo: 23 } });
                } else {
                    if (_this.securitySbp3DFlg == 1) {
                        _this.sbpTdsAuthenticationId = "";
                        _this.pt125ReqModel.tdsAuthenticationId = "";
                    }
                }
            }).catch(function (error) {
                _this.$emit("event-loading", false);
                if (_this.securitySbp3DFlg == 1) {
                    _this.sbpTdsAuthenticationId = "";
                    _this.pt125ReqModel.tdsAuthenticationId = "";
                }
                if (error != null && error != undefined) {
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.PT125_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        reload: function () {
            sessionStorage.currentURL = this.$route.fullPath;
            if (sessionStorage.currentURL == this.currentURL) {
                this.$router.go(0);
            }
        },

        /* 
        * 匹数から数量を算出する
        */
        getItemQty: async function (qty, syukkaNum) {
            var _this = this;
            if (_this.pt125Init.auraOpt == 1) {
                _this.pt125ReqModel.buyCount = (await commonEc.getItemQty(qty, syukkaNum)) % 1 !== 0 ? _this.pt125ReqModel.buyCount : await commonEc.getItemQty(qty, syukkaNum);
            }
        },
        /* 
        * 数量から匹数を算出する
        */
        getAnimalQty: async function (qty, syukkaNum) {
            var _this = this;
            if (_this.pt125Init.auraOpt == 1) {
                _this.pt125ReqModel.animalQty = await commonEc.getAnimalQty(qty, syukkaNum);
            }
        },
        /*
        * カート追加テキストを使用するカート追加区分かチェック
        */
        doChkCartAddTxt: function () {
            var _this = this;
            if (_this.pt125Init.productInfo.CART_ADD_KBN == '5' || _this.pt125Init.productInfo.CART_ADD_KBN == '6') {
                return true;
            }
            return false;
        },

        /*
        * 商品規格書のダウンロード
        */
        itemStdListDl: function (sItemNo, printYoutoKbn) {
            var _this = this;
            // ログインしていないときはログインを促す
            if (!_this.pt125Init.loginKbn) {
                _this.msgConfirm = _this.$i18n.t('pt125.messages.itemStdDlAlert');
                _this.isModalShow = true;
                _this.isButtonCancel = true;
                _this.actionFlg = -2;
                return;
            }

            // ログインしているときは商品規格書をダウンロード
            _this.isLoading = true;
            _this.printData = {};
            _this.printData.printSItemNo = sItemNo;
            _this.printData.printYoutoKbn = printYoutoKbn;

            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if (appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            if (appPath.startsWith('/')) {
                appPath = appPath.slice(1);
            }
            _this.printData.wfrBasePath = window.location.protocol + "//" + window.location.host + "/" + appPath;

            _this.$emit("event-loading", true);
            axios({ url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT125 + _this.$UrlConstants.DO_PRINT, method: "POST", responseType: "blob", data: _this.printData }).then(function (response) {
                var fileName = "";
                var disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, "");
                    }
                }
                if (/*@cc_on!@*/ false || !!document.documentMode) {
                    window.navigator.msSaveBlob(new Blob([response.data]), fileName);
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                _this.search();
                _this.$emit("event-loading", false);
            }).catch(async function (error) {
                if (error != null && error != undefined) {
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            if (error.request.responseType === "blob") {
                                let responseObj = await error.response.data.text();
                                error.response.data = JSON.parse(responseObj);
                            }
                            var resultValid = common.excuteValidationEcSite(error, 'pt430');
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });
        }
    },
    created() {
        var _this = this;
        const pt125StoreState = _this.$store && _this.$store.state && _this.$store.state.pt125
            ? _this.$store.state.pt125
            : null;

        if (pt125StoreState) {
            if (pt125StoreState.pt125Init && Object.keys(pt125StoreState.pt125Init).length > 0) {
                _this.pt125Init = Object.assign({}, _this.pt125Init, pt125StoreState.pt125Init);
            }
            if (pt125StoreState.pt125ReqModel && Object.keys(pt125StoreState.pt125ReqModel).length > 0) {
                _this.pt125ReqModel = Object.assign({}, _this.pt125ReqModel, pt125StoreState.pt125ReqModel);
            }
        }
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;

        _this.isLp = false;
        var paths = _this.$router.history.current.fullPath.split("/");
        if (paths) {
            if (paths.length >= 3) {
                if (paths[2].toLowerCase() == 'lp') {
                    _this.isLp = true;
                }
            }
        }
        if (Object.keys(paramData).length > 0) {
            _this.pt125ReqModel = Object.assign({}, _this.pt125ReqModel, paramData);
            _this.backPageNo = _this.pt125ReqModel.backPageNo;
            _this.categoryCd = _this.pt125ReqModel.categoryCd;
            _this.ptPageNo = _this.pt125ReqModel.ptPageNo;
            _this.ptPageSize = _this.pt125ReqModel.ptPageSize;
            _this.searchItemNm = _this.pt125ReqModel.searchItemNm;
            _this.itemNmOnly = _this.pt125ReqModel.itemNmOnly;
            _this.priceS = _this.pt125ReqModel.priceS;
            _this.priceE = _this.pt125ReqModel.priceE;
            _this.allergyMaterialKbn = _this.pt125ReqModel.allergyMaterialKbn;
        }

        if (Object.keys(queryData).length > 0) {
            _this.pt125ReqModel = Object.assign({}, _this.pt125ReqModel, queryData);
        }

        //Amazon Pay初期化
        _this.pt125Init.ampPaymentDescriptor = '';
        _this.amazonCheckoutSessionId = '';

        if (_this.$route.query) {
            if (_this.$route.query.action) {
                _this.jasApiSeqNo = _this.$route.query.action;
            }

            if (_this.$route.query.pageNo) {
                _this.currPageNo = _this.$route.query.pageNo;
            }

            if (_this.jasApiSeqNo) {
                _this.is3DLoding = true;
            } else if (_this.$route.query.AccessID) {
                _this.gmo2AuthAccessID = _this.$route.query.AccessID;
                _this.is3DLoding = true;
            } else if (_this.$route.query.sbpEmv3dsStatus) {
                _this.sbpEmv3dsStatus = _this.$route.query.sbpEmv3dsStatus;

                if (_this.sbpEmv3dsStatus == 'ok') {
                    if (sessionStorage['sbpTdsAuthenticationId']) {
                        _this.sbpTdsAuthenticationId = sessionStorage['sbpTdsAuthenticationId'];
                    }
                    sessionStorage.removeItem('sbpTdsAuthenticationId');
                    _this.is3DLoding = true;
                } else {
                    _this.sbpTdsAuthenticationId = '';
                    sessionStorage.removeItem('sbpTdsAuthenticationId');
                    sessionStorage.removeItem('sbp_ccdd');
                    _this.is3DLoding = false;
                }
            } else {
                _this.is3DLoding = false;
            }
            //Amazon Pay
            if (_this.$route.query.amazonCheckoutSessionId) {
                _this.amazonCheckoutSessionId = _this.$route.query.amazonCheckoutSessionId;
            }
        }
    },
    computed: {
        pan: function () {
            var cardNo;
            if (this.pt125Init.creditInpNumOption == 1) {
                cardNo = this.pt125ReqModel.cardNoDisp;
                if (cardNo != undefined) {
                    cardNo = cardNo.replaceAll(' ', '');
                }
                return cardNo;
            } else {
                cardNo = this.pt125ReqModel.cardNoDisp1 + this.pt125ReqModel.cardNoDisp2 + this.pt125ReqModel.cardNoDisp3 + this.pt125ReqModel.cardNoDisp4
                return cardNo;
            }
        },
        expiryDate: function () {
            return this.pt125ReqModel.limitMonth + this.pt125ReqModel.limitYear;
        },
        tourokuKbn: function () {
            return this.pt125ReqModel.cardSaveFlg ? 'i' : '3';
        },
        msgDigest: function () {
            if (this.pt125Init.kessaiCompKbn != 'JCS') return '';

            let tourokuKbn = this.pt125ReqModel.cardSaveFlg ? 'i' : '3';
            let payModel = this.pt125ReqModel.cardPayCnt;
            let payCount = this.pt125ReqModel.bunkatuKaisu;
            let keyAppend = '';
            if (payModel == 61) {
                keyAppend = '_' + payCount;
            }

            return this.pt125Init.msgDigestMap[tourokuKbn + '_' + payModel + keyAppend];
        }

    }
}
</script>
<style scoped>
.matomeLink {
    color: #007bff;
    text-decoration: underline;
    background-color: transparent;
}

#pt120 #readMoreBlock {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    gap: 30px;
}

#pt120 .readMoreInner {
    width: 100%;
    margin: 0 auto;
}

#pt120 .readMoreContainer {
    position: relative;
    height: auto;
    overflow: hidden;
    transition: max-height 0.5s;
}

#pt120 .readMoreBtn {
    display: block;
    margin: 0 auto;
    padding: 8px 20px;
    border: 0;
    color: black !important;
    background-color: transparent;
    cursor: pointer;
    letter-spacing: 0.13px;
}

#pt120 .readMoreBtn:focus {
    outline: 0px !important;
}

#pt120 .readMoreContainer p:last-child {
    margin-bottom: 10px;
}
</style>